webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(66);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(100);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(99);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(277);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(65);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _directives = __webpack_require__(135);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	var _filters = __webpack_require__(136);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _components = __webpack_require__(133);
	
	var _components2 = _interopRequireDefault(_components);
	
	__webpack_require__(230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _keys2.default)(_directives2.default).forEach(function (e) {
	  return _vue2.default.directive(e, _directives2.default[e]);
	});
	(0, _keys2.default)(_filters2.default).forEach(function (e) {
	  return _vue2.default.filter(e, _filters2.default[e]);
	});
	(0, _keys2.default)(_components2.default).forEach(function (e) {
	  return _vue2.default.component(e, _components2.default[e]);
	});
	
	window.__currentApp = initVue();
	
	function initVue() {
	  return new _vue2.default({
	    router: _router2.default,
	    render: function render(h) {
	      return h(_App2.default);
	    }
	  }).$mount('#app');
	}

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(66);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _config = __webpack_require__(134);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cacheHelper = __webpack_require__(33);
	
	var _cacheHelper2 = _interopRequireDefault(_cacheHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    SendGetRequest: function SendGetRequest(url, data, successCallback) {
	        var obj = new XMLHttpRequest();
	        var query = url.indexOf('?') > 0 ? "" : "?";
	        (0, _keys2.default)(data).forEach(function (e) {
	            query += e + "=" + data[e] + "&";
	        });
	        url = url + query;
	        obj.open('GET', url, true);
	        obj.onreadystatechange = function () {
	            if (obj.readyState == 4 && obj.status == 200 || obj.status == 304) {
	                successCallback && successCallback.call(this, obj.responseText);
	            }
	        };
	        obj.send(null);
	    },
	    SendPostRequest: function SendPostRequest(url, data, successCallback) {
	        var query = '';
	        (0, _keys2.default)(data).forEach(function (e) {
	            query += e + "=" + data[e] + "&";
	        });
	        var obj = new XMLHttpRequest();
	        obj.open("POST", url, true);
	        obj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	        obj.onreadystatechange = function () {
	            if (obj.readyState == 4 && (obj.status == 200 || obj.status == 304)) {
	                successCallback.call(this, obj.responseText);
	            }
	        };
	        obj.send(query);
	    },
	    execJsonp: function execJsonp(src) {
	        var script = document.createElement("script");
	        script.setAttribute("type", "text/javascript");
	        script.src = src;
	        document.body.appendChild(script);
	    },
	    trim: function trim(str) {
	        if (str) return str.replace(/\ +/g, '').replace(/[ ]/g, '');
	        return '';
	    },
	    getProtocol: function getProtocol() {
	        return location.protocol == 'http:' ? 'http' : 'https';
	    },
	    toUbb: function toUbb(str) {
	        str = str.replace(/</ig, '&lt;');
	        str = str.replace(/>/ig, '&gt;');
	        str = str.replace(/\n/ig, '<br />');
	        str = str.replace(/\[code\](.+?)\[\/code\]/ig, function ($1, $2) {
	            return phpcode($2);
	        });
	
	        str = str.replace(/\[hr\]/ig, '<hr />');
	        str = str.replace(/\[\/(size|color|font|backcolor)\]/ig, '</font>');
	        str = str.replace(/\[(sub|sup|u|i|strike|b|blockquote|li)\]/ig, '<$1>');
	        str = str.replace(/\[\/(sub|sup|u|i|strike|b|blockquote|li)\]/ig, '</$1>');
	        str = str.replace(/\[\/align\]/ig, '</p>');
	        str = str.replace(/\[(\/)?h([1-6])\]/ig, '<$1h$2>');
	
	        str = str.replace(/\[align=(left|center|right|justify)\]/ig, '<p align="$1">');
	        str = str.replace(/\[size=(\d+?)\]/ig, '<font size="$1">');
	        str = str.replace(/\[color=([^\[\<]+?)\]/ig, '<font color="$1">');
	        str = str.replace(/\[backcolor=([^\[\<]+?)\]/ig, '<font style="background-color:$1">');
	        str = str.replace(/\[font=([^\[\<]+?)\]/ig, '<font face="$1">');
	        str = str.replace(/\[list=(a|A|1)\](.+?)\[\/list\]/ig, '<ol type="$1">$2</ol>');
	        str = str.replace(/\[(\/)?list\]/ig, '<$1ul>');
	
	        str = str.replace(/\[s:(\d+)\]/ig, function ($1, $2) {
	            return smilepath($2);
	        });
	        str = str.replace(/\[img\]([^\[]*)\[\/img\]/ig, '<img src="$1" border="0" />');
	        str = str.replace(/\[url=([^\]]+)\]([^\[]+)\[\/url\]/ig, '<a href="$1">' + '$2' + '</a>');
	        str = str.replace(/\[url\]([^\[]+)\[\/url\]/ig, '<a href="$1">' + '$1' + '</a>');
	        return str;
	    },
	    toHtml: function toHtml(str) {
	        str = str.replace(/<br[^>]*>/ig, '\n');
	        str = str.replace(/<p[^>\/]*\/>/ig, '\n');
	
	        str = str.replace(/\son[\w]{3,16}\s?=\s*([\'\"]).+?\1/ig, '');
	
	        str = str.replace(/<hr[^>]*>/ig, '[hr]');
	        str = str.replace(/<(sub|sup|u|strike|b|i|pre)>/ig, '[$1]');
	        str = str.replace(/<\/(sub|sup|u|strike|b|i|pre)>/ig, '[/$1]');
	        str = str.replace(/<(\/)?strong>/ig, '[$1b]');
	        str = str.replace(/<(\/)?em>/ig, '[$1i]');
	        str = str.replace(/<(\/)?blockquote([^>]*)>/ig, '[$1blockquote]');
	
	        str = str.replace(/<img[^>]*smile=\"(\d+)\"[^>]*>/ig, '[s:$1]');
	        str = str.replace(/<img[^>]*src=[\'\"\s]*([^\s\'\"]+)[^>]*>/ig, '[img]' + '$1' + '[/img]');
	        str = str.replace(/<a[^>]*href=[\'\"\s]*([^\s\'\"]*)[^>]*>(.+?)<\/a>/ig, '[url=$1]' + '$2' + '[/url]');
	
	
	        str = str.replace(/<[^>]*?>/ig, '');
	        str = str.replace(/&amp;/ig, '&');
	        str = str.replace(/&lt;/ig, '<');
	        str = str.replace(/&gt;/ig, '>');
	        return str;
	    },
	    dynamicLoadJs: function dynamicLoadJs(url, callback) {
	        var head = document.getElementsByTagName('head')[0];
	        var script = document.createElement('script');
	        script.type = 'text/javascript';
	        script.src = url;
	        if (typeof callback == 'function') {
	            script.onload = script.onreadystatechange = function () {
	                if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
	                    callback();
	                    script.onload = script.onreadystatechange = null;
	                }
	            };
	        }
	        head.appendChild(script);
	    }
	};

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(7);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(25);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  GetCacheByKey: function GetCacheByKey(key) {
	    var data = localStorage.getItem(key);
	    return data;
	  },
	  SetCacheByKey: function SetCacheByKey(key, data) {
	    if ((typeof data === "undefined" ? "undefined" : (0, _typeof3.default)(data)) === "object") {
	      localStorage.setItem(key, (0, _stringify2.default)(data));
	    } else {
	      localStorage.setItem(key, data);
	    }
	  },
	  RemoveCahceByKey: function RemoveCahceByKey(key) {
	    localStorage.removeItem(key);
	  },
	  ClearCache: function ClearCache() {
	    localStorage.clear();
	  }
	};

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(145);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(24);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.sortDown = sortDown;
	
	var _vue = __webpack_require__(100);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(99);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _cacheHelper = __webpack_require__(33);
	
	var _cacheHelper2 = _interopRequireDefault(_cacheHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allpages = getAllPages();
	function getAllPages() {
	  var files = __webpack_require__(336);
	  var modules = [];
	  var menus = JSON.parse(localStorage.InsertMenus || '[]').map(function (e) {
	    return (0, _assign2.default)(e, JSON.parse(localStorage.getItem(e.menuUrl)));
	  });
	
	  files.keys().forEach(function (key) {
	    var mk = key.replace(/(^\.\/|\.vue$)/g, '');
	    var m = files(key);
	
	    var path = '/' + mk;
	    modules.push({
	      name: mk,
	      path: path,
	      component: m
	    });
	    if (m.meta && m.meta.menuName) {
	      var defMenu = {
	        menuName: m.meta ? m.meta.menuName : mk,
	        menuUrl: path,
	        sort: m.meta.sort || 0,
	        indexHide: m.meta.indexHide === true,
	        navHide: m.meta.navHide === true
	      };
	      var customMenu = (0, _assign2.default)(defMenu, JSON.parse(localStorage.getItem(path)));
	      menus.push(customMenu);
	    }
	  });
	  window.siteMenuItems = sortDown(menus, 'sort');
	  return modules;
	}
	
	function sortDown(items, key) {
	  return sort(items, key);
	  function sort(items, key) {
	    items.forEach(function (item) {
	      if (item.children && item.children.length > 0) {
	        item.children = sort(item.children);
	      }
	    });
	    return items.sort(compareDown(key));
	  }
	  function compareDown(propertyName) {
	    return function (obj1, obj2) {
	      var value1 = Number(obj1[propertyName]) || 0;
	      var value2 = Number(obj2[propertyName]) || 0;
	      return value2 - value1;
	    };
	  }
	}
	_vue2.default.use(_vueRouter2.default);
	var router = new _vueRouter2.default({
	  mode: 'hash',
	  routes: [{ name: 'index', path: '/', redirect: '/home', meta: {} }].concat((0, _toConsumableArray3.default)(allpages), [{ name: '404', path: '*', redirect: '/home' }])
	});
	
	router.beforeEach(function (to, from, next) {
	  var current_page = _cacheHelper2.default.GetCacheByKey('current_page') || '/home';
	  if (to.path == '/home' && from.path == '/' && current_page != '/home') {
	    next(current_page);
	    return;
	  }
	  _cacheHelper2.default.SetCacheByKey('prev_page', from.fullPath || '');
	
	  next();
	});
	
	router.afterEach(function (route) {
	  _cacheHelper2.default.SetCacheByKey('current_page', route.fullPath || '');
	});
	exports.default = router;

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(107)
	
	/* template */
	var __vue_template__ = __webpack_require__(310)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cacheHelper = __webpack_require__(33);
	
	var _cacheHelper2 = _interopRequireDefault(_cacheHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      currentOption: null,
	      menuOptions: []
	    };
	  },
	
	  watch: {
	    $route: function $route(route) {
	      this.currentOption = route.path;
	    }
	  },
	  methods: {
	    changeMenu: function changeMenu(value) {
	      this.$router.push(value);
	    }
	  },
	  created: function created() {
	    var menuItems = window.siteMenuItems.filter(function (e) {
	      return e.navHide !== true;
	    });
	    var self = this;
	    var current_page = _cacheHelper2.default.GetCacheByKey('current_page');
	    self.currentOption = current_page;
	    menuItems.forEach(function (item) {
	      self.menuOptions.push({
	        Text: item.menuName,
	        Value: item.menuUrl
	      });
	    });
	  }
	};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'v-button',
	  props: ['icon'],
	  components: {
	    'v-icon': __webpack_require__(98)
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	  mounted: function mounted() {},
	
	  methods: {
	    clickHandler: function clickHandler() {
	      this.$emit('click');
	    }
	  }
	};

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['value', 'text'],
	  data: function data() {
	    return {
	      selectShow: false,
	      currentValue: this.value
	    };
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    }
	  },
	  created: function created() {},
	
	  methods: {
	    changeCheckd: function changeCheckd() {
	      this.currentValue = !this.currentValue;
	      this.$emit('input', this.currentValue);
	    }
	  }
	};

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['value', 'isTime', 'dateFormat'],
	  data: function data() {
	    return {
	      dateId: 'laydate_' + Date.now(),
	      currentValue: this.value
	    };
	  },
	
	  methods: {
	    changeDate: function changeDate(dateId) {
	      var self = this;
	      layui.laydate({
	        elem: document.getElementById(dateId),
	        istime: self.isTime || false,
	        format: self.dateFormat || 'YYYY-MM-DD',
	        choose: function choose(dates) {
	          self.currentValue = dates;
	        }
	      });
	    }
	  },
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    },
	    currentValue: function currentValue(val) {
	      this.$emit('input', val);
	    }
	  }
	};

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['value', 'options'],
	  data: function data() {
	    return {
	      editorId: 'layeditor_' + Date.now() + Math.floor(Math.random() * 1000),
	      currentValue: this.value,
	      currentIndex: null
	    };
	  },
	  created: function created() {
	    var self = this;
	    var defOptions = {
	      uploadImage: {
	        url: options.editorUploadApi,
	        type: 'get' },
	      height: 200
	    };
	    if (self.options && self.options.height != null) {
	      defOptions.height = self.options.height;
	    }
	    if (self.options && self.options.hideTool != null) {
	      defOptions.hideTool = self.options.hideTool;
	    }
	    if (self.options && self.options.tool != null) {
	      defOptions.tool = defOptions.tool;
	    }
	    if (self.options && self.options.uploadImage != null) {
	      defOptions.uploadImage = defOptions.uploadImage;
	    }
	    self.$nextTick(function () {
	      self.currentIndex = layui.layedit.build(self.editorId, defOptions);
	      setInterval(function () {
	        self.getContent();
	      }, 500);
	    });
	  },
	
	  methods: {
	    getContent: function getContent() {
	      var self = this;
	      var content = layui.layedit.getContent(self.currentIndex);
	      if (self.value != content) {
	        self.$emit('input', layui.layedit.getContent(self.currentIndex));
	      }
	      return content;
	    }
	  }
	};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'v-icon',
	  props: ['icon'],
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["value", "label", "placeholder", "areaClass", "rows"],
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    },
	    currentValue: function currentValue(val) {
	      this.$emit("input", val);
	    }
	  }
	};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(24);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['options'],
	  data: function data() {
	    return {
	      layerId: 'layerId_' + Date.now() + Math.floor(Math.random() * 1000),
	      defOption: {}
	    };
	  },
	  created: function created() {
	    var self = this;
	    self.defOption = {
	      cancel: self.targetEvent('cancelHandler'),
	      end: self.targetEvent('endHandler')
	    };
	    this.$nextTick(function () {
	      var html = document.getElementById(self.layerId).innerHTML;
	      self.defOption.content = html;
	      if (self.options) {
	        (0, _assign2.default)(self.defOption, self.options);
	      }
	      window.layui.layer.open(self.defOption);
	    });
	  },
	
	  methods: {
	    targetEvent: function targetEvent(key) {
	      this.$emit(key);
	    }
	  }
	};

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['show', 'type', 'typeOne'],
	  data: function data() {
	    return {
	      lodingId: null
	    };
	  },
	  created: function created() {},
	
	  watch: {
	    show: function show(val) {
	      var self = this;
	      if (val == true) {
	        self.lodingId = window.layui.layer.load(self.type || 0);
	      } else {
	        window.layui.layer.close(self.lodingId);
	      }
	    }
	  }
	};

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['pageIndex', 'totalPage', 'groups', 'skin'],
	  data: function data() {
	    return {
	      pagerId: 'pagerId' + Date.now() + Math.floor(Math.random() * 1000),
	      cindex: this.pageIndex || 1,
	      cpages: this.totalPage || 1,
	      cgroups: this.groups || 10,
	      cskin: this.skin || '' };
	  },
	  created: function created() {
	    var self = this;
	    this.$nextTick(function () {
	      layui.laypage({
	        cont: self.pagerId,
	        skin: self.cskin,
	        pages: self.cpages,
	        groups: self.cgroups,
	        curr: self.pageIndex,
	        jump: function jump(obj, first) {
	          self.$emit('pageHandler', obj.curr);
	        }
	      });
	    });
	  }
	};

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['value', 'options', 'optionVals'],
	  data: function data() {
	    return {
	      currentValue: {
	        Text: '',
	        Value: null
	      },
	      currentVal: ''
	    };
	  },
	  created: function created() {
	    var self = this;
	    if (self.options != null) {
	      self.options.forEach(function (item) {
	        if (item.Value == self.value) {
	          self.currentValue = {
	            Text: item.Text,
	            Value: item.Value
	          };
	        }
	      });
	    } else if (self.optionVals != null) {
	      self.currentVal = this.value;
	    }
	  },
	
	  methods: {
	    changeRadio: function changeRadio(item) {
	      if (this.options != null) {
	        this.currentValue = {
	          Text: item.Text,
	          Value: item.Value
	        };
	        this.$emit('input', item.Value);
	      } else {
	        this.currentVal = item;
	        this.$emit('input', item);
	      }
	    }
	  }
	};

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['value', 'options', 'hasNull'],
	  data: function data() {
	    return {
	      selectShow: false,
	      currentValue: {
	        Text: '',
	        Value: null
	      },
	      currentOptions: []
	    };
	  },
	
	  watch: {
	    value: {
	      handler: function handler(val) {
	        this.currentValue = this.options.find(function (e) {
	          return e.Value === val;
	        }) || {
	          Text: '',
	          Value: null
	        };
	      },
	
	      immediate: true
	    }
	  },
	  created: function created() {
	    if (this.hasNull) {
	      this.currentOptions.push({ Text: '--------请选择--------', Value: '' });
	    }
	    this.currentOptions = this.currentOptions.concat(this.options);
	  },
	
	  methods: {
	    currentSelect: function currentSelect(item) {
	      var self = this;
	      self.currentValue = item;
	      this.changeSelect();
	      this.$emit('input', item.Value);
	      this.$emit('change', item.Value);
	    },
	    changeSelect: function changeSelect() {
	      this.selectShow = !this.selectShow;
	    }
	  }
	};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['value'],
	  data: function data() {
	    return {
	      selectShow: false,
	      currentValue: this.value
	    };
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    }
	  },
	  created: function created() {},
	
	  methods: {
	    changeSwitch: function changeSwitch() {
	      this.currentValue = !this.currentValue;
	      this.$emit('input', this.currentValue);
	      this.$emit('change', this.currentValue);
	    }
	  }
	};

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['items', 'tabClass'],
	  data: function data() {
	    return {
	      currentTab: this.items[0].Name,
	      defClass: this.tabClass || 'layui-tab-brief'
	    };
	  },
	
	  methods: {
	    current: function current(item) {
	      if (item.Url) {
	        window.open(item.Url);
	        this.currentTab = this.currentTab;
	      } else {
	        this.currentTab = item.Name;
	      }
	      this.$emit('currentHandler', item);
	    }
	  }
	};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["value", "previewPath", "uploadApi", "beforeShow"],
	  data: function data() {
	    return {
	      uploadId: "upload_" + Date.now(),
	      displayImg: this.previewPath
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    layui.upload({
	      url: self.uploadApi,
	      method: "get",
	      success: function success(res) {
	        if (res.Data) {
	          self.displayImg = res.Data.previewPath;
	          self.$emit("input", res.Data.savePath);
	        }
	      },
	      before: function before(res) {
	        if (self.beforeShow) {
	          var reader = new FileReader();
	          reader.readAsDataURL(res.files[0]);
	          reader.onload = function (e) {
	            self.displayImg = e.target.result;
	            self.$emit("before", self.displayImg, res.files);
	          };
	        }
	      }
	    });
	  }
	};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(7);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _cryptoJs = __webpack_require__(39);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	var _common = __webpack_require__(23);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    menuName: "编码/解码",
	    sort: 44
	  },
	  data: function data() {
	    return {
	      tabItems: [{
	        Name: "main",
	        Title: "编码转换"
	      }],
	      model: {
	        beforeTxt: "",
	        afterTxt: "",
	        currentType: ""
	      },
	      codeTypes: ["utf-8", "ascii", "unicode", "url", "base64", "html"]
	    };
	  },
	
	  watch: {
	    $route: "fetchData",
	    "model.afterTxt": "saveData"
	  },
	  created: function created() {
	    this.loadData();
	    this.fetchData();
	  },
	
	  methods: {
	    loadData: function loadData() {
	      this.model = JSON.parse(localStorage.getItem("encode_model") || "null") || this.model;
	    },
	    saveData: function saveData() {
	      localStorage.setItem("encode_model", (0, _stringify2.default)(this.model));
	    },
	    fetchData: function fetchData() {
	      if (!this.model.currentType) {
	        this.model.currentType = this.codeTypes[0];
	      }
	    },
	    currentHandler: function currentHandler(item) {
	      this.model.currentType = item;
	    },
	    encode: function encode(type) {
	      var self = this;
	      var data = {
	        beforeTxt: this.model.beforeTxt || "",
	        afterTxt: ""
	      };
	      switch (type) {
	        case "utf-8":
	          data.afterTxt = data.beforeTxt.replace(/[^\u0000-\u00FF]/g, function ($0) {
	            return escape($0).replace(/(%u)(\w{4})/gi, "&#x$2;");
	          });
	          break;
	        case "ascii":
	          var character = data.beforeTxt;
	          var ascii = "";
	          for (var i = 0; i < character.length; i++) {
	            var code = Number(character[i].charCodeAt(0));
	            var charAscii = code.toString(16);
	            charAscii = new String("0000").substring(charAscii.length, 4) + charAscii;
	            ascii += "\\u" + charAscii;
	          }
	          data.afterTxt = ascii;
	          break;
	        case "unicode":
	          for (var i = 0; i < data.beforeTxt.length; i++) {
	            data.afterTxt = data.afterTxt + "&#" + data.beforeTxt.charCodeAt(i) + ";";
	          }break;
	        case "url":
	          data.afterTxt = encodeURIComponent(data.beforeTxt);
	          break;
	        case "base64":
	          var str = _cryptoJs2.default.enc.Utf8.parse(data.beforeTxt);
	          data.afterTxt = _cryptoJs2.default.enc.Base64.stringify(str);
	          break;
	        case "html":
	          data.afterTxt = _common2.default.toUbb(data.beforeTxt);
	          break;
	        default:
	          break;
	      }
	      self.model.afterTxt = data.afterTxt;
	    },
	    decode: function decode(type) {
	      var self = this;
	      var data = {
	        beforeTxt: "",
	        afterTxt: this.model.afterTxt || ""
	      };
	      switch (type) {
	        case "utf-8":
	          data.beforeTxt = unescape(data.afterTxt.replace(/&#x/g, "%u").replace(/;/g, ""));
	          break;
	        case "ascii":
	          var character = data.afterTxt.split("\\u");
	          var native1 = character[0];
	          for (var i = 1; i < character.length; i++) {
	            var code = character[i];
	            native1 += String.fromCharCode(parseInt("0x" + code.substring(0, 4)));
	            if (code.length > 4) {
	              native1 += code.substring(4, code.length);
	            }
	          }
	          data.beforeTxt = native1;
	          break;
	        case "unicode":
	          var code = data.afterTxt.match(/&#(\d+);/g);
	          if (code == null) {
	            break;
	          }
	          for (var i = 0; i < code.length; i++) {
	            data.beforeTxt = data.beforeTxt + String.fromCharCode(code[i].replace(/[&#;]/g, ""));
	          }break;
	        case "url":
	          data.beforeTxt = decodeURIComponent(data.afterTxt);
	          break;
	        case "base64":
	          var words = _cryptoJs2.default.enc.Base64.parse(data.afterTxt);
	          data.beforeTxt = words.toString(_cryptoJs2.default.enc.Utf8);
	          break;
	        case "html":
	          data.beforeTxt = _common2.default.toHtml(data.afterTxt);
	          break;
	        default:
	          break;
	      }
	      self.model.beforeTxt = data.beforeTxt;
	    }
	  }
	};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(7);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _cryptoJs = __webpack_require__(39);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    menuName: "加密/解密",
	    sort: 45
	  },
	  data: function data() {
	    return {
	      model: {
	        beforeTxt: "",
	        afterTxt: "",
	        pwdTxt: "",
	        currentType: ""
	      },
	      encryptTypes: ["AES", "DES", "RC4", "Rabbit", "TripleDES", "Base64"],
	      hashTypes: ["MD5", "SHA1", "SHA224", "SHA256", "SHA384", "SHA512", "HmacSHA1", "HmacSHA224", "HmacSHA256", "HmacSHA384", "HmacSHA512", "HmacMD5"],
	      hashPwdTypes: ["HmacSHA1", "HmacSHA224", "HmacSHA256", "HmacSHA384", "HmacSHA512", "HmacMD5"],
	      tabType: 0
	    };
	  },
	
	  watch: {
	    $route: "fetchData",
	    "model.afterTxt": "saveData"
	  },
	  created: function created() {
	    this.loadData();
	    this.fetchData();
	  },
	
	  methods: {
	    loadData: function loadData() {
	      this.model = JSON.parse(localStorage.getItem("encrypt_model") || "null") || this.model;
	    },
	    saveData: function saveData() {
	      localStorage.setItem("encrypt_model", (0, _stringify2.default)(this.model));
	    },
	    fetchData: function fetchData() {
	      this.tabType = this.$route.query.tab || 1;
	      if (this.tabType == 1 && !this.model.currentType) {
	        this.model.currentType = this.encryptTypes[0];
	      } else if (!this.model.currentType) {
	        this.model.currentType = this.hashTypes[0];
	      }
	    },
	    switchTab: function switchTab(tab) {
	      this.$options.filters.openRoute({
	        path: this.$route.fullpath,
	        query: { tab: tab }
	      });
	    },
	    currentHandler: function currentHandler(e) {
	      this.model.currentType = e;
	    },
	    encrypt: function encrypt(type) {
	      var self = this;
	      type = type || self.encryptTypes[0];
	      var data = {
	        beforeTxt: this.model.beforeTxt || "",
	        afterTxt: this.model.afterTxt || "",
	        pwdTxt: this.model.pwdTxt || ""
	      };
	      if (type == "Base64") {
	        var str = _cryptoJs2.default.enc.Utf8.parse(data.beforeTxt);
	        self.model.afterTxt = _cryptoJs2.default.enc.Base64.stringify(str);
	        return;
	      }
	      self.model.afterTxt = _cryptoJs2.default[type].encrypt(data.beforeTxt, data.pwdTxt).toString();
	    },
	    decrypt: function decrypt(type) {
	      var self = this;
	      type = type || self.encryptTypes[0];
	      var data = {
	        afterTxt: this.model.afterTxt || "",
	        pwdTxt: this.model.pwdTxt || ""
	      };
	      if (type == "Base64") {
	        var words = _cryptoJs2.default.enc.Base64.parse(data.afterTxt);
	        self.model.beforeTxt = words.toString(_cryptoJs2.default.enc.Utf8);
	
	        return;
	      }
	      self.model.beforeTxt = _cryptoJs2.default[type].decrypt(data.afterTxt, data.pwdTxt).toString(_cryptoJs2.default.enc.Utf8);
	    },
	    hashEncrypt: function hashEncrypt(type) {
	      var self = this;
	      type = type || self.hashTypes[0];
	      var data = {
	        beforeTxt: this.model.beforeTxt || "",
	        afterTxt: this.model.afterTxt || "",
	        pwdTxt: this.model.pwdTxt || ""
	      };
	      self.model.afterTxt = _cryptoJs2.default[type](data.beforeTxt, data.pwdTxt).toString();
	    }
	  }
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(25);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(7);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(24);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _defineProperty2 = __webpack_require__(144);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _common = __webpack_require__(23);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _cryptoJs = __webpack_require__(39);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    menuName: '在线翻译',
	    sort: 90
	  },
	  data: function data() {
	    var _model;
	
	    return {
	      tabItems: [{
	        Name: 'fanyi',
	        Title: '在线翻译'
	      }],
	      currentOption: 1,
	      typeOptions: [],
	      model: (_model = {
	        beforeTxt: '',
	        afterTxt: ''
	      }, (0, _defineProperty3.default)(_model, 'afterTxt', ''), (0, _defineProperty3.default)(_model, 'jsonData', ''), _model),
	      config: {
	        baiduAppId: '20170416000044969',
	        baiduAppKey: 'X1ZMBUNuENgb7pzMVrpA',
	        youdaoAppId: '43710a08c729372d',
	        youdaoAppKey: 'LQlyErvEpecLMhUhTGOW0EjveWtqTg58'
	      }
	    };
	  },
	
	  watch: {
	    $route: 'fetchData',
	    'model.afterTxt': 'saveData'
	  },
	  created: function created() {
	    this.loadData();
	    this.fetchData();
	  },
	
	  methods: {
	    loadData: function loadData() {
	      this.model = JSON.parse(localStorage.getItem('fanyi_model') || 'null') || this.model;
	      this.config = (0, _assign2.default)(this.config, JSON.parse(localStorage.getItem('fanyi_config') || 'null'));
	    },
	    saveData: function saveData() {
	      localStorage.setItem('fanyi_model', (0, _stringify2.default)(this.model));
	    },
	    fetchData: function fetchData() {
	      this.typeOptions.push({
	        Text: '百度翻译',
	        Value: 1
	      });
	      this.typeOptions.push({
	        Text: '有道翻译',
	        Value: 2
	      });
	    },
	    fanyi: function fanyi() {
	      switch (this.currentOption) {
	        case 1:
	          this.baidufanyi();
	          break;
	        case 2:
	          this.youdaofanyi();
	          break;
	        default:
	          break;
	      }
	    },
	    youdaofanyi: function youdaofanyi() {
	      var self = this;
	      var str = this.model.beforeTxt;
	      if (_common2.default.trim(str) == '') {
	        self.model.beforeTxt = '';
	        return;
	      }
	      var query = str;
	      var appKey = self.config.youdaoAppId;
	      var key = self.config.youdaoAppKey;
	      var salt = new Date().getTime();
	      var curtime = Math.round(new Date().getTime() / 1000);
	
	      var from = 'auto';
	      var to = 'zh-CHS';
	      var str1 = appKey + truncate(query) + salt + curtime + key;
	      var sign = _cryptoJs2.default.SHA256(str1).toString(_cryptoJs2.default.enc.Hex);
	      var api = 'https://openapi.youdao.com/api';
	      var data = {
	        q: query,
	        appKey: appKey,
	        salt: salt,
	        from: from,
	        to: to,
	        sign: sign,
	        signType: 'v3',
	        curtime: curtime
	      };
	      if ((typeof chrome === 'undefined' ? 'undefined' : (0, _typeof3.default)(chrome)) != undefined && chrome.tabs) {
	        _common2.default.SendPostRequest(api, data, function (text) {
	          var resp = JSON.parse(text);
	          if (resp.errorCode == 0) {
	            self.model.afterTxt = '';
	            resp.translation.forEach(function (item) {
	              self.model.afterTxt += item + '\n';
	            });
	            self.model.jsonData = '';
	          } else {
	            self.model.afterTxt = '翻译失败~~~可以在设置中设置自己的密钥~~~~';
	            self.model.jsonData = (0, _stringify2.default)(resp);
	          }
	        });
	        return;
	      }
	      layui.jquery.ajax({
	        url: api,
	        type: 'post',
	        dataType: 'jsonp',
	        data: data,
	        success: function success(resp) {
	          if (resp.errorCode == 0) {
	            self.model.afterTxt = '';
	            resp.translation.forEach(function (item) {
	              self.model.afterTxt += item + '\n';
	            });
	            self.model.jsonData = '';
	          } else {
	            self.model.afterTxt = '翻译失败~~~可以在设置中设置自己的密钥~~~~';
	            self.model.jsonData = (0, _stringify2.default)(resp);
	          }
	        },
	        error: function error(data) {
	          self.model.afterTxt = '翻译失败~~~可以在设置中设置自己的密钥~~~~';
	          self.model.jsonData = (0, _stringify2.default)(data);
	        }
	      });
	
	      function truncate(q) {
	        var len = q.length;
	        if (len <= 20) return q;
	        return q.substring(0, 10) + len + q.substring(len - 10, len);
	      }
	    },
	    baidufanyi: function baidufanyi() {
	      var self = this;
	      var url = _common2.default.getProtocol() == 'http' ? 'http://api.fanyi.baidu.com/api/trans/vip/translate' : 'https://fanyi-api.baidu.com/api/trans/vip/translate';
	      if (_common2.default.trim(self.model.beforeTxt) == '') {
	        self.model.beforeTxt = '';
	        return;
	      }
	      var appid = self.config.baiduAppId;
	      var key = self.config.baiduAppKey;
	      var salt = new Date().getTime();
	      var query = self.model.beforeTxt.trim();
	
	      var from = 'auto';
	      var to = 'auto';
	      var str1 = appid + query + salt + key;
	      var sign = _cryptoJs2.default['MD5'](str1).toString();
	      var data = {
	        q: query,
	        appid: appid,
	        salt: salt,
	        from: from,
	        to: to,
	        sign: sign
	      };
	      if ((typeof chrome === 'undefined' ? 'undefined' : (0, _typeof3.default)(chrome)) != undefined && chrome.tabs) {
	        _common2.default.SendGetRequest(url, data, function (text) {
	          self.model.afterTxt = '';
	          JSON.parse(text).trans_result.forEach(function (item) {
	            self.model.afterTxt += item.dst + '\n';
	          });
	          self.model.jsonData = '';
	        });
	        return;
	      }
	      layui.jquery.ajax({
	        url: url,
	        type: 'get',
	        dataType: 'jsonp',
	        data: data,
	        success: function success(resp) {
	          if (!resp.trans_result) {
	            self.model.afterTxt = '翻译失败~~~可以在设置中设置自己的密钥~~~~';
	            self.model.jsonData = (0, _stringify2.default)(data);
	            return;
	          }
	          self.model.afterTxt = '';
	          resp.trans_result.forEach(function (item) {
	            self.model.afterTxt += item.dst + '\n';
	          });
	          self.model.jsonData = '';
	        },
	        error: function error(data) {
	          self.model.afterTxt = '翻译失败~~~可以在设置中设置自己的密钥~~~~';
	          self.model.jsonData = (0, _stringify2.default)(data);
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(25);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _common = __webpack_require__(23);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    menuName: "密码生成器",
	    sort: 80
	  },
	  data: function data() {
	    return {
	      tabItems: [{
	        Name: "sitepwd",
	        Title: "网站密码生成"
	      }, {
	        Name: "htpasswd",
	        Title: "htpasswd"
	      }],
	      model: {
	        userName: "",
	        userPwd: "",
	        afterTxt: "",
	        genPwdResult: "",
	        domainName: "",
	        domainKey: ""
	      },
	      currentHtpasswdType: "plain",
	      htpasswdOptions: [{
	        Text: "plain (Windows &amp; TPF servers)",
	        Value: "plain"
	      }, {
	        Text: "Crypt (all Unix servers)",
	        Value: "crypt"
	      }, {
	        Text: "MD5 (Apache servers only)",
	        Value: "md5"
	      }, {
	        Text: "SHA-1 (Netscape-LDIF/Apache servers)",
	        Value: "sha1"
	      }]
	    };
	  },
	  created: function created() {
	    var _this = this;
	    if (_this.$route.query.type === 'htpasswd') {
	      this.tabItems = this.tabItems.reverse();
	    }
	    if ((typeof chrome === "undefined" ? "undefined" : (0, _typeof3.default)(chrome)) != undefined && chrome.tabs) {
	      chrome.tabs.query({ active: true, currentWindow: true }, function (tabs) {
	        var tab = tabs[0];
	        _this.model.domainName = _this.getDomain(tab.url);
	      });
	    } else {
	      _this.model.domainName = location.host;
	    }
	  },
	
	  watch: {
	    currentHtpasswdType: function currentHtpasswdType(val) {
	      this.genHtpasswd();
	    }
	  },
	  methods: {
	    getDomain: function getDomain(weburl) {
	      var urlReg = /http[s]:\/\/([^\/]+)/i;
	      var domain = weburl.match(urlReg);
	      return domain != null && domain.length > 1 ? domain[1] : "";
	    },
	    genSitePwd: function genSitePwd() {
	      this.model.genPwdResult = this.htpasswd("", this.model.domainName + this.model.domainKey, "sha1").replace(":{SHA}", "").replace("/", "").replace("=", "").replace("+", "").substr(0, 8);
	      console.log(this.model.genPwdResult);
	    },
	    genHtpasswd: function genHtpasswd() {
	      this.model.afterTxt = this.htpasswd(this.model.userName, this.model.userPwd, this.currentHtpasswdType);
	    },
	    htpasswd: function htpasswd(user, pw, type) {
	      var cpw = "";
	      var AP_SHA1PW_ID = "{SHA}";
	      var AP_MD5PW_ID = "$apr1$";
	      switch (type) {
	        case "plain":
	          cpw = pw;
	          break;
	        case "crypt":
	          var salt = this.getMd5Salt();
	          cpw = this.getCrypt().displayPassword(pw, salt);
	          break;
	        case "md5":
	          var salt = this.getMd5Salt();
	          var msg = pw;
	          msg += AP_MD5PW_ID;
	          msg += salt;
	
	          var md5 = __webpack_require__(101);
	          cpw = md5(pw + salt + pw);
	          break;
	        case "sha1":
	          cpw = AP_SHA1PW_ID + this.sha1(pw);
	          break;
	      }
	
	      if (user.length + 1 + cpw.length > 255) return "用户+生成密码长度超过255";else return user + ":" + cpw;
	    },
	    getMd5Salt: function getMd5Salt() {
	      var itoa64 = "./0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
	      function ap_to64(v, n) {
	        var s = "";
	        while (--n >= 0) {
	          s += itoa64.charAt(v & 0x3f);
	          v >>>= 6;
	        }
	        return s;
	      }
	      var salt = ap_to64(Math.floor(Math.random() * 16777215), 4) + ap_to64(Math.floor(Math.random() * 16777215), 4);
	
	      return salt;
	    },
	    sha1: function sha1(str) {
	      var hexcase = 0;
	      var b64pad = "=";
	      var chrsz = 8;
	      function hex_sha1(s) {
	        return binb2hex(core_sha1(str2binb(s), s.length * chrsz));
	      }
	      function b64_sha1(s) {
	        return binb2b64(core_sha1(str2binb(s), s.length * chrsz));
	      }
	      function str_sha1(s) {
	        return binb2str(core_sha1(str2binb(s), s.length * chrsz));
	      }
	      function hex_hmac_sha1(key, data) {
	        return binb2hex(core_hmac_sha1(key, data));
	      }
	      function b64_hmac_sha1(key, data) {
	        return binb2b64(core_hmac_sha1(key, data));
	      }
	      function str_hmac_sha1(key, data) {
	        return binb2str(core_hmac_sha1(key, data));
	      }
	
	      function sha1_vm_test() {
	        return hex_sha1("abc") == "a9993e364706816aba3e25717850c26c9cd0d89d";
	      }
	
	      function core_sha1(x, len) {
	        x[len >> 5] |= 0x80 << 24 - len % 32;
	        x[(len + 64 >> 9 << 4) + 15] = len;
	
	        var w = Array(80);
	        var a = 1732584193;
	        var b = -271733879;
	        var c = -1732584194;
	        var d = 271733878;
	        var e = -1009589776;
	
	        for (var i = 0; i < x.length; i += 16) {
	          var olda = a;
	          var oldb = b;
	          var oldc = c;
	          var oldd = d;
	          var olde = e;
	
	          for (var j = 0; j < 80; j++) {
	            if (j < 16) w[j] = x[i + j];else w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
	            var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)), safe_add(safe_add(e, w[j]), sha1_kt(j)));
	            e = d;
	            d = c;
	            c = rol(b, 30);
	            b = a;
	            a = t;
	          }
	
	          a = safe_add(a, olda);
	          b = safe_add(b, oldb);
	          c = safe_add(c, oldc);
	          d = safe_add(d, oldd);
	          e = safe_add(e, olde);
	        }
	        return Array(a, b, c, d, e);
	      }
	
	      function sha1_ft(t, b, c, d) {
	        if (t < 20) return b & c | ~b & d;
	        if (t < 40) return b ^ c ^ d;
	        if (t < 60) return b & c | b & d | c & d;
	        return b ^ c ^ d;
	      }
	
	      function sha1_kt(t) {
	        return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
	      }
	
	      function core_hmac_sha1(key, data) {
	        var bkey = str2binb(key);
	        if (bkey.length > 16) bkey = core_sha1(bkey, key.length * chrsz);
	
	        var ipad = Array(16),
	            opad = Array(16);
	        for (var i = 0; i < 16; i++) {
	          ipad[i] = bkey[i] ^ 0x36363636;
	          opad[i] = bkey[i] ^ 0x5c5c5c5c;
	        }
	
	        var hash = core_sha1(ipad.concat(str2binb(data)), 512 + data.length * chrsz);
	        return core_sha1(opad.concat(hash), 512 + 160);
	      }
	
	      function safe_add(x, y) {
	        var lsw = (x & 0xffff) + (y & 0xffff);
	        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	        return msw << 16 | lsw & 0xffff;
	      }
	
	      function rol(num, cnt) {
	        return num << cnt | num >>> 32 - cnt;
	      }
	
	      function str2binb(str) {
	        var bin = Array();
	        var mask = (1 << chrsz) - 1;
	        for (var i = 0; i < str.length * chrsz; i += chrsz) {
	          bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << 24 - i % 32;
	        }return bin;
	      }
	
	      function binb2str(bin) {
	        var str = "";
	        var mask = (1 << chrsz) - 1;
	        for (var i = 0; i < bin.length * 32; i += chrsz) {
	          str += String.fromCharCode(bin[i >> 5] >>> 24 - i % 32 & mask);
	        }return str;
	      }
	
	      function binb2hex(binarray) {
	        var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
	        var str = "";
	        for (var i = 0; i < binarray.length * 4; i++) {
	          str += hex_tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 + 4 & 0xf) + hex_tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 & 0xf);
	        }
	        return str;
	      }
	
	      function binb2b64(binarray) {
	        var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	        var str = "";
	        for (var i = 0; i < binarray.length * 4; i += 3) {
	          var triplet = (binarray[i >> 2] >> 8 * (3 - i % 4) & 0xff) << 16 | (binarray[i + 1 >> 2] >> 8 * (3 - (i + 1) % 4) & 0xff) << 8 | binarray[i + 2 >> 2] >> 8 * (3 - (i + 2) % 4) & 0xff;
	          for (var j = 0; j < 4; j++) {
	            if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;else str += tab.charAt(triplet >> 6 * (3 - j) & 0x3f);
	          }
	        }
	        return str;
	      }
	      return b64_sha1(str);
	    },
	    getCrypt: function getCrypt() {
	      function init() {
	        function dP(pw, salt) {
	          var pw_salt = this.crypt(salt, pw);
	          return pw_salt[0];
	        }
	
	        function bTU(b) {
	          var value = Math.floor(b);
	          return value >= 0 ? value : value + 256;
	        }
	        function fBTI(b, offset) {
	          var value = this.byteToUnsigned(b[offset++]);
	          value |= this.byteToUnsigned(b[offset++]) << 8;
	          value |= this.byteToUnsigned(b[offset++]) << 16;
	          value |= this.byteToUnsigned(b[offset++]) << 24;
	          return value;
	        }
	        function iTFB(iValue, b, offset) {
	          b[offset++] = iValue & 0xff;
	          b[offset++] = iValue >>> 8 & 0xff;
	          b[offset++] = iValue >>> 16 & 0xff;
	          b[offset++] = iValue >>> 24 & 0xff;
	        }
	        function P_P(a, b, n, m, results) {
	          var t = (a >>> n ^ b) & m;
	          a ^= t << n;
	          b ^= t;
	          results[0] = a;
	          results[1] = b;
	        }
	        function H_P(a, n, m) {
	          var t = (a << 16 - n ^ a) & m;
	          a = a ^ t ^ t >>> 16 - n;
	          return a;
	        }
	        function d_s_k(key) {
	          var schedule = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
	          var c = this.fourBytesToInt(key, 0);
	          var d = this.fourBytesToInt(key, 4);
	          var results = new Array(0, 0);
	          this.PERM_OP(d, c, 4, 0x0f0f0f0f, results);
	          d = results[0];
	          c = results[1];
	          c = this.HPERM_OP(c, -2, 0xcccc0000);
	          d = this.HPERM_OP(d, -2, 0xcccc0000);
	          this.PERM_OP(d, c, 1, 0x55555555, results);
	          d = results[0];
	          c = results[1];
	          this.PERM_OP(c, d, 8, 0x00ff00ff, results);
	          c = results[0];
	          d = results[1];
	          this.PERM_OP(d, c, 1, 0x55555555, results);
	          d = results[0];
	          c = results[1];
	          d = (d & 0x000000ff) << 16 | d & 0x0000ff00 | (d & 0x00ff0000) >>> 16 | (c & 0xf0000000) >>> 4;
	          c &= 0x0fffffff;
	          var s = 0;
	          var t = 0;
	          var j = 0;
	          for (var i = 0; i < this.ITERATIONS; i++) {
	            if (this.shifts2[i]) {
	              c = c >>> 2 | c << 26;
	              d = d >>> 2 | d << 26;
	            } else {
	              c = c >>> 1 | c << 27;
	              d = d >>> 1 | d << 27;
	            }
	            c &= 0x0fffffff;
	            d &= 0x0fffffff;
	            s = this.skb[0][c & 0x3f] | this.skb[1][c >>> 6 & 0x03 | c >>> 7 & 0x3c] | this.skb[2][c >>> 13 & 0x0f | c >>> 14 & 0x30] | this.skb[3][c >>> 20 & 0x01 | c >>> 21 & 0x06 | c >>> 22 & 0x38];
	            t = this.skb[4][d & 0x3f] | this.skb[5][d >>> 7 & 0x03 | d >>> 8 & 0x3c] | this.skb[6][d >>> 15 & 0x3f] | this.skb[7][d >>> 21 & 0x0f | d >>> 22 & 0x30];
	            schedule[j++] = (t << 16 | s & 0x0000ffff) & 0xffffffff;
	            s = s >>> 16 | t & 0xffff0000;
	            s = s << 4 | s >>> 28;
	            schedule[j++] = s & 0xffffffff;
	          }
	          return schedule;
	        }
	        function D_E(L, R, S, E0, E1, s) {
	          var v = R ^ R >>> 16;
	          var u = v & E0;
	          v = v & E1;
	          u = u ^ u << 16 ^ R ^ s[S];
	          var t = v ^ v << 16 ^ R ^ s[S + 1];
	          t = t >>> 4 | t << 28;
	          L ^= this.SPtrans[1][t & 0x3f] | this.SPtrans[3][t >>> 8 & 0x3f] | this.SPtrans[5][t >>> 16 & 0x3f] | this.SPtrans[7][t >>> 24 & 0x3f] | this.SPtrans[0][u & 0x3f] | this.SPtrans[2][u >>> 8 & 0x3f] | this.SPtrans[4][u >>> 16 & 0x3f] | this.SPtrans[6][u >>> 24 & 0x3f];
	          return L;
	        }
	        function bdy(schedule, Eswap0, Eswap1) {
	          var left = 0;
	          var right = 0;
	          var t = 0;
	          for (var j = 0; j < 25; j++) {
	            for (var i = 0; i < this.ITERATIONS * 2; i += 4) {
	              left = this.D_ENCRYPT(left, right, i, Eswap0, Eswap1, schedule);
	              right = this.D_ENCRYPT(right, left, i + 2, Eswap0, Eswap1, schedule);
	            }
	            t = left;
	            left = right;
	            right = t;
	          }
	          t = right;
	          right = left >>> 1 | left << 31;
	          left = t >>> 1 | t << 31;
	          left &= 0xffffffff;
	          right &= 0xffffffff;
	          var results = new Array(0, 0);
	          this.PERM_OP(right, left, 1, 0x55555555, results);
	          right = results[0];
	          left = results[1];
	          this.PERM_OP(left, right, 8, 0x00ff00ff, results);
	          left = results[0];
	          right = results[1];
	          this.PERM_OP(right, left, 2, 0x33333333, results);
	          right = results[0];
	          left = results[1];
	          this.PERM_OP(left, right, 16, 0x0000ffff, results);
	          left = results[0];
	          right = results[1];
	          this.PERM_OP(right, left, 4, 0x0f0f0f0f, results);
	          right = results[0];
	          left = results[1];
	          var out = new Array(0, 0);
	          out[0] = left;
	          out[1] = right;
	          return out;
	        }
	        function rC() {
	          return this.GOODCHARS[Math.floor(64 * Math.random())];
	        }
	        function cript(salt, original) {
	          if (salt.length >= 2) salt = salt.substring(0, 2);
	          while (salt.length < 2) {
	            salt += this.randChar();
	          }var re = new RegExp("[^./a-zA-Z0-9]", "g");
	          if (re.test(salt)) salt = this.randChar() + this.randChar();
	          var charZero = salt.charAt(0) + "";
	          var charOne = salt.charAt(1) + "";
	          var ccZ = charZero.charCodeAt(0);
	          var ccO = charOne.charCodeAt(0);
	          var buffer = charZero + charOne + "       ";
	          var Eswap0 = this.con_salt[ccZ];
	          var Eswap1 = this.con_salt[ccO] << 4;
	          var key = new Array(0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0);
	          for (var i = 0; i < key.length && i < original.length; i++) {
	            var iChar = original.charCodeAt(i);
	            key[i] = iChar << 1;
	          }
	          var schedule = this.des_set_key(key);
	          var out = this.body(schedule, Eswap0, Eswap1);
	          var b = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
	          this.intToFourBytes(out[0], b, 0);
	          this.intToFourBytes(out[1], b, 4);
	          b[8] = 0;
	          for (var i = 2, y = 0, u = 0x80; i < 13; i++) {
	            for (var j = 0, c = 0; j < 6; j++) {
	              c <<= 1;
	              if ((b[y] & u) != 0) c |= 1;
	              u >>>= 1;
	              if (u == 0) {
	                y++;
	                u = 0x80;
	              }
	              buffer = buffer.substring(0, i) + String.fromCharCode(this.cov_2char[c]) + buffer.substring(i + 1, buffer.length);
	            }
	          }
	          var ret = new Array(buffer, salt);
	          return ret;
	        }
	
	        function Crypt() {
	          this.ITERATIONS = 16;
	          this.GOODCHARS = new Array(".", "/", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z");
	          this.con_salt = new Array(0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x02, 0x03, 0x04, 0x05, 0x06, 0x07, 0x08, 0x09, 0x0a, 0x0b, 0x05, 0x06, 0x07, 0x08, 0x09, 0x0a, 0x0b, 0x0c, 0x0d, 0x0e, 0x0f, 0x10, 0x11, 0x12, 0x13, 0x14, 0x15, 0x16, 0x17, 0x18, 0x19, 0x1a, 0x1b, 0x1c, 0x1d, 0x1e, 0x1f, 0x20, 0x21, 0x22, 0x23, 0x24, 0x25, 0x20, 0x21, 0x22, 0x23, 0x24, 0x25, 0x26, 0x27, 0x28, 0x29, 0x2a, 0x2b, 0x2c, 0x2d, 0x2e, 0x2f, 0x30, 0x31, 0x32, 0x33, 0x34, 0x35, 0x36, 0x37, 0x38, 0x39, 0x3a, 0x3b, 0x3c, 0x3d, 0x3e, 0x3f, 0x00, 0x00, 0x00, 0x00, 0x00);
	          this.shifts2 = new Array(false, false, true, true, true, true, true, true, false, true, true, true, true, true, true, false);
	          this.skb = new Array(0, 0, 0, 0, 0, 0, 0, 0);
	          this.skb[0] = new Array(0x00000000, 0x00000010, 0x20000000, 0x20000010, 0x00010000, 0x00010010, 0x20010000, 0x20010010, 0x00000800, 0x00000810, 0x20000800, 0x20000810, 0x00010800, 0x00010810, 0x20010800, 0x20010810, 0x00000020, 0x00000030, 0x20000020, 0x20000030, 0x00010020, 0x00010030, 0x20010020, 0x20010030, 0x00000820, 0x00000830, 0x20000820, 0x20000830, 0x00010820, 0x00010830, 0x20010820, 0x20010830, 0x00080000, 0x00080010, 0x20080000, 0x20080010, 0x00090000, 0x00090010, 0x20090000, 0x20090010, 0x00080800, 0x00080810, 0x20080800, 0x20080810, 0x00090800, 0x00090810, 0x20090800, 0x20090810, 0x00080020, 0x00080030, 0x20080020, 0x20080030, 0x00090020, 0x00090030, 0x20090020, 0x20090030, 0x00080820, 0x00080830, 0x20080820, 0x20080830, 0x00090820, 0x00090830, 0x20090820, 0x20090830);
	          this.skb[1] = new Array(0x00000000, 0x02000000, 0x00002000, 0x02002000, 0x00200000, 0x02200000, 0x00202000, 0x02202000, 0x00000004, 0x02000004, 0x00002004, 0x02002004, 0x00200004, 0x02200004, 0x00202004, 0x02202004, 0x00000400, 0x02000400, 0x00002400, 0x02002400, 0x00200400, 0x02200400, 0x00202400, 0x02202400, 0x00000404, 0x02000404, 0x00002404, 0x02002404, 0x00200404, 0x02200404, 0x00202404, 0x02202404, 0x10000000, 0x12000000, 0x10002000, 0x12002000, 0x10200000, 0x12200000, 0x10202000, 0x12202000, 0x10000004, 0x12000004, 0x10002004, 0x12002004, 0x10200004, 0x12200004, 0x10202004, 0x12202004, 0x10000400, 0x12000400, 0x10002400, 0x12002400, 0x10200400, 0x12200400, 0x10202400, 0x12202400, 0x10000404, 0x12000404, 0x10002404, 0x12002404, 0x10200404, 0x12200404, 0x10202404, 0x12202404);
	          this.skb[2] = new Array(0x00000000, 0x00000001, 0x00040000, 0x00040001, 0x01000000, 0x01000001, 0x01040000, 0x01040001, 0x00000002, 0x00000003, 0x00040002, 0x00040003, 0x01000002, 0x01000003, 0x01040002, 0x01040003, 0x00000200, 0x00000201, 0x00040200, 0x00040201, 0x01000200, 0x01000201, 0x01040200, 0x01040201, 0x00000202, 0x00000203, 0x00040202, 0x00040203, 0x01000202, 0x01000203, 0x01040202, 0x01040203, 0x08000000, 0x08000001, 0x08040000, 0x08040001, 0x09000000, 0x09000001, 0x09040000, 0x09040001, 0x08000002, 0x08000003, 0x08040002, 0x08040003, 0x09000002, 0x09000003, 0x09040002, 0x09040003, 0x08000200, 0x08000201, 0x08040200, 0x08040201, 0x09000200, 0x09000201, 0x09040200, 0x09040201, 0x08000202, 0x08000203, 0x08040202, 0x08040203, 0x09000202, 0x09000203, 0x09040202, 0x09040203);
	          this.skb[3] = new Array(0x00000000, 0x00100000, 0x00000100, 0x00100100, 0x00000008, 0x00100008, 0x00000108, 0x00100108, 0x00001000, 0x00101000, 0x00001100, 0x00101100, 0x00001008, 0x00101008, 0x00001108, 0x00101108, 0x04000000, 0x04100000, 0x04000100, 0x04100100, 0x04000008, 0x04100008, 0x04000108, 0x04100108, 0x04001000, 0x04101000, 0x04001100, 0x04101100, 0x04001008, 0x04101008, 0x04001108, 0x04101108, 0x00020000, 0x00120000, 0x00020100, 0x00120100, 0x00020008, 0x00120008, 0x00020108, 0x00120108, 0x00021000, 0x00121000, 0x00021100, 0x00121100, 0x00021008, 0x00121008, 0x00021108, 0x00121108, 0x04020000, 0x04120000, 0x04020100, 0x04120100, 0x04020008, 0x04120008, 0x04020108, 0x04120108, 0x04021000, 0x04121000, 0x04021100, 0x04121100, 0x04021008, 0x04121008, 0x04021108, 0x04121108);
	          this.skb[4] = new Array(0x00000000, 0x10000000, 0x00010000, 0x10010000, 0x00000004, 0x10000004, 0x00010004, 0x10010004, 0x20000000, 0x30000000, 0x20010000, 0x30010000, 0x20000004, 0x30000004, 0x20010004, 0x30010004, 0x00100000, 0x10100000, 0x00110000, 0x10110000, 0x00100004, 0x10100004, 0x00110004, 0x10110004, 0x20100000, 0x30100000, 0x20110000, 0x30110000, 0x20100004, 0x30100004, 0x20110004, 0x30110004, 0x00001000, 0x10001000, 0x00011000, 0x10011000, 0x00001004, 0x10001004, 0x00011004, 0x10011004, 0x20001000, 0x30001000, 0x20011000, 0x30011000, 0x20001004, 0x30001004, 0x20011004, 0x30011004, 0x00101000, 0x10101000, 0x00111000, 0x10111000, 0x00101004, 0x10101004, 0x00111004, 0x10111004, 0x20101000, 0x30101000, 0x20111000, 0x30111000, 0x20101004, 0x30101004, 0x20111004, 0x30111004);
	          this.skb[5] = new Array(0x00000000, 0x08000000, 0x00000008, 0x08000008, 0x00000400, 0x08000400, 0x00000408, 0x08000408, 0x00020000, 0x08020000, 0x00020008, 0x08020008, 0x00020400, 0x08020400, 0x00020408, 0x08020408, 0x00000001, 0x08000001, 0x00000009, 0x08000009, 0x00000401, 0x08000401, 0x00000409, 0x08000409, 0x00020001, 0x08020001, 0x00020009, 0x08020009, 0x00020401, 0x08020401, 0x00020409, 0x08020409, 0x02000000, 0x0a000000, 0x02000008, 0x0a000008, 0x02000400, 0x0a000400, 0x02000408, 0x0a000408, 0x02020000, 0x0a020000, 0x02020008, 0x0a020008, 0x02020400, 0x0a020400, 0x02020408, 0x0a020408, 0x02000001, 0x0a000001, 0x02000009, 0x0a000009, 0x02000401, 0x0a000401, 0x02000409, 0x0a000409, 0x02020001, 0x0a020001, 0x02020009, 0x0a020009, 0x02020401, 0x0a020401, 0x02020409, 0x0a020409);
	          this.skb[6] = new Array(0x00000000, 0x00000100, 0x00080000, 0x00080100, 0x01000000, 0x01000100, 0x01080000, 0x01080100, 0x00000010, 0x00000110, 0x00080010, 0x00080110, 0x01000010, 0x01000110, 0x01080010, 0x01080110, 0x00200000, 0x00200100, 0x00280000, 0x00280100, 0x01200000, 0x01200100, 0x01280000, 0x01280100, 0x00200010, 0x00200110, 0x00280010, 0x00280110, 0x01200010, 0x01200110, 0x01280010, 0x01280110, 0x00000200, 0x00000300, 0x00080200, 0x00080300, 0x01000200, 0x01000300, 0x01080200, 0x01080300, 0x00000210, 0x00000310, 0x00080210, 0x00080310, 0x01000210, 0x01000310, 0x01080210, 0x01080310, 0x00200200, 0x00200300, 0x00280200, 0x00280300, 0x01200200, 0x01200300, 0x01280200, 0x01280300, 0x00200210, 0x00200310, 0x00280210, 0x00280310, 0x01200210, 0x01200310, 0x01280210, 0x01280310);
	          this.skb[7] = new Array(0x00000000, 0x04000000, 0x00040000, 0x04040000, 0x00000002, 0x04000002, 0x00040002, 0x04040002, 0x00002000, 0x04002000, 0x00042000, 0x04042000, 0x00002002, 0x04002002, 0x00042002, 0x04042002, 0x00000020, 0x04000020, 0x00040020, 0x04040020, 0x00000022, 0x04000022, 0x00040022, 0x04040022, 0x00002020, 0x04002020, 0x00042020, 0x04042020, 0x00002022, 0x04002022, 0x00042022, 0x04042022, 0x00000800, 0x04000800, 0x00040800, 0x04040800, 0x00000802, 0x04000802, 0x00040802, 0x04040802, 0x00002800, 0x04002800, 0x00042800, 0x04042800, 0x00002802, 0x04002802, 0x00042802, 0x04042802, 0x00000820, 0x04000820, 0x00040820, 0x04040820, 0x00000822, 0x04000822, 0x00040822, 0x04040822, 0x00002820, 0x04002820, 0x00042820, 0x04042820, 0x00002822, 0x04002822, 0x00042822, 0x04042822);
	          this.SPtrans = new Array(0, 0, 0, 0, 0, 0, 0, 0);
	          this.SPtrans[0] = new Array(0x00820200, 0x00020000, 0x80800000, 0x80820200, 0x00800000, 0x80020200, 0x80020000, 0x80800000, 0x80020200, 0x00820200, 0x00820000, 0x80000200, 0x80800200, 0x00800000, 0x00000000, 0x80020000, 0x00020000, 0x80000000, 0x00800200, 0x00020200, 0x80820200, 0x00820000, 0x80000200, 0x00800200, 0x80000000, 0x00000200, 0x00020200, 0x80820000, 0x00000200, 0x80800200, 0x80820000, 0x00000000, 0x00000000, 0x80820200, 0x00800200, 0x80020000, 0x00820200, 0x00020000, 0x80000200, 0x00800200, 0x80820000, 0x00000200, 0x00020200, 0x80800000, 0x80020200, 0x80000000, 0x80800000, 0x00820000, 0x80820200, 0x00020200, 0x00820000, 0x80800200, 0x00800000, 0x80000200, 0x80020000, 0x00000000, 0x00020000, 0x00800000, 0x80800200, 0x00820200, 0x80000000, 0x80820000, 0x00000200, 0x80020200);
	          this.SPtrans[1] = new Array(0x10042004, 0x00000000, 0x00042000, 0x10040000, 0x10000004, 0x00002004, 0x10002000, 0x00042000, 0x00002000, 0x10040004, 0x00000004, 0x10002000, 0x00040004, 0x10042000, 0x10040000, 0x00000004, 0x00040000, 0x10002004, 0x10040004, 0x00002000, 0x00042004, 0x10000000, 0x00000000, 0x00040004, 0x10002004, 0x00042004, 0x10042000, 0x10000004, 0x10000000, 0x00040000, 0x00002004, 0x10042004, 0x00040004, 0x10042000, 0x10002000, 0x00042004, 0x10042004, 0x00040004, 0x10000004, 0x00000000, 0x10000000, 0x00002004, 0x00040000, 0x10040004, 0x00002000, 0x10000000, 0x00042004, 0x10002004, 0x10042000, 0x00002000, 0x00000000, 0x10000004, 0x00000004, 0x10042004, 0x00042000, 0x10040000, 0x10040004, 0x00040000, 0x00002004, 0x10002000, 0x10002004, 0x00000004, 0x10040000, 0x00042000);
	          this.SPtrans[2] = new Array(0x41000000, 0x01010040, 0x00000040, 0x41000040, 0x40010000, 0x01000000, 0x41000040, 0x00010040, 0x01000040, 0x00010000, 0x01010000, 0x40000000, 0x41010040, 0x40000040, 0x40000000, 0x41010000, 0x00000000, 0x40010000, 0x01010040, 0x00000040, 0x40000040, 0x41010040, 0x00010000, 0x41000000, 0x41010000, 0x01000040, 0x40010040, 0x01010000, 0x00010040, 0x00000000, 0x01000000, 0x40010040, 0x01010040, 0x00000040, 0x40000000, 0x00010000, 0x40000040, 0x40010000, 0x01010000, 0x41000040, 0x00000000, 0x01010040, 0x00010040, 0x41010000, 0x40010000, 0x01000000, 0x41010040, 0x40000000, 0x40010040, 0x41000000, 0x01000000, 0x41010040, 0x00010000, 0x01000040, 0x41000040, 0x00010040, 0x01000040, 0x00000000, 0x41010000, 0x40000040, 0x41000000, 0x40010040, 0x00000040, 0x01010000);
	          this.SPtrans[3] = new Array(0x00100402, 0x04000400, 0x00000002, 0x04100402, 0x00000000, 0x04100000, 0x04000402, 0x00100002, 0x04100400, 0x04000002, 0x04000000, 0x00000402, 0x04000002, 0x00100402, 0x00100000, 0x04000000, 0x04100002, 0x00100400, 0x00000400, 0x00000002, 0x00100400, 0x04000402, 0x04100000, 0x00000400, 0x00000402, 0x00000000, 0x00100002, 0x04100400, 0x04000400, 0x04100002, 0x04100402, 0x00100000, 0x04100002, 0x00000402, 0x00100000, 0x04000002, 0x00100400, 0x04000400, 0x00000002, 0x04100000, 0x04000402, 0x00000000, 0x00000400, 0x00100002, 0x00000000, 0x04100002, 0x04100400, 0x00000400, 0x04000000, 0x04100402, 0x00100402, 0x00100000, 0x04100402, 0x00000002, 0x04000400, 0x00100402, 0x00100002, 0x00100400, 0x04100000, 0x04000402, 0x00000402, 0x04000000, 0x04000002, 0x04100400);
	          this.SPtrans[4] = new Array(0x02000000, 0x00004000, 0x00000100, 0x02004108, 0x02004008, 0x02000100, 0x00004108, 0x02004000, 0x00004000, 0x00000008, 0x02000008, 0x00004100, 0x02000108, 0x02004008, 0x02004100, 0x00000000, 0x00004100, 0x02000000, 0x00004008, 0x00000108, 0x02000100, 0x00004108, 0x00000000, 0x02000008, 0x00000008, 0x02000108, 0x02004108, 0x00004008, 0x02004000, 0x00000100, 0x00000108, 0x02004100, 0x02004100, 0x02000108, 0x00004008, 0x02004000, 0x00004000, 0x00000008, 0x02000008, 0x02000100, 0x02000000, 0x00004100, 0x02004108, 0x00000000, 0x00004108, 0x02000000, 0x00000100, 0x00004008, 0x02000108, 0x00000100, 0x00000000, 0x02004108, 0x02004008, 0x02004100, 0x00000108, 0x00004000, 0x00004100, 0x02004008, 0x02000100, 0x00000108, 0x00000008, 0x00004108, 0x02004000, 0x02000008);
	
	          this.SPtrans[5] = new Array(0x20000010, 0x00080010, 0x00000000, 0x20080800, 0x00080010, 0x00000800, 0x20000810, 0x00080000, 0x00000810, 0x20080810, 0x00080800, 0x20000000, 0x20000800, 0x20000010, 0x20080000, 0x00080810, 0x00080000, 0x20000810, 0x20080010, 0x00000000, 0x00000800, 0x00000010, 0x20080800, 0x20080010, 0x20080810, 0x20080000, 0x20000000, 0x00000810, 0x00000010, 0x00080800, 0x00080810, 0x20000800, 0x00000810, 0x20000000, 0x20000800, 0x00080810, 0x20080800, 0x00080010, 0x00000000, 0x20000800, 0x20000000, 0x00000800, 0x20080010, 0x00080000, 0x00080010, 0x20080810, 0x00080800, 0x00000010, 0x20080810, 0x00080800, 0x00080000, 0x20000810, 0x20000010, 0x20080000, 0x00080810, 0x00000000, 0x00000800, 0x20000010, 0x20000810, 0x20080800, 0x20080000, 0x00000810, 0x00000010, 0x20080010);
	          this.SPtrans[6] = new Array(0x00001000, 0x00000080, 0x00400080, 0x00400001, 0x00401081, 0x00001001, 0x00001080, 0x00000000, 0x00400000, 0x00400081, 0x00000081, 0x00401000, 0x00000001, 0x00401080, 0x00401000, 0x00000081, 0x00400081, 0x00001000, 0x00001001, 0x00401081, 0x00000000, 0x00400080, 0x00400001, 0x00001080, 0x00401001, 0x00001081, 0x00401080, 0x00000001, 0x00001081, 0x00401001, 0x00000080, 0x00400000, 0x00001081, 0x00401000, 0x00401001, 0x00000081, 0x00001000, 0x00000080, 0x00400000, 0x00401001, 0x00400081, 0x00001081, 0x00001080, 0x00000000, 0x00000080, 0x00400001, 0x00000001, 0x00400080, 0x00000000, 0x00400081, 0x00400080, 0x00001080, 0x00000081, 0x00001000, 0x00401081, 0x00400000, 0x00401080, 0x00000001, 0x00001001, 0x00401081, 0x00400001, 0x00401080, 0x00401000, 0x00001001);
	          this.SPtrans[7] = new Array(0x08200020, 0x08208000, 0x00008020, 0x00000000, 0x08008000, 0x00200020, 0x08200000, 0x08208020, 0x00000020, 0x08000000, 0x00208000, 0x00008020, 0x00208020, 0x08008020, 0x08000020, 0x08200000, 0x00008000, 0x00208020, 0x00200020, 0x08008000, 0x08208020, 0x08000020, 0x00000000, 0x00208000, 0x08000000, 0x00200000, 0x08008020, 0x08200020, 0x00200000, 0x00008000, 0x08208000, 0x00000020, 0x00200000, 0x00008000, 0x08000020, 0x08208020, 0x00008020, 0x08000000, 0x00000000, 0x00208000, 0x08200020, 0x08008020, 0x08008000, 0x00200020, 0x08208000, 0x00000020, 0x00200020, 0x08008000, 0x08208020, 0x00200000, 0x08200000, 0x08000020, 0x00208000, 0x00008020, 0x08008020, 0x08200000, 0x00000020, 0x08208000, 0x00208020, 0x00000000, 0x08000000, 0x08200020, 0x00008000, 0x00208020);
	          this.cov_2char = new Array(0x2e, 0x2f, 0x30, 0x31, 0x32, 0x33, 0x34, 0x35, 0x36, 0x37, 0x38, 0x39, 0x41, 0x42, 0x43, 0x44, 0x45, 0x46, 0x47, 0x48, 0x49, 0x4a, 0x4b, 0x4c, 0x4d, 0x4e, 0x4f, 0x50, 0x51, 0x52, 0x53, 0x54, 0x55, 0x56, 0x57, 0x58, 0x59, 0x5a, 0x61, 0x62, 0x63, 0x64, 0x65, 0x66, 0x67, 0x68, 0x69, 0x6a, 0x6b, 0x6c, 0x6d, 0x6e, 0x6f, 0x70, 0x71, 0x72, 0x73, 0x74, 0x75, 0x76, 0x77, 0x78, 0x79, 0x7a);
	          this.byteToUnsigned = bTU;
	          this.fourBytesToInt = fBTI;
	          this.intToFourBytes = iTFB;
	          this.PERM_OP = P_P;
	          this.HPERM_OP = H_P;
	          this.des_set_key = d_s_k;
	          this.D_ENCRYPT = D_E;
	          this.body = bdy;
	          this.randChar = rC;
	          this.crypt = cript;
	          this.displayPassword = dP;
	        }
	        return new Crypt();
	      }
	      return init();
	    }
	  }
	};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _miaoHelper = __webpack_require__(137);
	
	var _miaoHelper2 = _interopRequireDefault(_miaoHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    menuName: '非人语转换',
	    sort: 30
	  },
	  data: function data() {
	    return {
	      tabItems: [{
	        Name: 'main',
	        Title: '非人语转换'
	      }],
	      replaceTxt: '喵',
	      beforeTxt: '',
	      afterTxt: ''
	    };
	  },
	  created: function created() {
	    if (localStorage.Gossip_Replace_Txt) this.replaceTxt = localStorage.Gossip_Replace_Txt;
	  },
	
	  methods: {
	    convertGossip: function convertGossip() {
	      this.saveReplaceTxt();
	      var beforeTxt = this.beforeTxt;
	      this.afterTxt = _miaoHelper2.default.encode(beforeTxt, this.replaceTxt);
	    },
	    convertMan: function convertMan() {
	      this.saveReplaceTxt();
	      var afterTxt = this.afterTxt;
	      this.beforeTxt = _miaoHelper2.default.decode(afterTxt);
	    },
	    saveReplaceTxt: function saveReplaceTxt() {
	      this.replaceTxt = this.replaceTxt || '喵';
	      localStorage.Gossip_Replace_Txt = this.replaceTxt;
	    }
	  }
	};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cacheHelper = __webpack_require__(33);
	
	var _cacheHelper2 = _interopRequireDefault(_cacheHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    indexHide: true,
	    menuName: '快速导航',
	    sort: 1000
	  },
	  data: function data() {
	    return {
	      menus: []
	    };
	  },
	  created: function created() {
	    this.menus = window.siteMenuItems.filter(function (e) {
	      return e.indexHide !== true;
	    });
	  },
	
	  methods: {}
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(7);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    menuName: 'JSON格式化',
	    sort: 31
	  },
	  data: function data() {
	    return {
	      tabItems: [{
	        Name: 'main',
	        Title: 'JSON格式化'
	      }],
	      replaceTxt: 4,
	      beforeTxt: '',
	      afterTxt: ''
	    };
	  },
	  created: function created() {
	    if (localStorage.JsonFormat_Number) this.replaceTxt = Number(localStorage.JsonFormat_Number);
	  },
	
	  methods: {
	    convertFormatJson: function convertFormatJson() {
	      this.saveReplaceTxt();
	      var beforeTxt = this.beforeTxt;
	      try {
	        var jsonObj = JSON.parse(beforeTxt);
	        this.afterTxt = (0, _stringify2.default)(jsonObj, null, Number(this.replaceTxt));
	      } catch (e) {
	        console.log(e);
	        this.afterTxt = 'JSON格式不正确:' + e;
	      }
	    },
	    convertMiniJson: function convertMiniJson() {
	      this.saveReplaceTxt();
	      var afterTxt = this.afterTxt;
	      try {
	        var jsonObj = JSON.parse(afterTxt);
	        this.beforeTxt = (0, _stringify2.default)(jsonObj, null, 0);
	      } catch (e) {
	        console.log(e);
	        this.afterTxt = 'JSON格式不正确:' + e;
	      }
	    },
	    saveReplaceTxt: function saveReplaceTxt() {
	      this.replaceTxt = this.replaceTxt || '4';
	      localStorage.JsonFormat_Number = this.replaceTxt;
	    }
	  }
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(231);
	
	var _tomarkdown = __webpack_require__(139);
	
	var _tomarkdown2 = _interopRequireDefault(_tomarkdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    menuName: 'Markdown/Html互转',
	    sort: 20
	  },
	  data: function data() {
	    return {
	      items: [{
	        Title: 'Html转Markdown',
	        Name: 'toMarkdown'
	      }, {
	        Title: 'Markdown转Html',
	        Name: 'toHtml'
	      }],
	      htmlText1: '',
	      mdText1: '',
	      mdText2: '',
	      htmlText2: ''
	    };
	  },
	
	  methods: {
	    convert: function convert(md) {
	      var marked = __webpack_require__(234);
	      marked.setOptions({
	        renderer: new marked.Renderer(),
	        gfm: true,
	        tables: true,
	        breaks: false,
	        pedantic: false,
	        sanitize: false,
	        smartLists: true,
	        smartypants: false
	      });
	      return marked(md);
	    },
	    toHtml: function toHtml() {
	      this.htmlText2 = this.convert(this.mdText2);
	    },
	    toMarkdown: function toMarkdown() {
	      this.mdText1 = _tomarkdown2.default.toMarkdown(this.htmlText1);
	    }
	  }
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(7);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(25);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _qrCodeWithLogo = __webpack_require__(236);
	
	var _qrCodeWithLogo2 = _interopRequireDefault(_qrCodeWithLogo);
	
	var _webqr = __webpack_require__(132);
	
	var _webqr2 = _interopRequireDefault(_webqr);
	
	var _common = __webpack_require__(23);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    menuName: "二维码生成/识别",
	    sort: 100
	  },
	  data: function data() {
	    return {
	      tabItems: [{
	        Name: "generatecode",
	        Title: "二维码生成"
	      }, {
	        Name: "decode",
	        Title: "二维码解码"
	      }],
	      dataList: [],
	      form: {
	        color: "#1aa094",
	        bgcolor: "#ffffff",
	        logoImg: null
	      },
	      dataTxt: "",
	      showMoreBtn: false
	    };
	  },
	  created: function created() {
	    var _this2 = this;
	
	    var self = this;
	    var url = this.$route.query.url;
	    window.webqr = _webqr2.default;
	    if (this.$route.query.type === "decode") {
	      this.tabItems = this.tabItems.reverse();
	    }
	    if (url) {
	      self.dataTxt = decodeURIComponent(this.$route.query.url);
	      self.loadData();
	    } else if ((typeof chrome === "undefined" ? "undefined" : (0, _typeof3.default)(chrome)) != undefined && chrome.tabs) {
	      chrome.tabs.query({ active: true, currentWindow: true }, function (tabs) {
	        var tab = tabs[0];
	        self.dataTxt = tab.url;
	        self.loadData();
	      });
	    } else {
	      self.dataTxt = location.href;
	      self.loadData();
	    }
	    this.$nextTick(function () {
	      layui.jquery("#ewmfile").change(function () {
	        _webqr2.default.handleFiles(this.files);
	      });
	      _this2.pasteInit();
	      _this2.selectDecode();
	      if (_this2.$route.query.type === "decode" && url) {
	        _this2.loadQrImg(url);
	      }
	    });
	  },
	
	  methods: {
	    addItem: function addItem() {
	      this.dataList.splice(0, 0, { text: "", src: "" });
	    },
	    delItem: function delItem(index) {
	      this.dataList.splice(index, 1);
	    },
	    addImage: function addImage(base64) {
	      this.form.logoImg = base64;
	      this.convert();
	    },
	    loadData: function loadData() {
	      var _this3 = this;
	
	      this.dataList = JSON.parse(localStorage.getItem("me_qrcode_list") || "[]").filter(function (s) {
	        return s.text;
	      });
	      if (this.dataList.length === 0) {
	        this.dataList = [{ text: this.dataTxt, src: "" }];
	      }
	      this.form = JSON.parse(localStorage.getItem("me_qrcode_form") || "null") || this.form;
	      this.$nextTick(function () {
	        _this3.convert();
	      });
	    },
	    saveData: function saveData() {
	      localStorage.setItem("me_qrcode_list", (0, _stringify2.default)(this.dataList));
	      localStorage.setItem("me_qrcode_form", (0, _stringify2.default)(this.form));
	      window.layui.layer.msg("保存成功");
	    },
	    convert: function convert() {
	      var list = this.dataList;
	      var color = this.color;
	      var bgcolor = this.bgcolor;
	      var _this = this;
	      list.forEach(function (item, index) {
	        if (!item.text) return;
	        var image = _qrCodeWithLogo2.default.toImage({
	          image: document.getElementById("custom-img-" + (list.length - index)),
	          content: item.text,
	          width: 200,
	
	          nodeQrCodeOptions: {
	            color: {
	              dark: _this.form.color,
	              light: _this.form.bgcolor
	            }
	          }
	        });
	      });
	    },
	    selectDecode: function selectDecode() {
	      _webqr2.default.load("qrfile", 200, 200);
	    },
	    pasteInit: function pasteInit() {
	      document.addEventListener("paste", function (e) {
	        if (!(e.clipboardData && e.clipboardData.items)) {
	          return;
	        }
	        for (var i = 0, len = e.clipboardData.items.length; i < len; i++) {
	          var item = e.clipboardData.items[i];
	          if (item.kind === "string") {
	            item.getAsString(function (str) {});
	          } else if (item.kind === "file") {
	            var pasteFile = item.getAsFile();
	
	            _webqr2.default.handleFiles([pasteFile]);
	          }
	        }
	      });
	    },
	    loadQrImg: function loadQrImg(url) {
	      fetch(url, {
	        method: "get",
	        responseType: "blob"
	      }).then(function (res) {
	        return res.blob();
	      }).then(function (u) {
	        _webqr2.default.handleFiles([u]);
	      });
	    }
	  }
	};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rmbHelper = __webpack_require__(138);
	
	var _rmbHelper2 = _interopRequireDefault(_rmbHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    menuName: '人民币转换',
	    sort: 30
	  },
	  data: function data() {
	    return {
	      tabItems: [{
	        Name: 'main',
	        Title: '人民币转换'
	      }],
	      beforeTxt: '',
	      afterTxt: ''
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    convertDxRmb: function convertDxRmb() {
	      var beforeTxt = this.beforeTxt;
	      this.afterTxt = _rmbHelper2.default.convert(beforeTxt);
	    },
	    convertXxRmb: function convertXxRmb() {
	      var afterTxt = this.afterTxt;
	      this.beforeTxt = _rmbHelper2.default.rmbToNum(afterTxt);
	    }
	  }
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(24);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(7);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    navHide: true,
	    menuName: '设置',
	    sort: 1
	  },
	  data: function data() {
	    return {
	      items: [{
	        Title: '菜单设置',
	        Name: 'menus'
	      }, {
	        Title: '翻译设置',
	        Name: 'fanyi'
	      }],
	      setting: localStorage.CustomSetting || {},
	      menus: [],
	      selectValue: null,
	      menuOptions: [],
	      selectMenu: {},
	      fanyiConfig: {}
	    };
	  },
	  created: function created() {
	    this.fanyiConfig = JSON.parse(localStorage.getItem('fanyi_config') || 'null') || this.fanyiConfig;
	    this.menus = window.siteMenuItems;
	    this.menuOptions = window.siteMenuItems.map(function (e) {
	      return {
	        Text: e.menuName,
	        Value: e.menuUrl
	      };
	    });
	  },
	
	  methods: {
	    changeSelect: function changeSelect(item) {
	      this.selectMenu = this.menus.find(function (e) {
	        return e.menuUrl === item;
	      }) || {};
	    },
	    checkForm: function checkForm() {
	      if (!this.selectMenu.menuName || !this.selectMenu.menuUrl) {
	        window.layui.layer.msg('菜单名称，菜单链接必须填写');
	        return false;
	      }
	      return true;
	    },
	    saveSetting: function saveSetting() {
	      if (!this.checkForm()) return;
	      localStorage.setItem(this.selectMenu.menuUrl, (0, _stringify2.default)((0, _assign2.default)({ sort: 0 }, this.selectMenu)));
	      this.reload();
	    },
	    addCustomMenu: function addCustomMenu() {
	      var _this = this;
	
	      if (!this.checkForm()) return;
	      var customMenus = JSON.parse(localStorage.InsertMenus || '[]');
	      if (customMenus.find(function (e) {
	        return e.menuName === _this.selectMenu.menuName || e.menuUrl === _this.selectMenu.menuUrl;
	      })) {
	        return layui.msg('不能添加重复的名称或Url');
	      }
	      customMenus.push((0, _assign2.default)({ custom: true, sort: 0 }, this.selectMenu));
	      localStorage.setItem('InsertMenus', (0, _stringify2.default)(customMenus));
	      this.reload();
	    },
	    removeCustomMenu: function removeCustomMenu() {
	      var _this2 = this;
	
	      var customMenus = JSON.parse(localStorage.InsertMenus || '[]');
	      customMenus = customMenus.filter(function (e) {
	        return e.menuName !== _this2.selectMenu.menuName && e.menuUrl !== _this2.selectMenu.menuUrl;
	      });
	      localStorage.setItem('InsertMenus', (0, _stringify2.default)(customMenus));
	      localStorage.removeItem(this.selectMenu.menuUrl);
	      this.reload();
	    },
	    reload: function reload() {
	      location.reload();
	    },
	    saveFanyiConfig: function saveFanyiConfig() {
	      localStorage.setItem('fanyi_config', (0, _stringify2.default)(this.fanyiConfig, function (key, value) {
	        if (value !== null && value !== undefined && value !== "") {
	          return value;
	        }
	      }));
	    }
	  }
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(7);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  meta: {
	    menuName: "字符串模板替换",
	    sort: 30
	  },
	  data: function data() {
	    return {
	      tabItems: [{
	        Name: "main",
	        Title: "字符串替换"
	      }],
	      beforeTxt: "",
	      afterTxt: "",
	      selectRule: [""],
	      ruleA: [""],
	      ruleB: [""]
	    };
	  },
	  created: function created() {
	    this.loadData();
	  },
	
	  methods: {
	    replaceTxt: function replaceTxt() {
	      var str = this.beforeTxt;
	      var r1 = this.ruleA;
	      var r2 = this.ruleB;
	
	      for (var i = 0; i < r1.length; i++) {
	        str = str.replace(new RegExp(r1[i], "g"), r2[i]);
	      }
	      this.afterTxt = str;
	    },
	    addRule: function addRule() {
	      this.ruleA.push("");
	      this.ruleB.push("");
	    },
	    removeRule: function removeRule(index) {
	      this.ruleB.splice(index, 1);
	      this.ruleA.splice(index, 1);
	    },
	    saveData: function saveData() {
	      localStorage.setItem("strsplit_beforeTxt", this.beforeTxt);
	      localStorage.setItem("strsplit_afterTxt", this.afterTxt);
	      localStorage.setItem("strsplit_selectRule", (0, _stringify2.default)(this.selectRule));
	      localStorage.setItem("strsplit_ruleA", (0, _stringify2.default)(this.ruleA));
	      localStorage.setItem("strsplit_ruleB", (0, _stringify2.default)(this.ruleB));
	    },
	    loadData: function loadData() {
	      this.beforeTxt = localStorage.getItem("strsplit_beforeTxt");
	      this.afterTxt = localStorage.getItem("strsplit_afterTxt");
	      this.selectRule = JSON.parse(localStorage.getItem("strsplit_selectRule") || "null") || this.selectRule;
	      this.ruleA = JSON.parse(localStorage.getItem("strsplit_ruleA") || "null") || this.ruleA;
	      this.ruleB = JSON.parse(localStorage.getItem("strsplit_ruleB") || "null") || this.ruleB;
	    }
	  }
	};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  meta: {
	    menuName: "图片转base64",
	    sort: 20
	  },
	  data: function data() {
	    return {
	      previewBase64: ""
	    };
	  },
	  mounted: function mounted() {
	    this.pasteInit();
	  },
	
	  methods: {
	    toBase64: function toBase64(base64) {
	      this.previewBase64 = base64;
	    },
	    pasteInit: function pasteInit() {
	      var _this = this;
	      document.addEventListener("paste", function (e) {
	        if (!(e.clipboardData && e.clipboardData.items)) {
	          return;
	        }
	        for (var i = 0, len = e.clipboardData.items.length; i < len; i++) {
	          var item = e.clipboardData.items[i];
	          if (item.kind === "string") {
	            item.getAsString(function (str) {});
	          } else if (item.kind === "file") {
	            var pasteFile = item.getAsFile();
	
	            var reader = new FileReader();
	            reader.readAsDataURL(pasteFile);
	            reader.onload = function (e) {
	              _this.toBase64(e.target.result);
	            };
	          }
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(7);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(24);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _common = __webpack_require__(23);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _thirtyTwo = __webpack_require__(272);
	
	var _thirtyTwo2 = _interopRequireDefault(_thirtyTwo);
	
	var _jssha = __webpack_require__(233);
	
	var _jssha2 = _interopRequireDefault(_jssha);
	
	var _clipboard = __webpack_require__(151);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var btnCopy = void 0;
	exports.default = {
	  meta: {
	    menuName: '双重验证器',
	    sort: 10
	  },
	  data: function data() {
	    return {
	      tabItems: [{
	        Name: 'twostepvalidation',
	        Title: '双重验证器'
	      }],
	      dataList: [],
	      showMoreBtn: false
	    };
	  },
	  created: function created() {
	    var self = this;
	    self.loadData();
	    if (!btnCopy) {
	      btnCopy = new _clipboard2.default('.btn-copy');
	      btnCopy.on('success', function (e) {
	        layer.msg('复制成功:' + e.text);
	        e.clearSelection();
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    layer.closeAll();
	  },
	
	  methods: {
	    addItem: function addItem() {
	      this.dataList.splice(0, 0, { text: '', title: '', code: '' });
	    },
	    delItem: function delItem(index) {
	      this.dataList.splice(index, 1);
	    },
	    loadData: function loadData() {
	      var _this = this;
	
	      this.dataList = JSON.parse(localStorage.getItem('me_twostepvalidation_list') || '[]').filter(function (s) {
	        return s.text;
	      }).map(function (s) {
	        return (0, _assign2.default)(s, { code: _this.genOTP(s.text) });
	      });
	      if (this.dataList.length === 0) {
	        this.dataList = [{ text: '', title: '', code: '' }];
	      }
	    },
	    saveData: function saveData() {
	      localStorage.setItem('me_twostepvalidation_list', (0, _stringify2.default)(this.dataList));
	      window.layui.layer.msg('保存成功');
	    },
	    genCode: function genCode(item) {
	      var code = this.genOTP(item.text);
	      item.code = code;
	    },
	    genOTP: function genOTP(key) {
	      var timeStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
	      var t0 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      var movingFactor = Math.floor((Date.now() / 1000 - t0) / timeStep);
	      var hmacSha = new _jssha2.default('SHA-1', 'BYTES');
	      hmacSha.setHMACKey(_thirtyTwo2.default.decode(key).toString(), 'BYTES');
	
	      var factorByte = this._factor2ByteText(movingFactor);
	      hmacSha.update(factorByte);
	
	      var hmac_result = hmacSha.getHMAC('BYTES');
	      return this._truncat(hmac_result);
	    },
	    _truncat: function _truncat(hmac_result) {
	      var digit = 6;
	      var offset = hmac_result[19].charCodeAt() & 0xf;
	      var bin_code = (hmac_result[offset].charCodeAt() & 0x7f) << 24 | (hmac_result[offset + 1].charCodeAt() & 0xff) << 16 | (hmac_result[offset + 2].charCodeAt() & 0xff) << 8 | hmac_result[offset + 3].charCodeAt() & 0xff;
	      var otp = (bin_code % Math.pow(10, digit)).toString();
	      while (otp.length < digit) {
	        otp = '0' + otp;
	      }
	      return otp;
	    },
	    _factor2ByteText: function _factor2ByteText(movingFactor) {
	      var text = new Array(8);
	      for (var i = text.length - 1; i >= 0; i--) {
	        text[i] = String.fromCharCode(movingFactor & 0xff);
	        movingFactor >>= 8;
	      }
	      return text.join('');
	    }
	  }
	};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getQrcode();
	
	
	function getQrcode() {
		var _aa = {};
		_aa._ab = function (f, e) {
			var d = qrcode.width;
			var b = qrcode.height;
			var c = true;
			for (var g = 0; g < e.length && c; g += 2) {
				var a = Math.floor(e[g]);
				var h = Math.floor(e[g + 1]);
				if (a < -1 || a > d || h < -1 || h > b) {
					throw "Error._ab ";
				}
				c = false;
				if (a == -1) {
					e[g] = 0;
					c = true;
				} else {
					if (a == d) {
						e[g] = d - 1;
						c = true;
					}
				}
				if (h == -1) {
					e[g + 1] = 0;
					c = true;
				} else {
					if (h == b) {
						e[g + 1] = b - 1;
						c = true;
					}
				}
			}
			c = true;
			for (var g = e.length - 2; g >= 0 && c; g -= 2) {
				var a = Math.floor(e[g]);
				var h = Math.floor(e[g + 1]);
				if (a < -1 || a > d || h < -1 || h > b) {
					throw "Error._ab ";
				}
				c = false;
				if (a == -1) {
					e[g] = 0;
					c = true;
				} else {
					if (a == d) {
						e[g] = d - 1;
						c = true;
					}
				}
				if (h == -1) {
					e[g + 1] = 0;
					c = true;
				} else {
					if (h == b) {
						e[g + 1] = b - 1;
						c = true;
					}
				}
			}
		};
		_aa._af = function (b, d, a) {
			var l = new _ac(d);
			var k = new Array(d << 1);
			for (var g = 0; g < d; g++) {
				var h = k.length;
				var j = g + 0.5;
				for (var i = 0; i < h; i += 2) {
					k[i] = (i >> 1) + 0.5;
					k[i + 1] = j;
				}
				a._ad(k);
				_aa._ab(b, k);
				try {
					for (var i = 0; i < h; i += 2) {
						var e = Math.floor(k[i]) * 4 + Math.floor(k[i + 1]) * qrcode.width * 4;
						var f = b[Math.floor(k[i]) + qrcode.width * Math.floor(k[i + 1])];
						qrcode.imagedata.data[e] = f ? 255 : 0;
						qrcode.imagedata.data[e + 1] = f ? 255 : 0;
						qrcode.imagedata.data[e + 2] = 0;
						qrcode.imagedata.data[e + 3] = 255;
						if (f) {
							l._dq(i >> 1, g);
						}
					}
				} catch (c) {
					throw "Error._ab";
				}
			}
			return l;
		};
		_aa._ah = function (h, o, l, k, r, q, b, a, f, e, n, m, t, s, d, c, j, i) {
			var g = _ae._ag(l, k, r, q, b, a, f, e, n, m, t, s, d, c, j, i);
			return _aa._af(h, o, g);
		};
	
		function _a1(b, a) {
			this.count = b;
			this._fc = a;
			this.__defineGetter__("Count", function () {
				return this.count;
			});
			this.__defineGetter__("_dm", function () {
				return this._fc;
			});
		}
		function _a2(a, c, b) {
			this._bm = a;
			if (b) {
				this._do = new Array(c, b);
			} else {
				this._do = new Array(c);
			}
			this.__defineGetter__("_bo", function () {
				return this._bm;
			});
			this.__defineGetter__("_dn", function () {
				return this._bm * this._fo;
			});
			this.__defineGetter__("_fo", function () {
				var e = 0;
				for (var d = 0; d < this._do.length; d++) {
					e += this._do[d].length;
				}
				return e;
			});
			this._fb = function () {
				return this._do;
			};
		}
		function _a3(k, l, h, g, f, e) {
			this._bs = k;
			this._ar = l;
			this._do = new Array(h, g, f, e);
			var j = 0;
			var b = h._bo;
			var a = h._fb();
			for (var d = 0; d < a.length; d++) {
				var c = a[d];
				j += c.Count * (c._dm + b);
			}
			this._br = j;
			this.__defineGetter__("_fd", function () {
				return this._bs;
			});
			this.__defineGetter__("_as", function () {
				return this._ar;
			});
			this.__defineGetter__("_dp", function () {
				return this._br;
			});
			this.__defineGetter__("_cr", function () {
				return 17 + 4 * this._bs;
			});
			this._aq = function () {
				var r = this._cr;
				var o = new _ac(r);
				o._bq(0, 0, 9, 9);
				o._bq(r - 8, 0, 8, 9);
				o._bq(0, r - 8, 9, 8);
				var n = this._ar.length;
				for (var m = 0; m < n; m++) {
					var q = this._ar[m] - 2;
					for (var s = 0; s < n; s++) {
						if (m == 0 && (s == 0 || s == n - 1) || m == n - 1 && s == 0) {
							continue;
						}
						o._bq(this._ar[s] - 2, q, 5, 5);
					}
				}
				o._bq(6, 9, 1, r - 17);
				o._bq(9, 6, r - 17, 1);
				if (this._bs > 6) {
					o._bq(r - 11, 0, 3, 6);
					o._bq(0, r - 11, 6, 3);
				}
				return o;
			};
			this._bu = function (i) {
				return this._do[i.ordinal()];
			};
		}
		_a3._bv = new Array(31892, 34236, 39577, 42195, 48118, 51042, 55367, 58893, 63784, 68472, 70749, 76311, 79154, 84390, 87683, 92361, 96236, 102084, 102881, 110507, 110734, 117786, 119615, 126325, 127568, 133589, 136944, 141498, 145311, 150283, 152622, 158308, 161089, 167017);
		_a3.VERSIONS = _ay();
		_a3._av = function (a) {
			if (a < 1 || a > 40) {
				throw "bad arguments";
			}
			return _a3.VERSIONS[a - 1];
		};
		_a3._at = function (b) {
			if (b % 4 != 1) {
				throw "Error _at";
			}
			try {
				return _a3._av(b - 17 >> 2);
			} catch (a) {
				throw "Error _av";
			}
		};
		_a3._aw = function (d) {
			var b = 4294967295;
			var f = 0;
			for (var c = 0; c < _a3._bv.length; c++) {
				var a = _a3._bv[c];
				if (a == d) {
					return this._av(c + 7);
				}
				var e = _ax._gj(d, a);
				if (e < b) {
					f = c + 7;
					b = e;
				}
			}
			if (b <= 3) {
				return this._av(f);
			}
			return null;
		};
	
		function _ay() {
			return new Array(new _a3(1, new Array(), new _a2(7, new _a1(1, 19)), new _a2(10, new _a1(1, 16)), new _a2(13, new _a1(1, 13)), new _a2(17, new _a1(1, 9))), new _a3(2, new Array(6, 18), new _a2(10, new _a1(1, 34)), new _a2(16, new _a1(1, 28)), new _a2(22, new _a1(1, 22)), new _a2(28, new _a1(1, 16))), new _a3(3, new Array(6, 22), new _a2(15, new _a1(1, 55)), new _a2(26, new _a1(1, 44)), new _a2(18, new _a1(2, 17)), new _a2(22, new _a1(2, 13))), new _a3(4, new Array(6, 26), new _a2(20, new _a1(1, 80)), new _a2(18, new _a1(2, 32)), new _a2(26, new _a1(2, 24)), new _a2(16, new _a1(4, 9))), new _a3(5, new Array(6, 30), new _a2(26, new _a1(1, 108)), new _a2(24, new _a1(2, 43)), new _a2(18, new _a1(2, 15), new _a1(2, 16)), new _a2(22, new _a1(2, 11), new _a1(2, 12))), new _a3(6, new Array(6, 34), new _a2(18, new _a1(2, 68)), new _a2(16, new _a1(4, 27)), new _a2(24, new _a1(4, 19)), new _a2(28, new _a1(4, 15))), new _a3(7, new Array(6, 22, 38), new _a2(20, new _a1(2, 78)), new _a2(18, new _a1(4, 31)), new _a2(18, new _a1(2, 14), new _a1(4, 15)), new _a2(26, new _a1(4, 13), new _a1(1, 14))), new _a3(8, new Array(6, 24, 42), new _a2(24, new _a1(2, 97)), new _a2(22, new _a1(2, 38), new _a1(2, 39)), new _a2(22, new _a1(4, 18), new _a1(2, 19)), new _a2(26, new _a1(4, 14), new _a1(2, 15))), new _a3(9, new Array(6, 26, 46), new _a2(30, new _a1(2, 116)), new _a2(22, new _a1(3, 36), new _a1(2, 37)), new _a2(20, new _a1(4, 16), new _a1(4, 17)), new _a2(24, new _a1(4, 12), new _a1(4, 13))), new _a3(10, new Array(6, 28, 50), new _a2(18, new _a1(2, 68), new _a1(2, 69)), new _a2(26, new _a1(4, 43), new _a1(1, 44)), new _a2(24, new _a1(6, 19), new _a1(2, 20)), new _a2(28, new _a1(6, 15), new _a1(2, 16))), new _a3(11, new Array(6, 30, 54), new _a2(20, new _a1(4, 81)), new _a2(30, new _a1(1, 50), new _a1(4, 51)), new _a2(28, new _a1(4, 22), new _a1(4, 23)), new _a2(24, new _a1(3, 12), new _a1(8, 13))), new _a3(12, new Array(6, 32, 58), new _a2(24, new _a1(2, 92), new _a1(2, 93)), new _a2(22, new _a1(6, 36), new _a1(2, 37)), new _a2(26, new _a1(4, 20), new _a1(6, 21)), new _a2(28, new _a1(7, 14), new _a1(4, 15))), new _a3(13, new Array(6, 34, 62), new _a2(26, new _a1(4, 107)), new _a2(22, new _a1(8, 37), new _a1(1, 38)), new _a2(24, new _a1(8, 20), new _a1(4, 21)), new _a2(22, new _a1(12, 11), new _a1(4, 12))), new _a3(14, new Array(6, 26, 46, 66), new _a2(30, new _a1(3, 115), new _a1(1, 116)), new _a2(24, new _a1(4, 40), new _a1(5, 41)), new _a2(20, new _a1(11, 16), new _a1(5, 17)), new _a2(24, new _a1(11, 12), new _a1(5, 13))), new _a3(15, new Array(6, 26, 48, 70), new _a2(22, new _a1(5, 87), new _a1(1, 88)), new _a2(24, new _a1(5, 41), new _a1(5, 42)), new _a2(30, new _a1(5, 24), new _a1(7, 25)), new _a2(24, new _a1(11, 12), new _a1(7, 13))), new _a3(16, new Array(6, 26, 50, 74), new _a2(24, new _a1(5, 98), new _a1(1, 99)), new _a2(28, new _a1(7, 45), new _a1(3, 46)), new _a2(24, new _a1(15, 19), new _a1(2, 20)), new _a2(30, new _a1(3, 15), new _a1(13, 16))), new _a3(17, new Array(6, 30, 54, 78), new _a2(28, new _a1(1, 107), new _a1(5, 108)), new _a2(28, new _a1(10, 46), new _a1(1, 47)), new _a2(28, new _a1(1, 22), new _a1(15, 23)), new _a2(28, new _a1(2, 14), new _a1(17, 15))), new _a3(18, new Array(6, 30, 56, 82), new _a2(30, new _a1(5, 120), new _a1(1, 121)), new _a2(26, new _a1(9, 43), new _a1(4, 44)), new _a2(28, new _a1(17, 22), new _a1(1, 23)), new _a2(28, new _a1(2, 14), new _a1(19, 15))), new _a3(19, new Array(6, 30, 58, 86), new _a2(28, new _a1(3, 113), new _a1(4, 114)), new _a2(26, new _a1(3, 44), new _a1(11, 45)), new _a2(26, new _a1(17, 21), new _a1(4, 22)), new _a2(26, new _a1(9, 13), new _a1(16, 14))), new _a3(20, new Array(6, 34, 62, 90), new _a2(28, new _a1(3, 107), new _a1(5, 108)), new _a2(26, new _a1(3, 41), new _a1(13, 42)), new _a2(30, new _a1(15, 24), new _a1(5, 25)), new _a2(28, new _a1(15, 15), new _a1(10, 16))), new _a3(21, new Array(6, 28, 50, 72, 94), new _a2(28, new _a1(4, 116), new _a1(4, 117)), new _a2(26, new _a1(17, 42)), new _a2(28, new _a1(17, 22), new _a1(6, 23)), new _a2(30, new _a1(19, 16), new _a1(6, 17))), new _a3(22, new Array(6, 26, 50, 74, 98), new _a2(28, new _a1(2, 111), new _a1(7, 112)), new _a2(28, new _a1(17, 46)), new _a2(30, new _a1(7, 24), new _a1(16, 25)), new _a2(24, new _a1(34, 13))), new _a3(23, new Array(6, 30, 54, 74, 102), new _a2(30, new _a1(4, 121), new _a1(5, 122)), new _a2(28, new _a1(4, 47), new _a1(14, 48)), new _a2(30, new _a1(11, 24), new _a1(14, 25)), new _a2(30, new _a1(16, 15), new _a1(14, 16))), new _a3(24, new Array(6, 28, 54, 80, 106), new _a2(30, new _a1(6, 117), new _a1(4, 118)), new _a2(28, new _a1(6, 45), new _a1(14, 46)), new _a2(30, new _a1(11, 24), new _a1(16, 25)), new _a2(30, new _a1(30, 16), new _a1(2, 17))), new _a3(25, new Array(6, 32, 58, 84, 110), new _a2(26, new _a1(8, 106), new _a1(4, 107)), new _a2(28, new _a1(8, 47), new _a1(13, 48)), new _a2(30, new _a1(7, 24), new _a1(22, 25)), new _a2(30, new _a1(22, 15), new _a1(13, 16))), new _a3(26, new Array(6, 30, 58, 86, 114), new _a2(28, new _a1(10, 114), new _a1(2, 115)), new _a2(28, new _a1(19, 46), new _a1(4, 47)), new _a2(28, new _a1(28, 22), new _a1(6, 23)), new _a2(30, new _a1(33, 16), new _a1(4, 17))), new _a3(27, new Array(6, 34, 62, 90, 118), new _a2(30, new _a1(8, 122), new _a1(4, 123)), new _a2(28, new _a1(22, 45), new _a1(3, 46)), new _a2(30, new _a1(8, 23), new _a1(26, 24)), new _a2(30, new _a1(12, 15), new _a1(28, 16))), new _a3(28, new Array(6, 26, 50, 74, 98, 122), new _a2(30, new _a1(3, 117), new _a1(10, 118)), new _a2(28, new _a1(3, 45), new _a1(23, 46)), new _a2(30, new _a1(4, 24), new _a1(31, 25)), new _a2(30, new _a1(11, 15), new _a1(31, 16))), new _a3(29, new Array(6, 30, 54, 78, 102, 126), new _a2(30, new _a1(7, 116), new _a1(7, 117)), new _a2(28, new _a1(21, 45), new _a1(7, 46)), new _a2(30, new _a1(1, 23), new _a1(37, 24)), new _a2(30, new _a1(19, 15), new _a1(26, 16))), new _a3(30, new Array(6, 26, 52, 78, 104, 130), new _a2(30, new _a1(5, 115), new _a1(10, 116)), new _a2(28, new _a1(19, 47), new _a1(10, 48)), new _a2(30, new _a1(15, 24), new _a1(25, 25)), new _a2(30, new _a1(23, 15), new _a1(25, 16))), new _a3(31, new Array(6, 30, 56, 82, 108, 134), new _a2(30, new _a1(13, 115), new _a1(3, 116)), new _a2(28, new _a1(2, 46), new _a1(29, 47)), new _a2(30, new _a1(42, 24), new _a1(1, 25)), new _a2(30, new _a1(23, 15), new _a1(28, 16))), new _a3(32, new Array(6, 34, 60, 86, 112, 138), new _a2(30, new _a1(17, 115)), new _a2(28, new _a1(10, 46), new _a1(23, 47)), new _a2(30, new _a1(10, 24), new _a1(35, 25)), new _a2(30, new _a1(19, 15), new _a1(35, 16))), new _a3(33, new Array(6, 30, 58, 86, 114, 142), new _a2(30, new _a1(17, 115), new _a1(1, 116)), new _a2(28, new _a1(14, 46), new _a1(21, 47)), new _a2(30, new _a1(29, 24), new _a1(19, 25)), new _a2(30, new _a1(11, 15), new _a1(46, 16))), new _a3(34, new Array(6, 34, 62, 90, 118, 146), new _a2(30, new _a1(13, 115), new _a1(6, 116)), new _a2(28, new _a1(14, 46), new _a1(23, 47)), new _a2(30, new _a1(44, 24), new _a1(7, 25)), new _a2(30, new _a1(59, 16), new _a1(1, 17))), new _a3(35, new Array(6, 30, 54, 78, 102, 126, 150), new _a2(30, new _a1(12, 121), new _a1(7, 122)), new _a2(28, new _a1(12, 47), new _a1(26, 48)), new _a2(30, new _a1(39, 24), new _a1(14, 25)), new _a2(30, new _a1(22, 15), new _a1(41, 16))), new _a3(36, new Array(6, 24, 50, 76, 102, 128, 154), new _a2(30, new _a1(6, 121), new _a1(14, 122)), new _a2(28, new _a1(6, 47), new _a1(34, 48)), new _a2(30, new _a1(46, 24), new _a1(10, 25)), new _a2(30, new _a1(2, 15), new _a1(64, 16))), new _a3(37, new Array(6, 28, 54, 80, 106, 132, 158), new _a2(30, new _a1(17, 122), new _a1(4, 123)), new _a2(28, new _a1(29, 46), new _a1(14, 47)), new _a2(30, new _a1(49, 24), new _a1(10, 25)), new _a2(30, new _a1(24, 15), new _a1(46, 16))), new _a3(38, new Array(6, 32, 58, 84, 110, 136, 162), new _a2(30, new _a1(4, 122), new _a1(18, 123)), new _a2(28, new _a1(13, 46), new _a1(32, 47)), new _a2(30, new _a1(48, 24), new _a1(14, 25)), new _a2(30, new _a1(42, 15), new _a1(32, 16))), new _a3(39, new Array(6, 26, 54, 82, 110, 138, 166), new _a2(30, new _a1(20, 117), new _a1(4, 118)), new _a2(28, new _a1(40, 47), new _a1(7, 48)), new _a2(30, new _a1(43, 24), new _a1(22, 25)), new _a2(30, new _a1(10, 15), new _a1(67, 16))), new _a3(40, new Array(6, 30, 58, 86, 114, 142, 170), new _a2(30, new _a1(19, 118), new _a1(6, 119)), new _a2(28, new _a1(18, 47), new _a1(31, 48)), new _a2(30, new _a1(34, 24), new _a1(34, 25)), new _a2(30, new _a1(20, 15), new _a1(61, 16))));
		}
		function _ae(i, f, c, h, e, b, g, d, a) {
			this.a11 = i;
			this.a12 = h;
			this.a13 = g;
			this.a21 = f;
			this.a22 = e;
			this.a23 = d;
			this.a31 = c;
			this.a32 = b;
			this.a33 = a;
			this._ad = function (w) {
				var t = w.length;
				var A = this.a11;
				var z = this.a12;
				var v = this.a13;
				var r = this.a21;
				var q = this.a22;
				var o = this.a23;
				var m = this.a31;
				var k = this.a32;
				var j = this.a33;
				for (var n = 0; n < t; n += 2) {
					var u = w[n];
					var s = w[n + 1];
					var l = v * u + o * s + j;
					w[n] = (A * u + r * s + m) / l;
					w[n + 1] = (z * u + q * s + k) / l;
				}
			};
			this._fp = function (m, k) {
				var r = m.length;
				for (var l = 0; l < r; l++) {
					var j = m[l];
					var q = k[l];
					var o = this.a13 * j + this.a23 * q + this.a33;
					m[l] = (this.a11 * j + this.a21 * q + this.a31) / o;
					k[l] = (this.a12 * j + this.a22 * q + this.a32) / o;
				}
			};
			this._fr = function () {
				return new _ae(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
			};
			this.times = function (j) {
				return new _ae(this.a11 * j.a11 + this.a21 * j.a12 + this.a31 * j.a13, this.a11 * j.a21 + this.a21 * j.a22 + this.a31 * j.a23, this.a11 * j.a31 + this.a21 * j.a32 + this.a31 * j.a33, this.a12 * j.a11 + this.a22 * j.a12 + this.a32 * j.a13, this.a12 * j.a21 + this.a22 * j.a22 + this.a32 * j.a23, this.a12 * j.a31 + this.a22 * j.a32 + this.a32 * j.a33, this.a13 * j.a11 + this.a23 * j.a12 + this.a33 * j.a13, this.a13 * j.a21 + this.a23 * j.a22 + this.a33 * j.a23, this.a13 * j.a31 + this.a23 * j.a32 + this.a33 * j.a33);
			};
		}
		_ae._ag = function (q, e, o, d, n, c, m, b, h, r, l, f, a, j, i, s) {
			var g = this._be(q, e, o, d, n, c, m, b);
			var k = this._bf(h, r, l, f, a, j, i, s);
			return k.times(g);
		};
		_ae._bf = function (f, h, d, g, b, e, a, c) {
			var dy2 = c - e;
			var dy3 = h - g + e - c;
			if (dy2 == 0 && dy3 == 0) {
				return new _ae(d - f, b - d, f, g - h, e - g, h, 0, 0, 1);
			} else {
				var dx1 = d - b;
				var dx2 = a - b;
				var dx3 = f - d + b - a;
				var dy1 = g - e;
				var _dr = dx1 * dy2 - dx2 * dy1;
				var a13 = (dx3 * dy2 - dx2 * dy3) / _dr;
				var a23 = (dx1 * dy3 - dx3 * dy1) / _dr;
				return new _ae(d - f + a13 * d, a - f + a23 * a, f, g - h + a13 * g, c - h + a23 * c, h, a13, a23, 1);
			}
		};
		_ae._be = function (f, h, d, g, b, e, a, c) {
			return this._bf(f, h, d, g, b, e, a, c)._fr();
		};
	
		function _bg(b, a) {
			this.bits = b;
			this.points = a;
		}
		function Detector(a) {
			this.image = a;
			this._am = null;
			this._bi = function (m, l, c, b) {
				var d = Math.abs(b - l) > Math.abs(c - m);
				if (d) {
					var s = m;
					m = l;
					l = s;
					s = c;
					c = b;
					b = s;
				}
				var j = Math.abs(c - m);
				var i = Math.abs(b - l);
				var q = -j >> 1;
				var v = l < b ? 1 : -1;
				var f = m < c ? 1 : -1;
				var e = 0;
				for (var h = m, g = l; h != c; h += f) {
					var u = d ? g : h;
					var t = d ? h : g;
					if (e == 1) {
						if (this.image[u + t * qrcode.width]) {
							e++;
						}
					} else {
						if (!this.image[u + t * qrcode.width]) {
							e++;
						}
					}
					if (e == 3) {
						var o = h - m;
						var n = g - l;
						return Math.sqrt(o * o + n * n);
					}
					q += i;
					if (q > 0) {
						if (g == b) {
							break;
						}
						g += v;
						q -= j;
					}
				}
				var k = c - m;
				var r = b - l;
				return Math.sqrt(k * k + r * r);
			};
			this._bh = function (i, g, h, f) {
				var b = this._bi(i, g, h, f);
				var e = 1;
				var d = i - (h - i);
				if (d < 0) {
					e = i / (i - d);
					d = 0;
				} else {
					if (d >= qrcode.width) {
						e = (qrcode.width - 1 - i) / (d - i);
						d = qrcode.width - 1;
					}
				}
				var c = Math.floor(g - (f - g) * e);
				e = 1;
				if (c < 0) {
					e = g / (g - c);
					c = 0;
				} else {
					if (c >= qrcode.height) {
						e = (qrcode.height - 1 - g) / (c - g);
						c = qrcode.height - 1;
					}
				}
				d = Math.floor(i + (d - i) * e);
				b += this._bi(i, g, d, c);
				return b - 1;
			};
			this._bj = function (c, d) {
				var b = this._bh(Math.floor(c.X), Math.floor(c.Y), Math.floor(d.X), Math.floor(d.Y));
				var e = this._bh(Math.floor(d.X), Math.floor(d.Y), Math.floor(c.X), Math.floor(c.Y));
				if (isNaN(b)) {
					return e / 7;
				}
				if (isNaN(e)) {
					return b / 7;
				}
				return (b + e) / 14;
			};
			this._bk = function (d, c, b) {
				return (this._bj(d, c) + this._bj(d, b)) / 2;
			};
			this.distance = function (c, b) {
				var xDiff = c.X - b.X;
				var yDiff = c.Y - b.Y;
				return Math.sqrt(xDiff * xDiff + yDiff * yDiff);
			};
			this._bx = function (g, f, d, e) {
				var b = Math.round(this.distance(g, f) / e);
				var c = Math.round(this.distance(g, d) / e);
				var h = (b + c >> 1) + 7;
				switch (h & 3) {
					case 0:
						h++;
						break;
					case 2:
						h--;
						break;
					case 3:
						throw "Error";
				}
				return h;
			};
			this._bl = function (g, f, d, j) {
				var k = Math.floor(j * g);
				var h = Math.max(0, f - k);
				var i = Math.min(qrcode.width - 1, f + k);
				if (i - h < g * 3) {
					throw "Error";
				}
				var b = Math.max(0, d - k);
				var c = Math.min(qrcode.height - 1, d + k);
				var e = new _ak(this.image, h, b, i - h, c - b, g, this._am);
				return e.find();
			};
			this.createTransform = function (l, h, k, b, g) {
				var j = g - 3.5;
				var i;
				var f;
				var e;
				var c;
				if (b != null) {
					i = b.X;
					f = b.Y;
					e = c = j - 3;
				} else {
					i = h.X - l.X + k.X;
					f = h.Y - l.Y + k.Y;
					e = c = j;
				}
				var d = _ae._ag(3.5, 3.5, j, 3.5, e, c, 3.5, j, l.X, l.Y, h.X, h.Y, i, f, k.X, k.Y);
				return d;
			};
			this._bz = function (e, b, d) {
				var c = _aa;
				return c._af(e, d, b);
			};
			this._cd = function (r) {
				var j = r._gq;
				var h = r._gs;
				var n = r._gp;
				var d = this._bk(j, h, n);
				if (d < 1) {
					throw "Error";
				}
				var s = this._bx(j, h, n, d);
				var b = _a3._at(s);
				var k = b._cr - 7;
				var l = null;
				if (b._as.length > 0) {
					var f = h.X - j.X + n.X;
					var e = h.Y - j.Y + n.Y;
					var c = 1 - 3 / k;
					var u = Math.floor(j.X + c * (f - j.X));
					var t = Math.floor(j.Y + c * (e - j.Y));
					for (var q = 4; q <= 16; q <<= 1) {
						l = this._bl(d, u, t, q);
						break;
					}
				}
				var g = this.createTransform(j, h, n, l, s);
				var m = this._bz(this.image, g, s);
				var o;
				if (l == null) {
					o = new Array(n, j, h);
				} else {
					o = new Array(n, j, h, l);
				}
				return new _bg(m, o);
			};
			this.detect = function () {
				var b = new _cc()._ce(this.image);
				return this._cd(b);
			};
		}
		var _ca = 21522;
		var _cb = new Array(new Array(21522, 0), new Array(20773, 1), new Array(24188, 2), new Array(23371, 3), new Array(17913, 4), new Array(16590, 5), new Array(20375, 6), new Array(19104, 7), new Array(30660, 8), new Array(29427, 9), new Array(32170, 10), new Array(30877, 11), new Array(26159, 12), new Array(25368, 13), new Array(27713, 14), new Array(26998, 15), new Array(5769, 16), new Array(5054, 17), new Array(7399, 18), new Array(6608, 19), new Array(1890, 20), new Array(597, 21), new Array(3340, 22), new Array(2107, 23), new Array(13663, 24), new Array(12392, 25), new Array(16177, 26), new Array(14854, 27), new Array(9396, 28), new Array(8579, 29), new Array(11994, 30), new Array(11245, 31));
		var _ch = new Array(0, 1, 1, 2, 1, 2, 2, 3, 1, 2, 2, 3, 2, 3, 3, 4);
	
		function _ax(a) {
			this._cf = _cg.forBits(a >> 3 & 3);
			this._fe = a & 7;
			this.__defineGetter__("_cg", function () {
				return this._cf;
			});
			this.__defineGetter__("_dx", function () {
				return this._fe;
			});
			this.GetHashCode = function () {
				return this._cf.ordinal() << 3 | _fe;
			};
			this.Equals = function (c) {
				var b = c;
				return this._cf == b._cf && this._fe == b._fe;
			};
		}
		_ax._gj = function (d, c) {
			d ^= c;
			return _ch[d & 15] + _ch[_ew(d, 4) & 15] + _ch[_ew(d, 8) & 15] + _ch[_ew(d, 12) & 15] + _ch[_ew(d, 16) & 15] + _ch[_ew(d, 20) & 15] + _ch[_ew(d, 24) & 15] + _ch[_ew(d, 28) & 15];
		};
		_ax._ci = function (a) {
			var b = _ax._cj(a);
			if (b != null) {
				return b;
			}
			return _ax._cj(a ^ _ca);
		};
		_ax._cj = function (d) {
			var b = 4294967295;
			var a = 0;
			for (var c = 0; c < _cb.length; c++) {
				var g = _cb[c];
				var f = g[0];
				if (f == d) {
					return new _ax(g[1]);
				}
				var e = this._gj(d, f);
				if (e < b) {
					a = g[1];
					b = e;
				}
			}
			if (b <= 3) {
				return new _ax(a);
			}
			return null;
		};
	
		function _cg(a, c, b) {
			this._ff = a;
			this.bits = c;
			this.name = b;
			this.__defineGetter__("Bits", function () {
				return this.bits;
			});
			this.__defineGetter__("Name", function () {
				return this.name;
			});
			this.ordinal = function () {
				return this._ff;
			};
		}
		_cg.forBits = function (a) {
			if (a < 0 || a >= FOR_BITS.length) {
				throw "bad arguments";
			}
			return FOR_BITS[a];
		};
		var L = new _cg(0, 1, "L");
		var M = new _cg(1, 0, "M");
		var Q = new _cg(2, 3, "Q");
		var H = new _cg(3, 2, "H");
		var FOR_BITS = new Array(M, L, H, Q);
	
		function _ac(d, a) {
			if (!a) {
				a = d;
			}
			if (d < 1 || a < 1) {
				throw "Both dimensions must be greater than 0";
			}
			this.width = d;
			this.height = a;
			var c = d >> 5;
			if ((d & 31) != 0) {
				c++;
			}
			this.rowSize = c;
			this.bits = new Array(c * a);
			for (var b = 0; b < this.bits.length; b++) {
				this.bits[b] = 0;
			}
			this.__defineGetter__("Width", function () {
				return this.width;
			});
			this.__defineGetter__("Height", function () {
				return this.height;
			});
			this.__defineGetter__("Dimension", function () {
				if (this.width != this.height) {
					throw "Can't call getDimension() on a non-square matrix";
				}
				return this.width;
			});
			this._ds = function (e, g) {
				var f = g * this.rowSize + (e >> 5);
				return (_ew(this.bits[f], e & 31) & 1) != 0;
			};
			this._dq = function (e, g) {
				var f = g * this.rowSize + (e >> 5);
				this.bits[f] |= 1 << (e & 31);
			};
			this.flip = function (e, g) {
				var f = g * this.rowSize + (e >> 5);
				this.bits[f] ^= 1 << (e & 31);
			};
			this.clear = function () {
				var e = this.bits.length;
				for (var f = 0; f < e; f++) {
					this.bits[f] = 0;
				}
			};
			this._bq = function (g, j, f, m) {
				if (j < 0 || g < 0) {
					throw "Left and top must be nonnegative";
				}
				if (m < 1 || f < 1) {
					throw "Height and width must be at least 1";
				}
				var l = g + f;
				var e = j + m;
				if (e > this.height || l > this.width) {
					throw "The region must fit inside the matrix";
				}
				for (var i = j; i < e; i++) {
					var h = i * this.rowSize;
					for (var k = g; k < l; k++) {
						this.bits[h + (k >> 5)] |= 1 << (k & 31);
					}
				}
			};
		}
		function _dl(a, b) {
			this._dv = a;
			this._dw = b;
			this.__defineGetter__("_du", function () {
				return this._dv;
			});
			this.__defineGetter__("Codewords", function () {
				return this._dw;
			});
		}
		_dl._gn = function (c, h, s) {
			if (c.length != h._dp) {
				throw "bad arguments";
			}
			var k = h._bu(s);
			var e = 0;
			var d = k._fb();
			for (var r = 0; r < d.length; r++) {
				e += d[r].Count;
			}
			var l = new Array(e);
			var n = 0;
			for (var o = 0; o < d.length; o++) {
				var f = d[o];
				for (var r = 0; r < f.Count; r++) {
					var m = f._dm;
					var t = k._bo + m;
					l[n++] = new _dl(m, new Array(t));
				}
			}
			var u = l[0]._dw.length;
			var b = l.length - 1;
			while (b >= 0) {
				var w = l[b]._dw.length;
				if (w == u) {
					break;
				}
				b--;
			}
			b++;
			var g = u - k._bo;
			var a = 0;
			for (var r = 0; r < g; r++) {
				for (var o = 0; o < n; o++) {
					l[o]._dw[r] = c[a++];
				}
			}
			for (var o = b; o < n; o++) {
				l[o]._dw[g] = c[a++];
			}
			var q = l[0]._dw.length;
			for (var r = g; r < q; r++) {
				for (var o = 0; o < n; o++) {
					var v = o < b ? r : r + 1;
					l[o]._dw[v] = c[a++];
				}
			}
			return l;
		};
	
		function _cl(a) {
			var b = a.Dimension;
			if (b < 21 || (b & 3) != 1) {
				throw "Error _cl";
			}
			this._au = a;
			this._cp = null;
			this._co = null;
			this._dk = function (d, c, e) {
				return this._au._ds(d, c) ? e << 1 | 1 : e << 1;
			};
			this._cm = function () {
				if (this._co != null) {
					return this._co;
				}
				var g = 0;
				for (var e = 0; e < 6; e++) {
					g = this._dk(e, 8, g);
				}
				g = this._dk(7, 8, g);
				g = this._dk(8, 8, g);
				g = this._dk(8, 7, g);
				for (var c = 5; c >= 0; c--) {
					g = this._dk(8, c, g);
				}
				this._co = _ax._ci(g);
				if (this._co != null) {
					return this._co;
				}
				var f = this._au.Dimension;
				g = 0;
				var d = f - 8;
				for (var e = f - 1; e >= d; e--) {
					g = this._dk(e, 8, g);
				}
				for (var c = f - 7; c < f; c++) {
					g = this._dk(8, c, g);
				}
				this._co = _ax._ci(g);
				if (this._co != null) {
					return this._co;
				}
				throw "Error _cm";
			};
			this._cq = function () {
				if (this._cp != null) {
					return this._cp;
				}
				var h = this._au.Dimension;
				var f = h - 17 >> 2;
				if (f <= 6) {
					return _a3._av(f);
				}
				var g = 0;
				var e = h - 11;
				for (var c = 5; c >= 0; c--) {
					for (var d = h - 9; d >= e; d--) {
						g = this._dk(d, c, g);
					}
				}
				this._cp = _a3._aw(g);
				if (this._cp != null && this._cp._cr == h) {
					return this._cp;
				}
				g = 0;
				for (var d = 5; d >= 0; d--) {
					for (var c = h - 9; c >= e; c--) {
						g = this._dk(d, c, g);
					}
				}
				this._cp = _a3._aw(g);
				if (this._cp != null && this._cp._cr == h) {
					return this._cp;
				}
				throw "Error _cq";
			};
			this._gk = function () {
				var r = this._cm();
				var o = this._cq();
				var c = _dx._gl(r._dx);
				var f = this._au.Dimension;
				c._dj(this._au, f);
				var k = o._aq();
				var n = true;
				var s = new Array(o._dp);
				var m = 0;
				var q = 0;
				var h = 0;
				for (var e = f - 1; e > 0; e -= 2) {
					if (e == 6) {
						e--;
					}
					for (var l = 0; l < f; l++) {
						var g = n ? f - 1 - l : l;
						for (var d = 0; d < 2; d++) {
							if (!k._ds(e - d, g)) {
								h++;
								q <<= 1;
								if (this._au._ds(e - d, g)) {
									q |= 1;
								}
								if (h == 8) {
									s[m++] = q;
									h = 0;
									q = 0;
								}
							}
						}
					}
					n ^= true;
				}
				if (m != o._dp) {
					throw "Error _gk";
				}
				return s;
			};
		}
		var _dx = {};
		_dx._gl = function (a) {
			if (a < 0 || a > 7) {
				throw "bad arguments";
			}
			return _dx._dy[a];
		};
	
		function _fg() {
			this._dj = function (c, d) {
				for (var b = 0; b < d; b++) {
					for (var a = 0; a < d; a++) {
						if (this._fw(b, a)) {
							c.flip(a, b);
						}
					}
				}
			};
			this._fw = function (b, a) {
				return (b + a & 1) == 0;
			};
		}
		function _fh() {
			this._dj = function (c, d) {
				for (var b = 0; b < d; b++) {
					for (var a = 0; a < d; a++) {
						if (this._fw(b, a)) {
							c.flip(a, b);
						}
					}
				}
			};
			this._fw = function (b, a) {
				return (b & 1) == 0;
			};
		}
		function _fi() {
			this._dj = function (c, d) {
				for (var b = 0; b < d; b++) {
					for (var a = 0; a < d; a++) {
						if (this._fw(b, a)) {
							c.flip(a, b);
						}
					}
				}
			};
			this._fw = function (b, a) {
				return a % 3 == 0;
			};
		}
		function _fj() {
			this._dj = function (c, d) {
				for (var b = 0; b < d; b++) {
					for (var a = 0; a < d; a++) {
						if (this._fw(b, a)) {
							c.flip(a, b);
						}
					}
				}
			};
			this._fw = function (b, a) {
				return (b + a) % 3 == 0;
			};
		}
		function _fk() {
			this._dj = function (c, d) {
				for (var b = 0; b < d; b++) {
					for (var a = 0; a < d; a++) {
						if (this._fw(b, a)) {
							c.flip(a, b);
						}
					}
				}
			};
			this._fw = function (b, a) {
				return (_ew(b, 1) + a / 3 & 1) == 0;
			};
		}
		function _fl() {
			this._dj = function (c, d) {
				for (var b = 0; b < d; b++) {
					for (var a = 0; a < d; a++) {
						if (this._fw(b, a)) {
							c.flip(a, b);
						}
					}
				}
			};
			this._fw = function (c, b) {
				var a = c * b;
				return (a & 1) + a % 3 == 0;
			};
		}
		function _fm() {
			this._dj = function (c, d) {
				for (var b = 0; b < d; b++) {
					for (var a = 0; a < d; a++) {
						if (this._fw(b, a)) {
							c.flip(a, b);
						}
					}
				}
			};
			this._fw = function (c, b) {
				var a = c * b;
				return ((a & 1) + a % 3 & 1) == 0;
			};
		}
		function _fn() {
			this._dj = function (c, d) {
				for (var b = 0; b < d; b++) {
					for (var a = 0; a < d; a++) {
						if (this._fw(b, a)) {
							c.flip(a, b);
						}
					}
				}
			};
			this._fw = function (b, a) {
				return ((b + a & 1) + b * a % 3 & 1) == 0;
			};
		}
		_dx._dy = new Array(new _fg(), new _fh(), new _fi(), new _fj(), new _fk(), new _fl(), new _fm(), new _fn());
	
		function _db(_fa) {
			this._fa = _fa;
			this.decode = function (received, _fv) {
				var poly = new _bp(this._fa, received);
				var _dh = new Array(_fv);
				for (var i = 0; i < _dh.length; i++) {
					_dh[i] = 0;
				}
				var _fq = false;
				var noError = true;
				for (var i = 0; i < _fv; i++) {
					var eval1 = poly.evaluateAt(this._fa.exp(_fq ? i + 1 : i));
					_dh[_dh.length - 1 - i] = eval1;
					if (eval1 != 0) {
						noError = false;
					}
				}
				if (noError) {
					return;
				}
				var _fu = new _bp(this._fa, _dh);
				var _dg = this._eb(this._fa._ba(_fv, 1), _fu, _fv);
				var sigma = _dg[0];
				var omega = _dg[1];
				var _dz = this._ey(sigma);
				var _ea = this._di(omega, _dz, _fq);
				for (var i = 0; i < _dz.length; i++) {
					var position = received.length - 1 - this._fa.log(_dz[i]);
					if (position < 0) {
						throw "ReedSolomonException Bad error location";
					}
					received[position] = _az._bd(received[position], _ea[i]);
				}
			};
			this._eb = function (a, b, R) {
				if (a._ec < b._ec) {
					var temp = a;
					a = b;
					b = temp;
				}
				var rLast = a;
				var r = b;
				var sLast = this._fa.One;
				var s = this._fa.Zero;
				var tLast = this._fa.Zero;
				var t = this._fa.One;
				while (r._ec >= Math.floor(R / 2)) {
					var rLastLast = rLast;
					var _ga = sLast;
					var _gb = tLast;
					rLast = r;
					sLast = s;
					tLast = t;
					if (rLast.Zero) {
						throw "r_{i-1} was zero";
					}
					r = rLastLast;
					var q = this._fa.Zero;
					var _df = rLast._ex(rLast._ec);
					var _fy = this._fa.inverse(_df);
					while (r._ec >= rLast._ec && !r.Zero) {
						var _fx = r._ec - rLast._ec;
						var scale = this._fa.multiply(r._ex(r._ec), _fy);
						q = q._bd(this._fa._ba(_fx, scale));
						r = r._bd(rLast._dc(_fx, scale));
					}
					s = q.multiply1(sLast)._bd(_ga);
					t = q.multiply1(tLast)._bd(_gb);
				}
				var _de = t._ex(0);
				if (_de == 0) {
					throw "ReedSolomonException sigmaTilde(0) was zero";
				}
				var inverse = this._fa.inverse(_de);
				var sigma = t.multiply2(inverse);
				var omega = r.multiply2(inverse);
				return new Array(sigma, omega);
			};
			this._ey = function (_ez) {
				var _fz = _ez._ec;
				if (_fz == 1) {
					return new Array(_ez._ex(1));
				}
				var result = new Array(_fz);
				var e = 0;
				for (var i = 1; i < 256 && e < _fz; i++) {
					if (_ez.evaluateAt(i) == 0) {
						result[e] = this._fa.inverse(i);
						e++;
					}
				}
				if (e != _fz) {
					throw "Error locator degree does not match number of roots";
				}
				return result;
			};
			this._di = function (_fs, _dz, _fq) {
				var s = _dz.length;
				var result = new Array(s);
				for (var i = 0; i < s; i++) {
					var _gc = this._fa.inverse(_dz[i]);
					var _dr = 1;
					for (var j = 0; j < s; j++) {
						if (i != j) {
							_dr = this._fa.multiply(_dr, _az._bd(1, this._fa.multiply(_dz[j], _gc)));
						}
					}
					result[i] = this._fa.multiply(_fs.evaluateAt(_gc), this._fa.inverse(_dr));
					if (_fq) {
						result[i] = this._fa.multiply(result[i], _gc);
					}
				}
				return result;
			};
		}
		function _bp(f, e) {
			if (e == null || e.length == 0) {
				throw "bad arguments";
			}
			this._fa = f;
			var c = e.length;
			if (c > 1 && e[0] == 0) {
				var d = 1;
				while (d < c && e[d] == 0) {
					d++;
				}
				if (d == c) {
					this._dd = f.Zero._dd;
				} else {
					this._dd = new Array(c - d);
					for (var b = 0; b < this._dd.length; b++) {
						this._dd[b] = 0;
					}
					for (var a = 0; a < this._dd.length; a++) {
						this._dd[a] = e[d + a];
					}
				}
			} else {
				this._dd = e;
			}
			this.__defineGetter__("Zero", function () {
				return this._dd[0] == 0;
			});
			this.__defineGetter__("_ec", function () {
				return this._dd.length - 1;
			});
			this.__defineGetter__("Coefficients", function () {
				return this._dd;
			});
			this._ex = function (g) {
				return this._dd[this._dd.length - 1 - g];
			};
			this.evaluateAt = function (h) {
				if (h == 0) {
					return this._ex(0);
				}
				var l = this._dd.length;
				if (h == 1) {
					var g = 0;
					for (var k = 0; k < l; k++) {
						g = _az._bd(g, this._dd[k]);
					}
					return g;
				}
				var j = this._dd[0];
				for (var k = 1; k < l; k++) {
					j = _az._bd(this._fa.multiply(h, j), this._dd[k]);
				}
				return j;
			};
			this._bd = function (g) {
				if (this._fa != g._fa) {
					throw "GF256Polys do not have same _az _fa";
				}
				if (this.Zero) {
					return g;
				}
				if (g.Zero) {
					return this;
				}
				var o = this._dd;
				var n = g._dd;
				if (o.length > n.length) {
					var j = o;
					o = n;
					n = j;
				}
				var h = new Array(n.length);
				var k = n.length - o.length;
				for (var m = 0; m < k; m++) {
					h[m] = n[m];
				}
				for (var l = k; l < n.length; l++) {
					h[l] = _az._bd(o[l - k], n[l]);
				}
				return new _bp(f, h);
			};
			this.multiply1 = function (o) {
				if (this._fa != o._fa) {
					throw "GF256Polys do not have same _az _fa";
				}
				if (this.Zero || o.Zero) {
					return this._fa.Zero;
				}
				var r = this._dd;
				var g = r.length;
				var l = o._dd;
				var n = l.length;
				var q = new Array(g + n - 1);
				for (var m = 0; m < g; m++) {
					var h = r[m];
					for (var k = 0; k < n; k++) {
						q[m + k] = _az._bd(q[m + k], this._fa.multiply(h, l[k]));
					}
				}
				return new _bp(this._fa, q);
			};
			this.multiply2 = function (g) {
				if (g == 0) {
					return this._fa.Zero;
				}
				if (g == 1) {
					return this;
				}
				var j = this._dd.length;
				var k = new Array(j);
				for (var h = 0; h < j; h++) {
					k[h] = this._fa.multiply(this._dd[h], g);
				}
				return new _bp(this._fa, k);
			};
			this._dc = function (l, g) {
				if (l < 0) {
					throw "bad arguments";
				}
				if (g == 0) {
					return this._fa.Zero;
				}
				var j = this._dd.length;
				var k = new Array(j + l);
				for (var h = 0; h < k.length; h++) {
					k[h] = 0;
				}
				for (var h = 0; h < j; h++) {
					k[h] = this._fa.multiply(this._dd[h], g);
				}
				return new _bp(this._fa, k);
			};
			this.divide = function (l) {
				if (this._fa != l._fa) {
					throw "GF256Polys do not have same _az _fa";
				}
				if (l.Zero) {
					throw "Divide by 0";
				}
				var j = this._fa.Zero;
				var o = this;
				var g = l._ex(l._ec);
				var n = this._fa.inverse(g);
				while (o._ec >= l._ec && !o.Zero) {
					var m = o._ec - l._ec;
					var h = this._fa.multiply(o._ex(o._ec), n);
					var i = l._dc(m, h);
					var k = this._fa._ba(m, h);
					j = j._bd(k);
					o = o._bd(i);
				}
				return new Array(j, o);
			};
		}
		function _az(b) {
			this._gh = new Array(256);
			this._gi = new Array(256);
			var a = 1;
			for (var e = 0; e < 256; e++) {
				this._gh[e] = a;
				a <<= 1;
				if (a >= 256) {
					a ^= b;
				}
			}
			for (var e = 0; e < 255; e++) {
				this._gi[this._gh[e]] = e;
			}
			var d = new Array(1);
			d[0] = 0;
			this.zero = new _bp(this, new Array(d));
			var c = new Array(1);
			c[0] = 1;
			this.one = new _bp(this, new Array(c));
			this.__defineGetter__("Zero", function () {
				return this.zero;
			});
			this.__defineGetter__("One", function () {
				return this.one;
			});
			this._ba = function (j, f) {
				if (j < 0) {
					throw "bad arguments";
				}
				if (f == 0) {
					return zero;
				}
				var h = new Array(j + 1);
				for (var g = 0; g < h.length; g++) {
					h[g] = 0;
				}
				h[0] = f;
				return new _bp(this, h);
			};
			this.exp = function (f) {
				return this._gh[f];
			};
			this.log = function (f) {
				if (f == 0) {
					throw "bad arguments";
				}
				return this._gi[f];
			};
			this.inverse = function (f) {
				if (f == 0) {
					throw "System.ArithmeticException";
				}
				return this._gh[255 - this._gi[f]];
			};
			this.multiply = function (g, f) {
				if (g == 0 || f == 0) {
					return 0;
				}
				if (g == 1) {
					return f;
				}
				if (f == 1) {
					return g;
				}
				return this._gh[(this._gi[g] + this._gi[f]) % 255];
			};
		}
		_az._bb = new _az(285);
		_az._bc = new _az(301);
		_az._bd = function (d, c) {
			return d ^ c;
		};
		var Decoder = {};
		Decoder.rsDecoder = new _db(_az._bb);
		Decoder.correctErrors = function (g, b) {
			var d = g.length;
			var f = new Array(d);
			for (var e = 0; e < d; e++) {
				f[e] = g[e] & 255;
			}
			var a = g.length - b;
			try {
				Decoder.rsDecoder.decode(f, a);
			} catch (c) {
				throw c;
			}
			for (var e = 0; e < b; e++) {
				g[e] = f[e];
			}
		};
		Decoder.decode = function (r) {
			var b = new _cl(r);
			var o = b._cq();
			var c = b._cm()._cg;
			var q = b._gk();
			var a = _dl._gn(q, o, c);
			var f = 0;
			for (var k = 0; k < a.length; k++) {
				f += a[k]._du;
			}
			var e = new Array(f);
			var n = 0;
			for (var h = 0; h < a.length; h++) {
				var m = a[h];
				var d = m.Codewords;
				var g = m._du;
				Decoder.correctErrors(d, g);
				for (var k = 0; k < g; k++) {
					e[n++] = d[k];
				}
			}
			var l = new QRCodeDataBlockReader(e, o._fd, c.Bits);
			return l;
		};
		var qrcode = {};
		qrcode.imagedata = null;
		qrcode.width = 0;
		qrcode.height = 0;
		qrcode.qrCodeSymbol = null;
		qrcode.debug = false;
		qrcode.maxImgSize = 1024 * 1024;
		qrcode._eo = [[10, 9, 8, 8], [12, 11, 16, 10], [14, 13, 16, 12]];
		qrcode.callback = null;
		qrcode.decode = function (d) {
			if (arguments.length == 0) {
				var b = document.getElementById("qr-canvas");
				var a = b.getContext("2d");
				qrcode.width = b.width;
				qrcode.height = b.height;
				qrcode.imagedata = a.getImageData(0, 0, qrcode.width, qrcode.height);
				qrcode.result = qrcode.process(a);
				if (qrcode.callback != null) {
					qrcode.callback(qrcode.result);
				}
				return qrcode.result;
			} else {
				var c = new Image();
				c.onload = function () {
					var g = document.getElementById("out-canvas");
					if (g != null) {
						var j = g.getContext("2d");
						j.clearRect(0, 0, 320, 240);
						j.drawImage(c, 0, 0, 320, 240);
					}
					var i = document.createElement("canvas");
					var h = i.getContext("2d");
					var f = c.height;
					var l = c.width;
					if (c.width * c.height > qrcode.maxImgSize) {
						var k = c.width / c.height;
						f = Math.sqrt(qrcode.maxImgSize / k);
						l = k * f;
					}
					i.width = l;
					i.height = f;
					h.drawImage(c, 0, 0, i.width, i.height);
					qrcode.width = i.width;
					qrcode.height = i.height;
					try {
						qrcode.imagedata = h.getImageData(0, 0, i.width, i.height);
					} catch (m) {
						qrcode.result = "Cross domain image reading not supported in your browser! Save it to your computer then drag and drop the file!";
						if (qrcode.callback != null) {
							qrcode.callback(qrcode.result);
						}
						return;
					}
					try {
						qrcode.result = qrcode.process(h);
					} catch (m) {
						qrcode.result = "error decoding QR Code";
					}
					if (qrcode.callback != null) {
						qrcode.callback(qrcode.result);
					}
				};
				c.src = d;
			}
		};
		qrcode.isUrl = function (a) {
			var b = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
			return b.test(a);
		};
		qrcode.decode_url = function (b) {
			var d = "";
			try {
				d = escape(b);
			} catch (c) {
				d = b;
			}
			var a = "";
			try {
				a = decodeURIComponent(d);
			} catch (c) {
				a = d;
			}
			return a;
		};
		qrcode.decode_utf8 = function (a) {
			if (qrcode.isUrl(a)) {
				return qrcode.decode_url(a);
			} else {
				return a;
			}
		};
		qrcode.process = function (r) {
			var a = new Date().getTime();
			var c = qrcode.grayScaleToBitmap(qrcode.grayscale());
			if (qrcode.debug) {
				for (var m = 0; m < qrcode.height; m++) {
					for (var n = 0; n < qrcode.width; n++) {
						var o = n * 4 + m * qrcode.width * 4;
						qrcode.imagedata.data[o] = c[n + m * qrcode.width] ? 0 : 0;
						qrcode.imagedata.data[o + 1] = c[n + m * qrcode.width] ? 0 : 0;
						qrcode.imagedata.data[o + 2] = c[n + m * qrcode.width] ? 255 : 0;
					}
				}
				r.putImageData(qrcode.imagedata, 0, 0);
			}
			var h = new Detector(c);
			var q = h.detect();
			if (qrcode.debug) {
				r.putImageData(qrcode.imagedata, 0, 0);
			}
			var k = Decoder.decode(q.bits);
			var g = k.DataByte;
			var l = "";
			for (var f = 0; f < g.length; f++) {
				for (var e = 0; e < g[f].length; e++) {
					l += String.fromCharCode(g[f][e]);
				}
			}
			var d = new Date().getTime();
			var b = d - a;
			return qrcode.decode_utf8(l);
		};
		qrcode.getPixel = function (a, b) {
			if (qrcode.width < a) {
				throw "point error";
			}
			if (qrcode.height < b) {
				throw "point error";
			}
			var point = a * 4 + b * qrcode.width * 4;
			var p = (qrcode.imagedata.data[point] * 33 + qrcode.imagedata.data[point + 1] * 34 + qrcode.imagedata.data[point + 2] * 33) / 100;
			return p;
		};
		qrcode.binarize = function (d) {
			var c = new Array(qrcode.width * qrcode.height);
			for (var e = 0; e < qrcode.height; e++) {
				for (var b = 0; b < qrcode.width; b++) {
					var a = qrcode.getPixel(b, e);
					c[b + e * qrcode.width] = a <= d ? true : false;
				}
			}
			return c;
		};
		qrcode._em = function (d) {
			var c = 4;
			var k = Math.floor(qrcode.width / c);
			var j = Math.floor(qrcode.height / c);
			var f = new Array(c);
			for (var g = 0; g < c; g++) {
				f[g] = new Array(c);
				for (var e = 0; e < c; e++) {
					f[g][e] = new Array(0, 0);
				}
			}
			for (var o = 0; o < c; o++) {
				for (var a = 0; a < c; a++) {
					f[a][o][0] = 255;
					for (var l = 0; l < j; l++) {
						for (var n = 0; n < k; n++) {
							var h = d[k * a + n + (j * o + l) * qrcode.width];
							if (h < f[a][o][0]) {
								f[a][o][0] = h;
							}
							if (h > f[a][o][1]) {
								f[a][o][1] = h;
							}
						}
					}
				}
			}
			var m = new Array(c);
			for (var b = 0; b < c; b++) {
				m[b] = new Array(c);
			}
			for (var o = 0; o < c; o++) {
				for (var a = 0; a < c; a++) {
					m[a][o] = Math.floor((f[a][o][0] + f[a][o][1]) / 2);
				}
			}
			return m;
		};
		qrcode.grayScaleToBitmap = function (f) {
			var j = qrcode._em(f);
			var b = j.length;
			var e = Math.floor(qrcode.width / b);
			var d = Math.floor(qrcode.height / b);
			var c = new Array(qrcode.height * qrcode.width);
			for (var i = 0; i < b; i++) {
				for (var a = 0; a < b; a++) {
					for (var g = 0; g < d; g++) {
						for (var h = 0; h < e; h++) {
							c[e * a + h + (d * i + g) * qrcode.width] = f[e * a + h + (d * i + g) * qrcode.width] < j[a][i] ? true : false;
						}
					}
				}
			}
			return c;
		};
		qrcode.grayscale = function () {
			var c = new Array(qrcode.width * qrcode.height);
			for (var d = 0; d < qrcode.height; d++) {
				for (var b = 0; b < qrcode.width; b++) {
					var a = qrcode.getPixel(b, d);
					c[b + d * qrcode.width] = a;
				}
			}
			return c;
		};
	
		function _ew(a, b) {
			if (a >= 0) {
				return a >> b;
			} else {
				return (a >> b) + (2 << ~b);
			}
		}
		Array.prototype.remove = function (c, b) {
			var a = this.slice((b || c) + 1 || this.length);
			this.length = c < 0 ? this.length + c : c;
			return this.push.apply(this, a);
		};
		var _gf = 3;
		var _eh = 57;
		var _el = 8;
		var _eg = 2;
		qrcode._er = function (c) {
			function b(l, k) {
				var xDiff = l.X - k.X;
				var yDiff = l.Y - k.Y;
				return Math.sqrt(xDiff * xDiff + yDiff * yDiff);
			}
			function d(k, o, n) {
				var m = o.x;
				var l = o.y;
				return (n.x - m) * (k.y - l) - (n.y - l) * (k.x - m);
			}
			var i = b(c[0], c[1]);
			var f = b(c[1], c[2]);
			var e = b(c[0], c[2]);
			var a, j, h;
			if (f >= i && f >= e) {
				j = c[0];
				a = c[1];
				h = c[2];
			} else {
				if (e >= f && e >= i) {
					j = c[1];
					a = c[0];
					h = c[2];
				} else {
					j = c[2];
					a = c[0];
					h = c[1];
				}
			}
			if (d(a, j, h) < 0) {
				var g = a;
				a = h;
				h = g;
			}
			c[0] = a;
			c[1] = j;
			c[2] = h;
		};
	
		function _cz(c, a, b) {
			this.x = c;
			this.y = a;
			this.count = 1;
			this._aj = b;
			this.__defineGetter__("_ei", function () {
				return this._aj;
			});
			this.__defineGetter__("Count", function () {
				return this.count;
			});
			this.__defineGetter__("X", function () {
				return this.x;
			});
			this.__defineGetter__("Y", function () {
				return this.y;
			});
			this._ek = function () {
				this.count++;
			};
			this._ev = function (f, e, d) {
				if (Math.abs(e - this.y) <= f && Math.abs(d - this.x) <= f) {
					var g = Math.abs(f - this._aj);
					return g <= 1 || g / this._aj <= 1;
				}
				return false;
			};
		}
		function _es(a) {
			this._go = a[0];
			this._gu = a[1];
			this._gr = a[2];
			this.__defineGetter__("_gp", function () {
				return this._go;
			});
			this.__defineGetter__("_gq", function () {
				return this._gu;
			});
			this.__defineGetter__("_gs", function () {
				return this._gr;
			});
		}
		function _cc() {
			this.image = null;
			this._cv = [];
			this._ge = false;
			this._al = new Array(0, 0, 0, 0, 0);
			this._am = null;
			this.__defineGetter__("_da", function () {
				this._al[0] = 0;
				this._al[1] = 0;
				this._al[2] = 0;
				this._al[3] = 0;
				this._al[4] = 0;
				return this._al;
			});
			this._ao = function (f) {
				var b = 0;
				for (var d = 0; d < 5; d++) {
					var e = f[d];
					if (e == 0) {
						return false;
					}
					b += e;
				}
				if (b < 7) {
					return false;
				}
				var c = Math.floor((b << _el) / 7);
				var a = Math.floor(c / 2);
				return Math.abs(c - (f[0] << _el)) < a && Math.abs(c - (f[1] << _el)) < a && Math.abs(3 * c - (f[2] << _el)) < 3 * a && Math.abs(c - (f[3] << _el)) < a && Math.abs(c - (f[4] << _el)) < a;
			};
			this._an = function (b, a) {
				return a - b[4] - b[3] - b[2] / 2;
			};
			this._ap = function (a, j, d, g) {
				var c = this.image;
				var h = qrcode.height;
				var b = this._da;
				var f = a;
				while (f >= 0 && c[j + f * qrcode.width]) {
					b[2]++;
					f--;
				}
				if (f < 0) {
					return NaN;
				}
				while (f >= 0 && !c[j + f * qrcode.width] && b[1] <= d) {
					b[1]++;
					f--;
				}
				if (f < 0 || b[1] > d) {
					return NaN;
				}
				while (f >= 0 && c[j + f * qrcode.width] && b[0] <= d) {
					b[0]++;
					f--;
				}
				if (b[0] > d) {
					return NaN;
				}
				f = a + 1;
				while (f < h && c[j + f * qrcode.width]) {
					b[2]++;
					f++;
				}
				if (f == h) {
					return NaN;
				}
				while (f < h && !c[j + f * qrcode.width] && b[3] < d) {
					b[3]++;
					f++;
				}
				if (f == h || b[3] >= d) {
					return NaN;
				}
				while (f < h && c[j + f * qrcode.width] && b[4] < d) {
					b[4]++;
					f++;
				}
				if (b[4] >= d) {
					return NaN;
				}
				var e = b[0] + b[1] + b[2] + b[3] + b[4];
				if (5 * Math.abs(e - g) >= 2 * g) {
					return NaN;
				}
				return this._ao(b) ? this._an(b, f) : NaN;
			};
			this._ej = function (b, a, e, h) {
				var d = this.image;
				var i = qrcode.width;
				var c = this._da;
				var g = b;
				while (g >= 0 && d[g + a * qrcode.width]) {
					c[2]++;
					g--;
				}
				if (g < 0) {
					return NaN;
				}
				while (g >= 0 && !d[g + a * qrcode.width] && c[1] <= e) {
					c[1]++;
					g--;
				}
				if (g < 0 || c[1] > e) {
					return NaN;
				}
				while (g >= 0 && d[g + a * qrcode.width] && c[0] <= e) {
					c[0]++;
					g--;
				}
				if (c[0] > e) {
					return NaN;
				}
				g = b + 1;
				while (g < i && d[g + a * qrcode.width]) {
					c[2]++;
					g++;
				}
				if (g == i) {
					return NaN;
				}
				while (g < i && !d[g + a * qrcode.width] && c[3] < e) {
					c[3]++;
					g++;
				}
				if (g == i || c[3] >= e) {
					return NaN;
				}
				while (g < i && d[g + a * qrcode.width] && c[4] < e) {
					c[4]++;
					g++;
				}
				if (c[4] >= e) {
					return NaN;
				}
				var f = c[0] + c[1] + c[2] + c[3] + c[4];
				if (5 * Math.abs(f - h) >= h) {
					return NaN;
				}
				return this._ao(c) ? this._an(c, g) : NaN;
			};
			this._cu = function (c, f, e) {
				var d = c[0] + c[1] + c[2] + c[3] + c[4];
				var n = this._an(c, e);
				var b = this._ap(f, Math.floor(n), c[2], d);
				if (!isNaN(b)) {
					n = this._ej(Math.floor(n), Math.floor(b), c[2], d);
					if (!isNaN(n)) {
						var l = d / 7;
						var m = false;
						var h = this._cv.length;
						for (var g = 0; g < h; g++) {
							var a = this._cv[g];
							if (a._ev(l, b, n)) {
								a._ek();
								m = true;
								break;
							}
						}
						if (!m) {
							var k = new _cz(n, b, l);
							this._cv.push(k);
							if (this._am != null) {
								this._am._ep(k);
							}
						}
						return true;
					}
				}
				return false;
			};
			this._ee = function () {
				var h = this._cv.length;
				if (h < 3) {
					throw "Couldn't find enough finder patterns";
				}
				if (h > 3) {
					var b = 0;
					var j = 0;
					for (var d = 0; d < h; d++) {
						var g = this._cv[d]._ei;
						b += g;
						j += g * g;
					}
					var a = b / h;
					this._cv.sort(function (m, l) {
						var k = Math.abs(l._ei - a);
						var i = Math.abs(m._ei - a);
						if (k < i) {
							return -1;
						} else {
							if (k == i) {
								return 0;
							} else {
								return 1;
							}
						}
					});
					var e = Math.sqrt(j / h - a * a);
					var c = Math.max(0.2 * a, e);
					for (var d = 0; d < this._cv.length && this._cv.length > 3; d++) {
						var f = this._cv[d];
						if (Math.abs(f._ei - a) > c) {
							this._cv.remove(d);
							d--;
						}
					}
				}
				if (this._cv.length > 3) {
					this._cv.sort(function (k, i) {
						if (k.count > i.count) {
							return -1;
						}
						if (k.count < i.count) {
							return 1;
						}
						return 0;
					});
				}
				return new Array(this._cv[0], this._cv[1], this._cv[2]);
			};
			this._eq = function () {
				var b = this._cv.length;
				if (b <= 1) {
					return 0;
				}
				var c = null;
				for (var d = 0; d < b; d++) {
					var a = this._cv[d];
					if (a.Count >= _eg) {
						if (c == null) {
							c = a;
						} else {
							this._ge = true;
							return Math.floor((Math.abs(c.X - a.X) - Math.abs(c.Y - a.Y)) / 2);
						}
					}
				}
				return 0;
			};
			this._cx = function () {
				var g = 0;
				var c = 0;
				var a = this._cv.length;
				for (var d = 0; d < a; d++) {
					var f = this._cv[d];
					if (f.Count >= _eg) {
						g++;
						c += f._ei;
					}
				}
				if (g < 3) {
					return false;
				}
				var e = c / a;
				var b = 0;
				for (var d = 0; d < a; d++) {
					f = this._cv[d];
					b += Math.abs(f._ei - e);
				}
				return b <= 0.05 * c;
			};
			this._ce = function (e) {
				var o = false;
				this.image = e;
				var n = qrcode.height;
				var k = qrcode.width;
				var a = Math.floor(3 * n / (4 * _eh));
				if (a < _gf || o) {
					a = _gf;
				}
				var g = false;
				var d = new Array(5);
				for (var h = a - 1; h < n && !g; h += a) {
					d[0] = 0;
					d[1] = 0;
					d[2] = 0;
					d[3] = 0;
					d[4] = 0;
					var b = 0;
					for (var f = 0; f < k; f++) {
						if (e[f + h * qrcode.width]) {
							if ((b & 1) == 1) {
								b++;
							}
							d[b]++;
						} else {
							if ((b & 1) == 0) {
								if (b == 4) {
									if (this._ao(d)) {
										var c = this._cu(d, h, f);
										if (c) {
											a = 2;
											if (this._ge) {
												g = this._cx();
											} else {
												var m = this._eq();
												if (m > d[2]) {
													h += m - d[2] - a;
													f = k - 1;
												}
											}
										} else {
											do {
												f++;
											} while (f < k && !e[f + h * qrcode.width]);
											f--;
										}
										b = 0;
										d[0] = 0;
										d[1] = 0;
										d[2] = 0;
										d[3] = 0;
										d[4] = 0;
									} else {
										d[0] = d[2];
										d[1] = d[3];
										d[2] = d[4];
										d[3] = 1;
										d[4] = 0;
										b = 3;
									}
								} else {
									d[++b]++;
								}
							} else {
								d[b]++;
							}
						}
					}
					if (this._ao(d)) {
						var c = this._cu(d, h, k);
						if (c) {
							a = d[0];
							if (this._ge) {
								g = _cx();
							}
						}
					}
				}
				var l = this._ee();
				qrcode._er(l);
				return new _es(l);
			};
		}
		function _ai(c, a, b) {
			this.x = c;
			this.y = a;
			this.count = 1;
			this._aj = b;
			this.__defineGetter__("_ei", function () {
				return this._aj;
			});
			this.__defineGetter__("Count", function () {
				return this.count;
			});
			this.__defineGetter__("X", function () {
				return Math.floor(this.x);
			});
			this.__defineGetter__("Y", function () {
				return Math.floor(this.y);
			});
			this._ek = function () {
				this.count++;
			};
			this._ev = function (f, e, d) {
				if (Math.abs(e - this.y) <= f && Math.abs(d - this.x) <= f) {
					var g = Math.abs(f - this._aj);
					return g <= 1 || g / this._aj <= 1;
				}
				return false;
			};
		}
		function _ak(g, c, b, f, a, e, d) {
			this.image = g;
			this._cv = new Array();
			this.startX = c;
			this.startY = b;
			this.width = f;
			this.height = a;
			this._ef = e;
			this._al = new Array(0, 0, 0);
			this._am = d;
			this._an = function (i, h) {
				return h - i[2] - i[1] / 2;
			};
			this._ao = function (l) {
				var k = this._ef;
				var h = k / 2;
				for (var j = 0; j < 3; j++) {
					if (Math.abs(k - l[j]) >= h) {
						return false;
					}
				}
				return true;
			};
			this._ap = function (h, r, l, o) {
				var k = this.image;
				var q = qrcode.height;
				var j = this._al;
				j[0] = 0;
				j[1] = 0;
				j[2] = 0;
				var n = h;
				while (n >= 0 && k[r + n * qrcode.width] && j[1] <= l) {
					j[1]++;
					n--;
				}
				if (n < 0 || j[1] > l) {
					return NaN;
				}
				while (n >= 0 && !k[r + n * qrcode.width] && j[0] <= l) {
					j[0]++;
					n--;
				}
				if (j[0] > l) {
					return NaN;
				}
				n = h + 1;
				while (n < q && k[r + n * qrcode.width] && j[1] <= l) {
					j[1]++;
					n++;
				}
				if (n == q || j[1] > l) {
					return NaN;
				}
				while (n < q && !k[r + n * qrcode.width] && j[2] <= l) {
					j[2]++;
					n++;
				}
				if (j[2] > l) {
					return NaN;
				}
				var m = j[0] + j[1] + j[2];
				if (5 * Math.abs(m - o) >= 2 * o) {
					return NaN;
				}
				return this._ao(j) ? this._an(j, n) : NaN;
			};
			this._cu = function (l, o, n) {
				var m = l[0] + l[1] + l[2];
				var u = this._an(l, n);
				var k = this._ap(o, Math.floor(u), 2 * l[1], m);
				if (!isNaN(k)) {
					var t = (l[0] + l[1] + l[2]) / 3;
					var r = this._cv.length;
					for (var q = 0; q < r; q++) {
						var h = this._cv[q];
						if (h._ev(t, k, u)) {
							return new _ai(u, k, t);
						}
					}
					var s = new _ai(u, k, t);
					this._cv.push(s);
					if (this._am != null) {
						this._am._ep(s);
					}
				}
				return null;
			};
			this.find = function () {
				var q = this.startX;
				var t = this.height;
				var r = q + f;
				var s = b + (t >> 1);
				var m = new Array(0, 0, 0);
				for (var k = 0; k < t; k++) {
					var o = s + ((k & 1) == 0 ? k + 1 >> 1 : -(k + 1 >> 1));
					m[0] = 0;
					m[1] = 0;
					m[2] = 0;
					var n = q;
					while (n < r && !g[n + qrcode.width * o]) {
						n++;
					}
					var h = 0;
					while (n < r) {
						if (g[n + o * qrcode.width]) {
							if (h == 1) {
								m[h]++;
							} else {
								if (h == 2) {
									if (this._ao(m)) {
										var l = this._cu(m, o, n);
										if (l != null) {
											return l;
										}
									}
									m[0] = m[2];
									m[1] = 1;
									m[2] = 0;
									h = 1;
								} else {
									m[++h]++;
								}
							}
						} else {
							if (h == 1) {
								h++;
							}
							m[h]++;
						}
						n++;
					}
					if (this._ao(m)) {
						var l = this._cu(m, o, r);
						if (l != null) {
							return l;
						}
					}
				}
				if (!(this._cv.length == 0)) {
					return this._cv[0];
				}
				throw "Couldn't find enough alignment patterns";
			};
		}
		function QRCodeDataBlockReader(c, a, b) {
			this._ed = 0;
			this._cw = 7;
			this.dataLength = 0;
			this.blocks = c;
			this._en = b;
			if (a <= 9) {
				this.dataLengthMode = 0;
			} else {
				if (a >= 10 && a <= 26) {
					this.dataLengthMode = 1;
				} else {
					if (a >= 27 && a <= 40) {
						this.dataLengthMode = 2;
					}
				}
			}
			this._gd = function (f) {
				var k = 0;
				if (f < this._cw + 1) {
					var m = 0;
					for (var e = 0; e < f; e++) {
						m += 1 << e;
					}
					m <<= this._cw - f + 1;
					k = (this.blocks[this._ed] & m) >> this._cw - f + 1;
					this._cw -= f;
					return k;
				} else {
					if (f < this._cw + 1 + 8) {
						var j = 0;
						for (var e = 0; e < this._cw + 1; e++) {
							j += 1 << e;
						}
						k = (this.blocks[this._ed] & j) << f - (this._cw + 1);
						this._ed++;
						k += this.blocks[this._ed] >> 8 - (f - (this._cw + 1));
						this._cw = this._cw - f % 8;
						if (this._cw < 0) {
							this._cw = 8 + this._cw;
						}
						return k;
					} else {
						if (f < this._cw + 1 + 16) {
							var j = 0;
							var h = 0;
							for (var e = 0; e < this._cw + 1; e++) {
								j += 1 << e;
							}
							var g = (this.blocks[this._ed] & j) << f - (this._cw + 1);
							this._ed++;
							var d = this.blocks[this._ed] << f - (this._cw + 1 + 8);
							this._ed++;
							for (var e = 0; e < f - (this._cw + 1 + 8); e++) {
								h += 1 << e;
							}
							h <<= 8 - (f - (this._cw + 1 + 8));
							var l = (this.blocks[this._ed] & h) >> 8 - (f - (this._cw + 1 + 8));
							k = g + d + l;
							this._cw = this._cw - (f - 8) % 8;
							if (this._cw < 0) {
								this._cw = 8 + this._cw;
							}
							return k;
						} else {
							return 0;
						}
					}
				}
			};
			this.NextMode = function () {
				if (this._ed > this.blocks.length - this._en - 2) {
					return 0;
				} else {
					return this._gd(4);
				}
			};
			this.getDataLength = function (d) {
				var e = 0;
				while (true) {
					if (d >> e == 1) {
						break;
					}
					e++;
				}
				return this._gd(qrcode._eo[this.dataLengthMode][e]);
			};
			this.getRomanAndFigureString = function (h) {
				var f = h;
				var g = 0;
				var j = "";
				var d = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", " ", "$", "%", "*", "+", "-", ".", "/", ":");
				do {
					if (f > 1) {
						g = this._gd(11);
						var i = Math.floor(g / 45);
						var e = g % 45;
						j += d[i];
						j += d[e];
						f -= 2;
					} else {
						if (f == 1) {
							g = this._gd(6);
							j += d[g];
							f -= 1;
						}
					}
				} while (f > 0);
				return j;
			};
			this.getFigureString = function (f) {
				var d = f;
				var e = 0;
				var g = "";
				do {
					if (d >= 3) {
						e = this._gd(10);
						if (e < 100) {
							g += "0";
						}
						if (e < 10) {
							g += "0";
						}
						d -= 3;
					} else {
						if (d == 2) {
							e = this._gd(7);
							if (e < 10) {
								g += "0";
							}
							d -= 2;
						} else {
							if (d == 1) {
								e = this._gd(4);
								d -= 1;
							}
						}
					}
					g += e;
				} while (d > 0);
				return g;
			};
			this.get8bitByteArray = function (g) {
				var e = g;
				var f = 0;
				var d = new Array();
				do {
					f = this._gd(8);
					d.push(f);
					e--;
				} while (e > 0);
				return d;
			};
			this.getKanjiString = function (j) {
				var g = j;
				var i = 0;
				var h = "";
				do {
					i = _gd(13);
					var e = i % 192;
					var f = i / 192;
					var k = (f << 8) + e;
					var d = 0;
					if (k + 33088 <= 40956) {
						d = k + 33088;
					} else {
						d = k + 49472;
					}
					h += String.fromCharCode(d);
					g--;
				} while (g > 0);
				return h;
			};
			this.__defineGetter__("DataByte", function () {
				var g = new Array();
				var e = 1;
				var f = 2;
				var d = 4;
				var n = 8;
				do {
					var k = this.NextMode();
					if (k == 0) {
						if (g.length > 0) {
							break;
						} else {
							throw "Empty data block";
						}
					}
					if (k != e && k != f && k != d && k != n) {
						throw "Invalid mode: " + k + " in (block:" + this._ed + " bit:" + this._cw + ")";
					}
					var dataLength = this.getDataLength(k);
					if (dataLength < 1) {
						throw "Invalid data length: " + dataLength;
					}
					switch (k) {
						case e:
							var l = this.getFigureString(dataLength);
							var i = new Array(l.length);
							for (var h = 0; h < l.length; h++) {
								i[h] = l.charCodeAt(h);
							}
							g.push(i);
							break;
						case f:
							var l = this.getRomanAndFigureString(dataLength);
							var i = new Array(l.length);
							for (var h = 0; h < l.length; h++) {
								i[h] = l.charCodeAt(h);
							}
							g.push(i);
							break;
						case d:
							var m = this.get8bitByteArray(dataLength);
							g.push(m);
							break;
						case n:
							var l = this.getKanjiString(dataLength);
							g.push(l);
							break;
					}
				} while (true);
				return g;
			});
		};
		return qrcode;
	}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _llqrcode = __webpack_require__(131);
	
	var _llqrcode2 = _interopRequireDefault(_llqrcode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = webqr();
	
	function webqr() {
		var gCtx = null;
		var gCanvas = null;
		var c = 0;
		var stype = 0;
		var gUM = false;
		var webkit = false;
		var moz = false;
		var v = null;
		var qrCanvas = null;
		var qrResult = null;
		function dragenter(e) {
			e.stopPropagation();
			e.preventDefault();
		}
		function dragover(e) {
			e.stopPropagation();
			e.preventDefault();
		}
		function drop(e) {
			e.stopPropagation();
			e.preventDefault();
			var dt = e.dataTransfer;
			var files = dt.files;
			if (files.length > 0) {
				handleFiles(files);
			} else {
				if (dt.getData("URL")) {
					_llqrcode2.default.decode(dt.getData("URL"));
				}
			}
		}
	
		function handleFiles(f) {
			var o = [];
			for (var i = 0; i < f.length; i++) {
				var reader = new FileReader();
				reader.onload = function (theFile) {
					return function (e) {
						gCtx.clearRect(0, 0, gCanvas.width, gCanvas.height);
						var img = new Image();
						img.onload = function () {
							setTimeout(function () {
								gCtx.drawImage(img, 0, 0, gCanvas.width, gCanvas.height);
							}, 0);
						};
						img.src = e.target.result;
						_llqrcode2.default.decode(e.target.result);
					};
				}(f[i]);
				reader.readAsDataURL(f[i]);
			}
		}
		function initCanvas(w, h) {
			gCanvas = document.getElementById(qrCanvas);
			gCanvas.style.width = w + "px";
			gCanvas.style.height = h + "px";
			gCanvas.width = w;
			gCanvas.height = h;
			gCtx = gCanvas.getContext("2d");
			gCtx.clearRect(0, 0, w, h);
		}
		function captureToCanvas() {
			if (stype != 1) {
				return;
			}
			if (gUM) {
				try {
					gCtx.drawImage(v, 0, 0);
					try {
						_llqrcode2.default.decode();
					} catch (e) {
						setTimeout(captureToCanvas, 500);
					}
				} catch (e) {
					console.log(e);
					setTimeout(captureToCanvas, 500);
				}
			}
		}
		function htmlEntities(str) {
			return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
		}
		function read(a) {
			var html = "";
			if (a.indexOf("http://") === 0 || a.indexOf("https://") === 0) {
				html += "<a target='_blank' href='" + a + "'>" + a + "</a><br>";
			} else {
				html += "<bdi>" + htmlEntities(a) + "</bdi>";
			}
			document.getElementById(qrResult).innerHTML = html;
		}
		function isCanvasSupported() {
			var elem = document.createElement("canvas");
			return !!(elem.getContext && elem.getContext("2d"));
		}
		function success(stream) {
			if (webkit) {
				v.src = window.webkitURL.createObjectURL(stream);
			} else {
				if (moz) {
					v.mozSrcObject = stream;
					v.play();
				} else {
					v.src = stream;
				}
			}
			gUM = true;
			setTimeout(captureToCanvas, 500);
		}
		function error(error) {
			gUM = false;
			return;
		}
	
		function load(qrfile, width, heigth) {
			if (isCanvasSupported() && window.File && window.FileReader) {
				initR(qrfile);
				initCanvas(width || 200, heigth || 200);
				_llqrcode2.default.callback = read;
			} else {}
		}
		function initR(qr) {
			var qrfile = document.getElementById(qr);
			qrCanvas = qrfile.getAttribute('qrCanvas');
			qrResult = qrfile.getAttribute('qrResult');
			qrfile.addEventListener("dragenter", dragenter, false);
			qrfile.addEventListener("dragover", dragover, false);
			qrfile.addEventListener("drop", drop, false);
		};
		return {
			load: load,
			handleFiles: handleFiles
		};
	}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'v-button': __webpack_require__(278),
	  'v-checkbox': __webpack_require__(279),
	  'v-date': __webpack_require__(280),
	  'v-editor': __webpack_require__(281),
	  'v-layer': __webpack_require__(283),
	  'v-loading': __webpack_require__(284),
	  'v-pager': __webpack_require__(285),
	  'v-radio': __webpack_require__(286),
	  'v-select': __webpack_require__(287),
	  'v-switch': __webpack_require__(288),
	  'v-table': __webpack_require__(290),
	  'v-upload': __webpack_require__(291),
	  'v-tab': __webpack_require__(289),
	  'v-input-txt': __webpack_require__(282),
	  'v-icon': __webpack_require__(98)
	};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    apiDomain: 'http://api.yimo.link'
	};

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'absolute-bottom': {
	        inserted: function inserted(el, binding) {
	            el.style.position = 'fixed';
	            el.style.bottom = binding.value;
	        }
	    },
	    'keydown-tab': {
	        inserted: function inserted(el) {
	            var onkeydown = function onkeydown(e) {
	                if (e.keyCode == 9) {
	                    e.preventDefault();
	                    var start = this.selectionStart,
	                        end = this.selectionEnd;
	                    var text = this.value;
	                    var tab = '    ';
	                    text = text.substr(0, start) + tab + text.substr(start);
	                    this.value = text;
	                    this.selectionStart = start + tab.length;
	                    this.selectionEnd = end + tab.length;
	                }
	            };
	            el.onkeydown = onkeydown;
	        }
	    }
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(65);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  openRoute: function openRoute(route) {
	    if (typeof route === 'string' && route.indexOf('http') == 0) {
	      this.openRedirect(route);
	      return;
	    }
	    _router2.default.push(route);
	  },
	  openRedirect: function openRedirect(url) {
	    window.open(url);
	  },
	  openLayer: function openLayer(url, title) {
	    window.layui.layer.open({
	      type: 2,
	      shade: 0,
	      skin: 'layui-layer-molv',
	      anim: 4,
	      offset: 'rb',
	      area: ['400px', '500px'],
	      title: title,
	      content: url
	    });
	  }
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cryptoJs = __webpack_require__(39);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var b64 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ+/=';
	
	var codes = ['\u200B', '\u200C\u200D'];
	var table = [];
	
	var makeTable = function makeTable() {
	  var sep = codes[0],
	      chars = codes[1];
	
	  var char_count = b64.length;
	  var code_len = chars.length;
	
	  while (table.length < char_count) {
	    var table_len = table.length;
	    for (var i = 0; i < code_len; i++) {
	      var c = chars.charAt(i);
	      if (!table.includes(c)) {
	        if (table.length >= char_count) break;
	        table.push(c);
	      }
	
	      for (var j = 0; j < table_len; j++) {
	        if (table.length >= char_count) break;
	        var t = '' + c + table[j];
	        if (!table.includes(t)) {
	          table.push(t);
	        }
	      }
	    }
	  }
	
	  for (var _i = 0; _i < table.length; _i++) {
	    table[_i] = sep + table[_i];
	  }
	};
	
	makeTable();
	
	var clean = function clean(t) {
	  return t.replace(/[^\u200b\u200c\u200d]/gi, '');
	};
	var addPunctuations = function addPunctuations(t, lang) {
	  var a = t.split('');
	  var idx = 0;
	  lang = lang || '喵';
	  while (idx < a.length) {
	    var c = a[idx].charCodeAt(0);
	    var delta = c % 60 + 1;
	    idx += delta;
	    if (!a[idx]) {
	      break;
	    }
	
	    a[idx] += lang;
	    var mod = idx % 32;
	    switch (mod) {
	      case 0:
	      case 1:
	      case 2:
	      case 3:
	        a[idx] += '，';
	        break;
	      case 7:
	        a[idx] += '。';
	        break;
	      case 8:
	        a[idx] += '？';
	        break;
	      case 9:
	        a[idx] += '！';
	        break;
	      case 10:
	        a[idx] += '～';
	        break;
	    }
	  }
	
	  t = lang + a.join('') + lang + '。';
	
	  return t;
	};
	exports.default = {
	  encode: function encode(text, lang) {
	    var str = _cryptoJs2.default.enc.Utf8.parse(text);
	    var t = _cryptoJs2.default.enc.Base64.stringify(str);
	    var len = t.length;
	    var arr = [];
	    for (var i = 0; i < len; i++) {
	      var c = t.charAt(i);
	      var n = b64.indexOf(c);
	
	      arr.push(table[n]);
	    }
	    var data = arr.join('');
	    return addPunctuations(data, lang);
	  },
	  decode: function decode(t) {
	    t = clean(t);
	
	    for (var idx = table.length; idx >= 0; idx--) {
	      var reg = new RegExp(table[idx], 'ig');
	      t = t.replace(reg, b64.charAt(idx));
	    }
	    var words = _cryptoJs2.default.enc.Base64.parse(t);
	    t = words.toString(_cryptoJs2.default.enc.Utf8);
	    return t;
	  }
	};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    convert: convertRmb,
	    rmbToNum: rmbToNum
	};
	
	function convertRmb(money) {
	    var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖");
	    var cnIntRadice = new Array("", "拾", "佰", "仟");
	    var cnIntUnits = new Array("", "万", "亿", "兆");
	    var cnDecUnits = new Array("角", "分", "毫", "厘");
	    var cnInteger = "整";
	    var cnIntLast = "元";
	    var maxNum = 999999999999999.9999;
	
	    var IntegerNum;
	    var DecimalNum;
	    var ChineseStr = "";
	    var parts;
	    if (money == "") {
	        return "";
	    }
	    money = parseFloat(money);
	    if (money >= maxNum) {
	        $.alert('超出最大处理数字');
	        return "";
	    }
	    if (money == 0) {
	        ChineseStr = cnNums[0] + cnIntLast;
	        return ChineseStr;
	    }
	    money = money.toString();
	    if (money.indexOf(".") == -1) {
	        IntegerNum = money;
	        DecimalNum = '';
	    } else {
	        parts = money.split(".");
	        IntegerNum = parts[0];
	        DecimalNum = parts[1].substr(0, 4);
	    }
	    if (parseInt(IntegerNum, 10) > 0) {
	        var zeroCount = 0;
	        var IntLen = IntegerNum.length;
	        for (var i = 0; i < IntLen; i++) {
	            var n = IntegerNum.substr(i, 1);
	            var p = IntLen - i - 1;
	            var q = p / 4;
	            var m = p % 4;
	            if (n == "0") {
	                zeroCount++;
	            } else {
	                if (zeroCount > 0) {
	                    ChineseStr += cnNums[0];
	                }
	                zeroCount = 0;
	                ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
	            }
	            if (m == 0 && zeroCount < 4) {
	                ChineseStr += cnIntUnits[q];
	            }
	        }
	        ChineseStr += cnIntLast;
	    }
	    if (DecimalNum != '') {
	        var decLen = DecimalNum.length;
	        for (i = 0; i < decLen; i++) {
	            n = DecimalNum.substr(i, 1);
	            if (n != '0') {
	                ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
	            }
	        }
	    }
	    if (ChineseStr == '') {
	        ChineseStr += cnNums[0] + cnIntLast;
	    }
	    if (ChineseStr.charAt(ChineseStr.length - 1) == cnIntLast) {
	        ChineseStr += cnInteger;
	    }
	    return ChineseStr;
	}
	function rmbToNum(rmb) {
	    var num = "";
	    rmb = rmb.indexOf('元') == rmb.length - 1 ? rmb + '整' : rmb;
	    rmb = rmb.replace('圆', '元');
	    var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖");
	    for (var i = 0; i < rmb.length; i++) {
	        if (cnNums.indexOf(rmb[i]) > -1) {
	            num = num + cnNums.indexOf(rmb[i]);
	        }
	        if (rmb.indexOf('拾元') > -1 && rmb[i] == '元') {
	            num = num + '0';
	        }
	        if (rmb[i] == '元' && rmb.indexOf('整') == -1 && rmb.indexOf('元') != rmb.length - 1 && num.indexOf('.') == -1) {
	            num = num + '.';
	        }
	    }
	    return num;
	}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(25);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toMarkdown = function toMarkdown(string) {
	    var ELEMENTS = [{
	        patterns: 'p', replacement: function replacement(str, attrs, innerHTML) {
	            return innerHTML ? '\n\n' + innerHTML + '\n' : '';
	        }
	    }, { patterns: 'br', type: 'void', replacement: '\n' }, {
	        patterns: 'h([1-6])',
	        replacement: function replacement(str, hLevel, attrs, innerHTML) {
	            var hPrefix = '';for (var i = 0; i < hLevel; i++) {
	                hPrefix += '#';
	            }return '\n\n' + hPrefix + ' ' + innerHTML + '\n';
	        }
	    }, { patterns: 'hr', type: 'void', replacement: '\n\n* * *\n' }, {
	        patterns: 'a',
	        replacement: function replacement(str, attrs, innerHTML) {
	            var href = attrs.match(attrRegExp('href')),
	                title = attrs.match(attrRegExp('title'));return href ? '[' + innerHTML + ']' + '(' + href[1] + (title && title[1] ? ' "' + title[1] + '"' : '') + ')' : str;
	        }
	    }, {
	        patterns: ['b', 'strong'],
	        replacement: function replacement(str, attrs, innerHTML) {
	            return innerHTML ? '**' + innerHTML + '**' : '';
	        }
	    }, {
	        patterns: ['i', 'em'], replacement: function replacement(str, attrs, innerHTML) {
	            return innerHTML ? '_' + innerHTML + '_' : '';
	        }
	    }, {
	        patterns: 'code',
	        replacement: function replacement(str, attrs, innerHTML) {
	            return innerHTML ? '`' + innerHTML + '`' : '';
	        }
	    }, {
	        patterns: 'img', type: 'void', replacement: function replacement(str, attrs, innerHTML) {
	            var src = attrs.match(attrRegExp('src')),
	                alt = attrs.match(attrRegExp('alt')),
	                title = attrs.match(attrRegExp('title'));return '![' + (alt && alt[1] ? alt[1] : '') + ']' + '(' + src[1] + (title && title[1] ? ' "' + title[1] + '"' : '') + ')';
	        }
	    }];
	    for (var i = 0, len = ELEMENTS.length; i < len; i++) {
	        if (typeof ELEMENTS[i].patterns === 'string') {
	            string = replaceEls(string, { tag: ELEMENTS[i].patterns, replacement: ELEMENTS[i].replacement, type: ELEMENTS[i].type });
	        } else {
	            for (var j = 0, pLen = ELEMENTS[i].patterns.length; j < pLen; j++) {
	                string = replaceEls(string, { tag: ELEMENTS[i].patterns[j], replacement: ELEMENTS[i].replacement, type: ELEMENTS[i].type });
	            }
	        }
	    }
	    function replaceEls(html, elProperties) {
	        var pattern = elProperties.type === 'void' ? '<' + elProperties.tag + '\\b([^>]*)\\/?>' : '<' + elProperties.tag + '\\b([^>]*)>([\\s\\S]*?)<\\/' + elProperties.tag + '>',
	            regex = new RegExp(pattern, 'gi'),
	            markdown = '';if (typeof elProperties.replacement === 'string') {
	            markdown = html.replace(regex, elProperties.replacement);
	        } else {
	            markdown = html.replace(regex, function (str, p1, p2, p3) {
	                return elProperties.replacement.call(this, str, p1, p2, p3);
	            });
	        }return markdown;
	    }
	    function attrRegExp(attr) {
	        return new RegExp(attr + '\\s*=\\s*["\']?([^"\']*)["\']?', 'i');
	    }
	    string = string.replace(/<pre\b[^>]*>`([\s\S]*)`<\/pre>/gi, function (str, innerHTML) {
	        innerHTML = innerHTML.replace(/^\t+/g, '  ');innerHTML = innerHTML.replace(/\n/g, '\n    ');return '\n\n    ' + innerHTML + '\n';
	    });
	    string = string.replace(/^(\s{0,3}\d+)\. /g, '$1\\. ');
	    var noChildrenRegex = /<(ul|ol)\b[^>]*>(?:(?!<ul|<ol)[\s\S])*?<\/\1>/gi;
	    while (string.match(noChildrenRegex)) {
	        string = string.replace(noChildrenRegex, function (str) {
	            return replaceLists(str);
	        });
	    }
	    function replaceLists(html) {
	        html = html.replace(/<(ul|ol)\b[^>]*>([\s\S]*?)<\/\1>/gi, function (str, listType, innerHTML) {
	            var lis = innerHTML.split('</li>');lis.splice(lis.length - 1, 1);
	            for (i = 0, len = lis.length; i < len; i++) {
	                if (lis[i]) {
	                    var prefix = listType === 'ol' ? i + 1 + ".  " : "*   ";lis[i] = lis[i].replace(/\s*<li[^>]*>([\s\S]*)/i, function (str, innerHTML) {
	                        innerHTML = innerHTML.replace(/^\s+/, '');innerHTML = innerHTML.replace(/\n\n/g, '\n\n    ');innerHTML = innerHTML.replace(/\n([ ]*)+(\*|\d+\.) /g, '\n$1    $2 ');return prefix + innerHTML;
	                    });
	                }
	            }
	            return lis.join('\n');
	        });
	        return '\n\n' + html.replace(/[ \t]+\n|\s+$/g, '');
	    }
	    var deepest = /<blockquote\b[^>]*>((?:(?!<blockquote)[\s\S])*?)<\/blockquote>/gi;
	    while (string.match(deepest)) {
	        string = string.replace(deepest, function (str) {
	            return replaceBlockquotes(str);
	        });
	    }function replaceBlockquotes(html) {
	        html = html.replace(/<blockquote\b[^>]*>([\s\S]*?)<\/blockquote>/gi, function (str, inner) {
	            inner = inner.replace(/^\s+|\s+$/g, '');
	            inner = cleanUp(inner);inner = inner.replace(/^/gm, '> ');
	            inner = inner.replace(/^(>([ \t]{2,}>)+)/gm, '> >');
	            return inner;
	        });
	        return html;
	    }
	    function cleanUp(string) {
	        string = string.replace(/^[\t\r\n]+|[\t\r\n]+$/g, '');
	        string = string.replace(/\n\s+\n/g, '\n\n');
	        string = string.replace(/\n{3,}/g, '\n\n');
	        return string;
	    }
	    return cleanUp(string);
	};
	if (( false ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') {
	    exports.toMarkdown = toMarkdown;
	}

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(102)
	
	/* template */
	var __vue_template__ = __webpack_require__(320)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(103)
	
	/* template */
	var __vue_template__ = __webpack_require__(307)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(104)
	
	/* template */
	var __vue_template__ = __webpack_require__(313)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(105)
	
	/* template */
	var __vue_template__ = __webpack_require__(327)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(106)
	
	/* template */
	var __vue_template__ = __webpack_require__(334)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(228)
	
	/* script */
	__vue_exports__ = __webpack_require__(108)
	
	/* template */
	var __vue_template__ = __webpack_require__(331)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(109)
	
	/* template */
	var __vue_template__ = __webpack_require__(329)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(110)
	
	/* template */
	var __vue_template__ = __webpack_require__(308)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(225)
	
	/* script */
	__vue_exports__ = __webpack_require__(111)
	
	/* template */
	var __vue_template__ = __webpack_require__(317)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(112)
	
	/* template */
	var __vue_template__ = __webpack_require__(325)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(113)
	
	/* template */
	var __vue_template__ = __webpack_require__(335)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(114)
	
	/* template */
	var __vue_template__ = __webpack_require__(321)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(115)
	
	/* template */
	var __vue_template__ = __webpack_require__(326)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(229)
	
	/* template */
	var __vue_template__ = __webpack_require__(332)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(226)
	
	/* script */
	__vue_exports__ = __webpack_require__(116)
	
	/* template */
	var __vue_template__ = __webpack_require__(319)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(117)
	
	/* template */
	var __vue_template__ = __webpack_require__(311)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(118)
	
	/* template */
	var __vue_template__ = __webpack_require__(318)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(224)
	
	/* script */
	__vue_exports__ = __webpack_require__(119)
	
	/* template */
	var __vue_template__ = __webpack_require__(315)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3296945e"
	
	module.exports = __vue_exports__


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(120)
	
	/* template */
	var __vue_template__ = __webpack_require__(328)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(121)
	
	/* template */
	var __vue_template__ = __webpack_require__(306)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(222)
	
	/* script */
	__vue_exports__ = __webpack_require__(122)
	
	/* template */
	var __vue_template__ = __webpack_require__(309)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-162badb4"
	
	module.exports = __vue_exports__


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(123)
	
	/* template */
	var __vue_template__ = __webpack_require__(330)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(124)
	
	/* template */
	var __vue_template__ = __webpack_require__(324)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(125)
	
	/* template */
	var __vue_template__ = __webpack_require__(314)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(126)
	
	/* template */
	var __vue_template__ = __webpack_require__(323)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(223)
	
	/* script */
	__vue_exports__ = __webpack_require__(127)
	
	/* template */
	var __vue_template__ = __webpack_require__(312)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(227)
	
	/* script */
	__vue_exports__ = __webpack_require__(128)
	
	/* template */
	var __vue_template__ = __webpack_require__(322)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(129)
	
	/* template */
	var __vue_template__ = __webpack_require__(316)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(130)
	
	/* template */
	var __vue_template__ = __webpack_require__(333)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.tabItems
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "main"
	    },
	    slot: "main"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.beforeTxt),
	      expression: "beforeTxt"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "placeholder": "人类语言"
	    },
	    domProps: {
	      "value": (_vm.beforeTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.beforeTxt = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('div', {
	    staticStyle: {
	      "border": "0",
	      "width": "30%",
	      "display": "inline-block",
	      "line-height": "38px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.replaceTxt),
	      expression: "replaceTxt"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "placeholder": "非人语"
	    },
	    domProps: {
	      "value": (_vm.replaceTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.replaceTxt = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.convertGossip()
	      }
	    }
	  }, [_c('span', [_vm._v("流言蜚语\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.convertMan()
	      }
	    }
	  }, [_c('span', [_vm._v("人言可畏\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.afterTxt),
	      expression: "afterTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "非人类语言"
	    },
	    domProps: {
	      "value": (_vm.afterTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.afterTxt = $event.target.value
	      }
	    }
	  })]), _vm._v("\n    参考项目：https://github.com/miao-lang/miao-lang\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "layui-btn",
	    on: {
	      "click": _vm.clickHandler
	    }
	  }, [_vm._t("default"), _vm._v(" "), (_vm.icon) ? _c('v-icon', {
	    attrs: {
	      "icon": _vm.icon
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.typeOne) ? _c('div', {
	    staticClass: "layui-layer layui-layer-loading  layer-anim",
	    staticStyle: {
	      "top": "50%",
	      "left": "50%",
	      "margin-top": "-12px",
	      "margin-left": "-30px",
	      "z-index": "19891027"
	    },
	    attrs: {
	      "id": "layui-loading-1",
	      "type": "loading",
	      "times": "1",
	      "showtime": "0",
	      "contype": "string"
	    }
	  }, [_c('div', {
	    staticClass: "layui-layer-content layui-layer-loading0"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "layui-layer-setwin"
	  })]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home-block"
	  }, _vm._l((_vm.menus), function(item, index) {
	    return _c('blockquote', {
	      key: index,
	      staticClass: "layui-elem-quote layui-quote-nm left-block",
	      on: {
	        "click": function($event) {
	          _vm.$options.filters.openRoute(item.menuUrl)
	        }
	      }
	    }, [(item.menuUrl && item.menuUrl.indexOf('/') == 0) ? _c('router-link', {
	      attrs: {
	        "to": {
	          path: item.menuUrl
	        }
	      }
	    }, [_vm._v(_vm._s(item.menuName))]) : _c('a', {
	      attrs: {
	        "href": item.menuUrl,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(item.menuName))])], 1)
	  }))
	},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('i', {
	    staticClass: "layui-icon"
	  }, [(_vm.icon == 'up') ? [_vm._v("\n    \n  ")] : _vm._e(), _vm._v(" "), (_vm.icon == 'down') ? [_vm._v("\n    \n  ")] : _vm._e(), _vm._v(" "), (_vm.icon == 'delete') ? [_vm._v("\n    \n  ")] : _vm._e(), _vm._v(" "), (_vm.icon == 'right') ? [_vm._v("\n    \n  ")] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.tabItems
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "main"
	    },
	    slot: "main"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.beforeTxt),
	      expression: "model.beforeTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "转换前字符串..."
	    },
	    domProps: {
	      "value": (_vm.model.beforeTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "beforeTxt", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-radio', {
	    attrs: {
	      "value": _vm.model.currentType,
	      "optionVals": _vm.codeTypes
	    },
	    on: {
	      "input": _vm.currentHandler
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.encode(_vm.model.currentType)
	      }
	    }
	  }, [_c('span', [_c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")]), _vm._v("编码")])]), _vm._v(" "), _c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.decode(_vm.model.currentType)
	      }
	    }
	  }, [_c('span', [_vm._v("解码\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.afterTxt),
	      expression: "model.afterTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "转换后字符串..."
	    },
	    domProps: {
	      "value": (_vm.model.afterTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "afterTxt", $event.target.value)
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.items
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "common"
	    },
	    slot: "common"
	  }, [_c('div', {
	    staticClass: "layui-form-item"
	  }, [_c('label', {
	    staticClass: "layui-form-label"
	  }, [_vm._v("输入框")]), _vm._v(" "), _c('div', {
	    staticClass: "layui-input-block"
	  }, [_c('input', {
	    staticClass: "layui-input",
	    attrs: {
	      "type": "text",
	      "name": "title",
	      "required": "",
	      "lay-verify": "required",
	      "placeholder": "请输入标题",
	      "autocomplete": "off"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "menus"
	    },
	    slot: "menus"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-select', {
	    attrs: {
	      "options": _vm.menuOptions,
	      "hasNull": true
	    },
	    on: {
	      "change": _vm.changeSelect
	    },
	    model: {
	      value: (_vm.selectValue),
	      callback: function($$v) {
	        _vm.selectValue = $$v
	      },
	      expression: "selectValue"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectMenu.menuName),
	      expression: "selectMenu.menuName"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "菜单名称"
	    },
	    domProps: {
	      "value": (_vm.selectMenu.menuName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.selectMenu, "menuName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectMenu.menuUrl),
	      expression: "selectMenu.menuUrl"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "菜单链接"
	    },
	    domProps: {
	      "value": (_vm.selectMenu.menuUrl)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.selectMenu, "menuUrl", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectMenu.sort),
	      expression: "selectMenu.sort"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "type": "number",
	      "placeholder": "菜单排序"
	    },
	    domProps: {
	      "value": (_vm.selectMenu.sort)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.selectMenu, "sort", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_vm._v("\n      显示状态\n      "), _c('v-checkbox', {
	    attrs: {
	      "text": "首页隐藏"
	    },
	    model: {
	      value: (_vm.selectMenu.indexHide),
	      callback: function($$v) {
	        _vm.$set(_vm.selectMenu, "indexHide", $$v)
	      },
	      expression: "selectMenu.indexHide"
	    }
	  }), _vm._v(" "), _c('v-checkbox', {
	    attrs: {
	      "text": "导航隐藏"
	    },
	    model: {
	      value: (_vm.selectMenu.navHide),
	      callback: function($$v) {
	        _vm.$set(_vm.selectMenu, "navHide", $$v)
	      },
	      expression: "selectMenu.navHide"
	    }
	  })], 1), _vm._v(" "), (_vm.selectValue) ? _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    on: {
	      "click": _vm.saveSetting
	    }
	  }, [_vm._v("保存菜单")]), _vm._v(" "), (_vm.selectMenu.custom) ? _c('v-button', {
	    on: {
	      "click": _vm.removeCustomMenu
	    }
	  }, [_vm._v("删除")]) : _vm._e()], 1) : _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    on: {
	      "click": _vm.addCustomMenu
	    }
	  }, [_vm._v("添加菜单")])], 1)]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "fanyi"
	    },
	    slot: "fanyi"
	  }, [_c('fieldset', {
	    staticClass: "layui-elem-field"
	  }, [_c('legend', [_vm._v("百度")]), _vm._v(" "), _c('div', {
	    staticClass: "layui-field-box"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fanyiConfig.baiduAppId),
	      expression: "fanyiConfig.baiduAppId"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "百度APPID"
	    },
	    domProps: {
	      "value": (_vm.fanyiConfig.baiduAppId)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fanyiConfig, "baiduAppId", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fanyiConfig.baiduAppKey),
	      expression: "fanyiConfig.baiduAppKey"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "百度密钥"
	    },
	    domProps: {
	      "value": (_vm.fanyiConfig.baiduAppKey)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fanyiConfig, "baiduAppKey", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "layui-elem-field"
	  }, [_c('legend', [_vm._v("有道")]), _vm._v(" "), _c('div', {
	    staticClass: "layui-field-box"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fanyiConfig.youdaoAppId),
	      expression: "fanyiConfig.youdaoAppId"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "有道应用ID"
	    },
	    domProps: {
	      "value": (_vm.fanyiConfig.youdaoAppId)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fanyiConfig, "youdaoAppId", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fanyiConfig.youdaoAppKey),
	      expression: "fanyiConfig.youdaoAppKey"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "有道密钥"
	    },
	    domProps: {
	      "value": (_vm.fanyiConfig.youdaoAppKey)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.fanyiConfig, "youdaoAppKey", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    on: {
	      "click": _vm.saveFanyiConfig
	    }
	  }, [_vm._v("保存配置")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "layui-unselect layui-form-checkbox",
	    class: {
	      'layui-form-checked': _vm.currentValue
	    },
	    on: {
	      "click": _vm.changeCheckd
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v("")])])
	},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports={render:function (){
	var this$1 = this;
	var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.tabItems
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "generatecode"
	    },
	    slot: "generatecode"
	  }, [_c('div', {
	    staticClass: "layui-form-item"
	  }, [_c('v-button', {
	    on: {
	      "click": _vm.addItem
	    }
	  }, [_c('span', [_vm._v("添加新项\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v("")])])]), _vm._v(" "), _c('v-button', {
	    on: {
	      "click": _vm.saveData
	    }
	  }, [_c('span', [_vm._v("保存数据\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-button', {
	    attrs: {
	      "icon": _vm.showMoreBtn ? 'right' : 'down'
	    },
	    on: {
	      "click": function (s) { return _vm.showMoreBtn = !_vm.showMoreBtn; }
	    }
	  }, [_vm._v("更多")])], 1), _vm._v(" "), (_vm.showMoreBtn) ? _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('label', {
	    staticStyle: {
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "float": "left",
	      "line-height": "38px"
	    }
	  }, [_vm._v("背景色:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.bgcolor),
	      expression: "form.bgcolor"
	    }],
	    staticClass: "layui-input",
	    staticStyle: {
	      "width": "100px",
	      "padding-left": "0"
	    },
	    attrs: {
	      "type": "color"
	    },
	    domProps: {
	      "value": (_vm.form.bgcolor)
	    },
	    on: {
	      "change": _vm.convert,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "bgcolor", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    staticStyle: {
	      "float": "left",
	      "margin-left": "5px",
	      "margin-right": "5px"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "float": "left",
	      "line-height": "38px"
	    }
	  }, [_vm._v("填充色：")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.color),
	      expression: "form.color"
	    }],
	    staticClass: "layui-input",
	    staticStyle: {
	      "width": "100px",
	      "padding-left": "0"
	    },
	    attrs: {
	      "type": "color"
	    },
	    domProps: {
	      "value": (_vm.form.color)
	    },
	    on: {
	      "change": _vm.convert,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.form, "color", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.showMoreBtn) ? _c('div', {
	    staticClass: "layui-form-item "
	  }, [_c('v-upload', {
	    staticStyle: {
	      "height": "30px"
	    },
	    attrs: {
	      "beforeShow": true,
	      "uploadApi": '/static/data/editorUpload.json'
	    },
	    on: {
	      "before": _vm.addImage
	    }
	  }, [_c('v-button', {
	    staticStyle: {
	      "position": "absolute"
	    }
	  }, [_c('span', [_vm._v("上传 Logo\n            "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v("")])])])], 1), _vm._v(" "), (_vm.form.logoImg) ? _c('img', {
	    staticStyle: {
	      "width": "40px",
	      "height": "40px",
	      "margin-left": "5px"
	    },
	    attrs: {
	      "src": _vm.form.logoImg
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.form.logoImg) ? _c('button', {
	    staticClass: "layui-btn layui-btn-danger layui-btn-mini",
	    on: {
	      "click": function (e) {
	        this$1.form.logoImg = null;
	        this$1.convert()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v("")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataList), function(item, index) {
	    return _c('fieldset', {
	      key: 't_' + index,
	      staticClass: "layui-elem-field"
	    }, [_c('legend', [_vm._v("第" + _vm._s(_vm.dataList.length - index) + "项\n        "), _c('button', {
	      staticClass: "layui-btn layui-btn-danger layui-btn-mini",
	      on: {
	        "click": function($event) {
	          _vm.delItem(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "layui-icon"
	    }, [_vm._v("")])])]), _vm._v(" "), _c('div', {
	      staticClass: "layui-field-box"
	    }, [_c('v-input-txt', {
	      attrs: {
	        "label": "文本/Url",
	        "placeholder": "将要生成二维码的文本或链接",
	        "rows": 2
	      },
	      on: {
	        "change": _vm.convert
	      },
	      model: {
	        value: (item.text),
	        callback: function($$v) {
	          _vm.$set(item, "text", $$v)
	        },
	        expression: "item.text"
	      }
	    }), _vm._v(" "), _c('img', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (item.text),
	        expression: "item.text"
	      }],
	      attrs: {
	        "src": item.src,
	        "id": 'custom-img-' + (_vm.dataList.length - index)
	      }
	    })], 1)])
	  })], 2), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "decode"
	    },
	    slot: "decode"
	  }, [_c('div', {
	    attrs: {
	      "id": "qrfile",
	      "qrCanvas": "qr-canvas",
	      "qrResult": "qrcode_content"
	    }
	  }, [_c('div', {
	    attrs: {
	      "title": "把您的二维码拖到这儿，即可识别内容"
	    }
	  }, [_c('div', {
	    staticClass: "browser",
	    attrs: {
	      "id": "canvas_ext_div"
	    }
	  }, [_c('label', {
	    staticStyle: {
	      "height": "30px",
	      "line-height": "30px"
	    }
	  }, [_c('span', [_vm._v("选择要识别的二维码，粘贴剪切板或者拖动图片到面板中")]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "file",
	      "name": "files",
	      "accept": "image/*",
	      "id": "ewmfile",
	      "title": "选择文件后自动识别"
	    }
	  })])])]), _vm._v(" "), _c('canvas', {
	    staticStyle: {
	      "border": "1px solid #CCC"
	    },
	    attrs: {
	      "id": "qr-canvas"
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("识别结果：\n      "), _c('p', {
	    staticStyle: {
	      "border": "1px solid #ccc",
	      "line-height": "30px",
	      "word-break": "break-all"
	    },
	    attrs: {
	      "id": "qrcode_content"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.tabItems
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "fanyi"
	    },
	    slot: "fanyi"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.beforeTxt),
	      expression: "model.beforeTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "请输入转换前字符串... 粘贴/空格后自动翻译"
	    },
	    domProps: {
	      "value": (_vm.model.beforeTxt)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key, " ")) { return null; }
	        return _vm.fanyi($event)
	      },
	      "keyup": function($event) {
	        if (!('button' in $event) && $event.keyCode !== 86) { return null; }
	        if (!$event.ctrlKey) { return null; }
	        return _vm.fanyi($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "beforeTxt", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-select', {
	    attrs: {
	      "options": _vm.typeOptions
	    },
	    on: {
	      "change": _vm.fanyi
	    },
	    model: {
	      value: (_vm.currentOption),
	      callback: function($$v) {
	        _vm.currentOption = $$v
	      },
	      expression: "currentOption"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.afterTxt),
	      expression: "model.afterTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "rows": "13",
	      "placeholder": "翻译结果..."
	    },
	    domProps: {
	      "value": (_vm.model.afterTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "afterTxt", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [(_vm.model.jsonData) ? _c('pre', {
	    staticClass: "layui-code",
	    domProps: {
	      "innerHTML": _vm._s(_vm.model.jsonData)
	    }
	  }) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "layui-tab-brief",
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    }
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text",
	    staticStyle: {
	      "padding": "5px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "height": "30px",
	      "line-height": "30px",
	      "float": "left"
	    }
	  }, [_vm._v("粘贴图片或上传图片即可")]), _vm._v(" "), _c('v-upload', {
	    staticStyle: {
	      "height": "30px"
	    },
	    attrs: {
	      "beforeShow": true,
	      "uploadApi": '/static/data/editorUpload.json'
	    },
	    on: {
	      "before": _vm.toBase64
	    }
	  }, [_c('v-button', {
	    staticStyle: {
	      "position": "absolute"
	    }
	  }, [_vm._v("\n          选择图片\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.previewBase64),
	      expression: "previewBase64"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "Base64图片"
	    },
	    domProps: {
	      "value": (_vm.previewBase64)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.previewBase64 = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [(_vm.previewBase64) ? _c('img', {
	    staticStyle: {
	      "width": "200px"
	    },
	    attrs: {
	      "src": _vm.previewBase64
	    }
	  }) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ympager",
	    attrs: {
	      "id": _vm.pagerId
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "layui-tab-brief",
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    }
	  }, [_c('ul', {
	    staticClass: "layui-tab-title site-demo-title",
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }, [_c('li', {
	    class: {
	      'layui-this': _vm.tabType == 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.switchTab(1)
	      }
	    }
	  }, [_vm._v("可逆加密/解密")]), _vm._v(" "), _c('li', {
	    class: {
	      'layui-this': _vm.tabType == 2
	    },
	    on: {
	      "click": function($event) {
	        _vm.switchTab(2)
	      }
	    }
	  }, [_vm._v("散列/哈希")])]), _vm._v(" "), (_vm.tabType == 1) ? _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    }
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.beforeTxt),
	      expression: "model.beforeTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "加密/解密字符串..."
	    },
	    domProps: {
	      "value": (_vm.model.beforeTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "beforeTxt", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-radio', {
	    attrs: {
	      "value": _vm.model.currentType,
	      "optionVals": _vm.encryptTypes
	    },
	    on: {
	      "input": _vm.currentHandler
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.pwdTxt),
	      expression: "model.pwdTxt"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "密匙"
	    },
	    domProps: {
	      "value": (_vm.model.pwdTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "pwdTxt", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.encrypt(_vm.model.currentType)
	      }
	    }
	  }, [_c('span', [_c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")]), _vm._v("加密")])]), _vm._v(" "), _c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.decrypt(_vm.model.currentType)
	      }
	    }
	  }, [_c('span', [_vm._v("解密\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.afterTxt),
	      expression: "model.afterTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "加密后字符串..."
	    },
	    domProps: {
	      "value": (_vm.model.afterTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "afterTxt", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.tabType == 2) ? _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    }
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.beforeTxt),
	      expression: "model.beforeTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "加密/解密字符串..."
	    },
	    domProps: {
	      "value": (_vm.model.beforeTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "beforeTxt", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-radio', {
	    attrs: {
	      "value": _vm.model.currentType,
	      "optionVals": _vm.hashTypes
	    },
	    on: {
	      "input": _vm.currentHandler
	    }
	  })], 1), _vm._v(" "), (_vm.hashPwdTypes.indexOf(_vm.model.currentType) > -1) ? _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.pwdTxt),
	      expression: "model.pwdTxt"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "密匙"
	    },
	    domProps: {
	      "value": (_vm.model.pwdTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "pwdTxt", $event.target.value)
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.hashEncrypt(_vm.model.currentType)
	      }
	    }
	  }, [_c('span', [_c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")]), _vm._v("加密")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.afterTxt),
	      expression: "model.afterTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "加密后字符串..."
	    },
	    domProps: {
	      "value": (_vm.model.afterTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "afterTxt", $event.target.value)
	      }
	    }
	  })])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "uploadLayer"
	  }, [_vm._t("default", [(_vm.displayImg) ? _c('img', {
	    staticClass: "uploadimg",
	    attrs: {
	      "src": _vm.displayImg
	    }
	  }) : _c('img', {
	    staticClass: "uploadimg",
	    attrs: {
	      "src": __webpack_require__(274)
	    }
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "layui-upload-file",
	    attrs: {
	      "type": "file",
	      "accept": "image/*",
	      "name": "file",
	      "id": _vm.uploadId
	    }
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('v-select', {
	    attrs: {
	      "options": _vm.menuOptions
	    },
	    on: {
	      "change": _vm.changeMenu
	    },
	    model: {
	      value: (_vm.currentOption),
	      callback: function($$v) {
	        _vm.currentOption = $$v
	      },
	      expression: "currentOption"
	    }
	  }), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "layui-unselect layui-form-switch",
	    class: {
	      'layui-form-onswitch': _vm.currentValue
	    },
	    on: {
	      "click": _vm.changeSwitch
	    }
	  }, [_c('i')])
	},staticRenderFns: []}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.tabItems
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "main"
	    },
	    slot: "main"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.beforeTxt),
	      expression: "beforeTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "待处理字符串...",
	      "rows": "10"
	    },
	    domProps: {
	      "value": (_vm.beforeTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.beforeTxt = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.addRule()
	      }
	    }
	  }, [_c('span', [_c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")]), _vm._v("添加规则")])])], 1), _vm._v(" "), _vm._l((_vm.ruleA), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "layui-form-item layui-form-text "
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.ruleA[index]),
	        expression: "ruleA[index]"
	      }],
	      staticClass: "layui-input",
	      staticStyle: {
	        "width": "40%",
	        "float": "left"
	      },
	      attrs: {
	        "placeholder": "替换字符串/规则"
	      },
	      domProps: {
	        "value": (_vm.ruleA[index])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.ruleA, index, $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "height": "38px",
	        "line-height": "38px",
	        "float": "left"
	      }
	    }, [_vm._v("→_→")]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.ruleB[index]),
	        expression: "ruleB[index]"
	      }],
	      staticClass: "layui-input",
	      staticStyle: {
	        "width": "40%",
	        "float": "left"
	      },
	      attrs: {
	        "type": "text",
	        "placeholder": "替换字符串"
	      },
	      domProps: {
	        "value": (_vm.ruleB[index])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.ruleB, index, $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('i', {
	      staticClass: "layui-icon editicon",
	      on: {
	        "click": function($event) {
	          _vm.removeRule(index)
	        }
	      }
	    }, [_vm._v("")])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.replaceTxt()
	      }
	    }
	  }, [_c('span', [_vm._v("替换\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.saveData()
	      }
	    }
	  }, [_c('span', [_vm._v("保存数据\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.afterTxt),
	      expression: "afterTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "处理后字符串...",
	      "rows": "10"
	    },
	    domProps: {
	      "value": (_vm.afterTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.afterTxt = $event.target.value
	      }
	    }
	  })])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.tabItems
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "main"
	    },
	    slot: "main"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.beforeTxt),
	      expression: "beforeTxt"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "placeholder": "数字..."
	    },
	    domProps: {
	      "value": (_vm.beforeTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.beforeTxt = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.convertDxRmb()
	      }
	    }
	  }, [_c('span', [_vm._v("大写\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.convertXxRmb()
	      }
	    }
	  }, [_c('span', [_vm._v("小写\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.afterTxt),
	      expression: "afterTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "中文..."
	    },
	    domProps: {
	      "value": (_vm.afterTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.afterTxt = $event.target.value
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.items
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "toHtml"
	    },
	    slot: "toHtml"
	  }, [_c('v-input-txt', {
	    attrs: {
	      "label": "Markdown",
	      "placeholder": "MarkDown"
	    },
	    model: {
	      value: (_vm.mdText2),
	      callback: function($$v) {
	        _vm.mdText2 = $$v
	      },
	      expression: "mdText2"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    attrs: {
	      "icon": "down"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toHtml()
	      }
	    }
	  }, [_vm._v("转为Html")])], 1), _vm._v(" "), _c('v-input-txt', {
	    attrs: {
	      "label": "Html",
	      "value": _vm.htmlText2,
	      "placeholder": "Html"
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "site-tips"
	  }, [_vm._v("预览")]), _vm._v(" "), _c('div', {
	    staticClass: " artcontent",
	    domProps: {
	      "innerHTML": _vm._s(_vm.htmlText2)
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "toMarkdown"
	    },
	    slot: "toMarkdown"
	  }, [_c('v-input-txt', {
	    attrs: {
	      "label": "HTML",
	      "placeholder": "HTML"
	    },
	    model: {
	      value: (_vm.htmlText1),
	      callback: function($$v) {
	        _vm.htmlText1 = $$v
	      },
	      expression: "htmlText1"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    attrs: {
	      "icon": "down"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toMarkdown()
	      }
	    }
	  }, [_vm._v("转为Markdown")])], 1), _vm._v(" "), _c('v-input-txt', {
	    attrs: {
	      "label": "MarkDown",
	      "value": _vm.mdText1,
	      "placeholder": "MarkDown"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._l((_vm.options), function(item, index) {
	    return (_vm.options != null) ? _c('div', {
	      key: index,
	      staticClass: "layui-unselect layui-form-radio",
	      class: {
	        'layui-form-radioed': _vm.currentValue.Value == item.Value
	      },
	      on: {
	        "click": function($event) {
	          _vm.changeRadio(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "layui-anim layui-icon",
	      class: {
	        'layui-anim-scaleSpring': _vm.currentValue.Value == item.Value
	      }
	    }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.Text))])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.optionVals), function(item, index) {
	    return (_vm.optionVals != null) ? _c('div', {
	      key: index,
	      staticClass: "layui-unselect layui-form-radio",
	      class: {
	        'layui-form-radioed': _vm.currentVal == item
	      },
	      on: {
	        "click": function($event) {
	          _vm.changeRadio(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "layui-anim layui-icon",
	      class: {
	        'layui-anim-scaleSpring': _vm.currentVal == item
	      }
	    }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item))])]) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.defClass
	  }, [_c('ul', {
	    staticClass: "layui-tab-title site-demo-title",
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }, _vm._l((_vm.items), function(item, index) {
	    return _c('li', {
	      key: index,
	      class: {
	        'layui-this': _vm.currentTab == item.Name
	      },
	      attrs: {
	        "tabCode": item.Name
	      },
	      domProps: {
	        "textContent": _vm._s(item.Title)
	      },
	      on: {
	        "click": function($event) {
	          _vm.current(item)
	        }
	      }
	    })
	  })), _vm._v(" "), _c('div', {
	    staticClass: "layui-tab-content"
	  }, _vm._l((_vm.items), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "layui-tab-item",
	      class: {
	        'layui-show': _vm.currentTab == item.Name
	      }
	    }, [_vm._t(item.Name)], 2)
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "type": "text",
	      "id": _vm.dateId
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "click": function($event) {
	        _vm.changeDate(_vm.dateId)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.tabItems
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "htpasswd"
	    },
	    slot: "htpasswd"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.userName),
	      expression: "model.userName"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "placeholder": "用户名"
	    },
	    domProps: {
	      "value": (_vm.model.userName)
	    },
	    on: {
	      "keyup": _vm.genHtpasswd,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "userName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.userPwd),
	      expression: "model.userPwd"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "placeholder": "密码"
	    },
	    domProps: {
	      "value": (_vm.model.userPwd)
	    },
	    on: {
	      "keyup": _vm.genHtpasswd,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "userPwd", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-radio', {
	    attrs: {
	      "options": _vm.htpasswdOptions,
	      "optionsVal": _vm.htpasswdOptions.map(function (s) { return s.Value; })
	    },
	    model: {
	      value: (_vm.currentHtpasswdType),
	      callback: function($$v) {
	        _vm.currentHtpasswdType = $$v
	      },
	      expression: "currentHtpasswdType"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.afterTxt),
	      expression: "model.afterTxt"
	    }],
	    staticClass: "layui-textarea ",
	    attrs: {
	      "rows": "3",
	      "placeholder": "生成结果..."
	    },
	    domProps: {
	      "value": (_vm.model.afterTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "afterTxt", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "well"
	  }, [_vm._v("\n        参考：http://tool.oschina.net/htpasswd\n        "), _c('h4', [_vm._v("什么是 htpasswd ?")]), _vm._v(" "), _c('p', [_vm._v("htpasswd 是开源 http 服务器 "), _c('a', {
	    attrs: {
	      "href": "http://www.oschina.net/p/apache+http+server",
	      "target": "_blank"
	    }
	  }, [_vm._v("apache httpd")]), _vm._v("\n          的一个命令工具，用于生成 http 基本认证的密码文件。")]), _vm._v(" "), _c('h4', [_vm._v("加密方式有什么区别？")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("MD5:")]), _vm._v("使用MD5加密密码。在Windows, Netware 和TPF上，这是默认的加密方式。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("crypt:")]), _vm._v("使用crypt()加密密码。在除了Windows, Netware和TPF的平台上，这是默认的。 虽然它在所有平台上可以为htpasswd所支持， 但是在Windows,\n          Netware和TPF上不能为httpd服务器所支持。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("SHA:")]), _vm._v("使用SHA加密密码。 它是为了方便转入或移植到使用LDAP Directory Interchange Format (ldif)的Netscape而设计的。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("plain:")]), _vm._v("不加密，使用纯文本的密码。虽然在所有平台上 htpasswd 都可以建立这样的密码， 但是httpd后台只在Windows, Netware和TPF上支持纯文本的密码。\n        ")])])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "sitepwd"
	    },
	    slot: "sitepwd"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.domainName),
	      expression: "model.domainName"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "placeholder": "网站根域名"
	    },
	    domProps: {
	      "value": (_vm.model.domainName)
	    },
	    on: {
	      "keyup": _vm.genSitePwd,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "domainName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.domainKey),
	      expression: "model.domainKey"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "placeholder": "网站用户名/Key"
	    },
	    domProps: {
	      "value": (_vm.model.domainKey)
	    },
	    on: {
	      "keyup": _vm.genSitePwd,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "domainKey", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('v-button', {
	    attrs: {
	      "icon": "down"
	    },
	    on: {
	      "click": _vm.genSitePwd
	    }
	  }, [_vm._v("生成密码")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.genPwdResult),
	      expression: "model.genPwdResult"
	    }],
	    staticClass: "layui-textarea ",
	    attrs: {
	      "rows": "3",
	      "placeholder": "生成密码..."
	    },
	    domProps: {
	      "value": (_vm.model.genPwdResult)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "genPwdResult", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("\n      浏览器访问地址："), _c('a', {
	    attrs: {
	      "href": "https://metools.js.org/#/genpwd",
	      "target": "_blank"
	    }
	  }, [_vm._v("https://metools.js.org/#/genpwd")])])])])
	},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": _vm.layerId
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.tabItems
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "main"
	    },
	    slot: "main"
	  }, [_c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.beforeTxt),
	      expression: "beforeTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "压缩后的JSON",
	      "wrap": "off"
	    },
	    domProps: {
	      "value": (_vm.beforeTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.beforeTxt = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('div', {
	    staticStyle: {
	      "border": "0",
	      "width": "30%",
	      "display": "inline-block",
	      "line-height": "38px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.replaceTxt),
	      expression: "replaceTxt"
	    }],
	    staticClass: "layui-input",
	    attrs: {
	      "placeholder": "缩进",
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.replaceTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.replaceTxt = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.convertFormatJson()
	      }
	    }
	  }, [_c('span', [_vm._v("格式化\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-button', {
	    on: {
	      "click": function($event) {
	        _vm.convertMiniJson()
	      }
	    }
	  }, [_c('span', [_vm._v("压缩\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "layui-form-item layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.afterTxt),
	      expression: "afterTxt"
	    }],
	    staticClass: "layui-textarea",
	    attrs: {
	      "placeholder": "格式化后端JSON",
	      "rows": "13",
	      "wrap": "off"
	    },
	    domProps: {
	      "value": (_vm.afterTxt)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.afterTxt = $event.target.value
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "layui-form-item custom-input-txt layui-form-text"
	  }, [_c('textarea', {
	    directives: [{
	      name: "keydown-tab",
	      rawName: "v-keydown-tab"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "layui-textarea",
	    class: _vm.areaClass,
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "rows": _vm.rows
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "keyup": function (e) { return _vm.$emit('change', e); },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "ym-table table-hover"
	  }, [_vm._t("thead"), _vm._v(" "), _vm._t("tbody")], 2)
	},staticRenderFns: []}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-tab', {
	    attrs: {
	      "items": _vm.tabItems
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "twostepvalidation"
	    },
	    slot: "twostepvalidation"
	  }, [_c('div', {
	    staticClass: "layui-form-item"
	  }, [_c('v-button', {
	    on: {
	      "click": _vm.addItem
	    }
	  }, [_c('span', [_vm._v("添加新项\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v("")])])]), _vm._v(" "), _c('v-button', {
	    on: {
	      "click": _vm.saveData
	    }
	  }, [_c('span', [_vm._v("保存数据\n          "), _c('i', {
	    staticClass: "layui-icon"
	  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _vm._l((_vm.dataList), function(item, index) {
	    return _c('fieldset', {
	      key: 't_' + index,
	      staticClass: "layui-elem-field"
	    }, [_c('legend', [_vm._v("\n        第" + _vm._s(_vm.dataList.length - index) + "项\n        "), _c('button', {
	      staticClass: "layui-btn layui-btn-danger layui-btn-mini",
	      on: {
	        "click": function($event) {
	          _vm.delItem(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "layui-icon"
	    }, [_vm._v("")])])]), _vm._v(" "), _c('div', {
	      staticClass: "layui-field-box"
	    }, [_c('div', {
	      staticClass: "layui-form-item"
	    }, [_c('label', {
	      staticClass: "layui-form-label"
	    }, [_vm._v("网站名称")]), _vm._v(" "), _c('div', {
	      staticClass: "layui-input-block"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.title),
	        expression: "item.title"
	      }],
	      staticClass: "layui-input",
	      attrs: {
	        "placeholder": "网站名称"
	      },
	      domProps: {
	        "value": (item.title)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "title", $event.target.value)
	        }
	      }
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "layui-form-item"
	    }, [_c('label', {
	      staticClass: "layui-form-label"
	    }, [_vm._v("绑定密钥")]), _vm._v(" "), _c('div', {
	      staticClass: "layui-input-block"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.text),
	        expression: "item.text"
	      }],
	      staticClass: "layui-input",
	      attrs: {
	        "placeholder": "双重验证绑定密钥"
	      },
	      domProps: {
	        "value": (item.text)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "text", $event.target.value)
	        }
	      }
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "layui-form-item"
	    }, [_c('div', {
	      staticClass: "layui-input-block"
	    }, [_c('v-button', {
	      attrs: {
	        "id": item.text
	      },
	      on: {
	        "click": function($event) {
	          _vm.genCode(item)
	        }
	      }
	    }, [_c('span', [_vm._v("生成验证码\n                "), _c('i', {
	      staticClass: "layui-icon"
	    }, [_vm._v("ဂ")])])])], 1)]), _vm._v(" "), (item.code) ? _c('div', {
	      staticClass: "layui-form-item"
	    }, [_c('label', {
	      staticClass: "layui-form-label"
	    }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
	      staticClass: "layui-input-block"
	    }, [_c('blockquote', {
	      staticClass: "layui-elem-quote"
	    }, [_vm._v("\n              " + _vm._s(item.code) + "\n              "), _c('button', {
	      staticClass: "layui-btn layui-btn-sm btn-copy",
	      attrs: {
	        "data-clipboard-text": item.code
	      }
	    }, [_vm._v("\n                复制\n              ")])])])]) : _vm._e()])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "well"
	  }, [_c('p', [_vm._v("\n        可用于谷歌验证等支持 TOTP 算法的二步验证 算法，结合\n        thirty-two，jssha生成\n      ")]), _vm._v(" "), _c('p', [_vm._v("参考：https://github.com/wuyanxin/totp.js")])])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "layui-textarea layui-hide",
	    attrs: {
	      "id": _vm.editorId
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "custom-select-single layui-unselect layui-form-select",
	    class: {
	      'layui-form-selected': _vm.selectShow
	    }
	  }, [_c('div', {
	    staticClass: "layui-select-title"
	  }, [_c('input', {
	    staticClass: "layui-input layui-unselect",
	    attrs: {
	      "type": "text",
	      "placeholder": "--------请选择--------",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.currentValue.Text
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSelect($event)
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "layui-edge",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSelect($event)
	      }
	    }
	  })]), _vm._v(" "), _c('dl', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.selectShow),
	      expression: "selectShow"
	    }],
	    staticClass: "layui-anim layui-anim-upbit"
	  }, _vm._l((_vm.currentOptions), function(item, index) {
	    return _c('dd', {
	      key: index,
	      class: {
	        'layui-this': _vm.currentValue.Value == item.Value
	      },
	      attrs: {
	        "value": "item.Value"
	      },
	      on: {
	        "click": function($event) {
	          _vm.currentSelect(item)
	        }
	      }
	    }, [_vm._v(_vm._s(item.Text))])
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./encode.vue": 292,
		"./encrypt.vue": 293,
		"./fanyi.vue": 294,
		"./genpwd.vue": 295,
		"./gossip.vue": 296,
		"./home.vue": 297,
		"./jsonformat.vue": 298,
		"./mdconvert.vue": 299,
		"./qrcode.vue": 300,
		"./rmbconvert.vue": 301,
		"./setting.vue": 302,
		"./strsplit.vue": 303,
		"./tobase64.vue": 304,
		"./twostepvalidation.vue": 305
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 336;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.c1678618546109fc0af3.js